(function() {
    /* =========================================================================
       全局图片链接池
       ========================================================================= */
    const ICON_EDIT = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/0C84B350-DED1-426D-A1BB-D2414933654E.png?v=1776992156";
    const ICON_CONFIRM = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/D5B7934F-8A71-45DD-85C1-CC43A9D42913.png?v=1776992156";
    const IMG_EMPTY_STATE = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/lQLPJxtEOGR6BMnNA-jNB9CwQO86fx9Ic7YJxNkCoQYrAA_2000_1000.png?v=1777269166";
    const IMG_FIXED_WIRING = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/RKIT400ASR-R40-2560Wh-1220P2-US.jpg?v=1776237126&width=400"; 
    
    const IMG_RV_SUV      = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/8BDB6F9C-1C49-4F13-9A2E-8239B99D8E04.png?v=1776937526"; 
    const IMG_RV_CLASS_B  = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/lQLPJwEWJzndSr3NAZDNAZCw1a_W2to9UDcJv_p-z9nMAA_400_400.png?v=1776937526"; 
    const IMG_RV_CLASS_C  = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/825666d7f95e8bf490348d852f382898.png?v=1776937526"; 
    const IMG_RV_TRAILER  = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/lQLPJwk45Wp0A73NAZDNAZCwTv4INsSaMZwJv_mfLHzxAA_400_400.png?v=1776937526"; 

    const IMG_MAR_FISHING = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/lQLPJwI5MRKBD_3NAZDNAZCwl3j_5rNwHSAJv_uIfpNLAA_400_400.png?v=1776937526"; 
    const IMG_MAR_SAIL    = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/lQLPJxC37gnACT3NAZDNAZCw35pU5sod5MEJv_fmyFdVAA_400_400.png?v=1776937526"; 
    const IMG_MAR_YACHT   = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/lQLPKdaMD_Rte93NAZDNAZCwNki8xlXPUGcJv_1Wt5vrAA_400_400.png?v=1776937526"; 

    const IMG_TH_CABIN    = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/lQLPJx6aPEbOJd3NAZDNAZCwfUBSvqHBUCwJv_b08PhEAA_400_400.png?v=1776937526"; 
    const IMG_TH_OFFGRID  = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/lQLPJxGilFj14z3NAZDNAZCwDarIWBQNE4UJwAi4nuebAA_400_400.png?v=1776937526"; 
    const IMG_TH_WORKSHOP = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/lQLPJwapJooO8F3NAZDNAZCwJt0F_4zAtUMJwAbcVr9CAA_400_400.png?v=1776937526"; 

    const ICON_MARINE_RADIO = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/19e6f134b67e19ea37814dab4632a2c3.png?v=1777269504";
    const ICON_BOAT_LIGHT = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/be0e1377beced0d5c037738d8cf2c6c2.png?v=1777269504";
    const ICON_NAV = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/924b15bbbd9e6cda793a3e80cfa9fe30.png?v=1777269503";
    const ICON_JACKS = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/4f678be41ebcc3455b250d0852c9a011.png?v=1777269503";
    const ICON_WELDER = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/b401322f272a2939910e8e27024db39d.png?v=1777269503";
    const ICON_HEAT_GUN = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/4710d591c2c0a39de23b19d9a47bcdc6.png?v=1777269504";
    const ICON_DRILL = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/555d7b1c42eeb68bad0c79e44d6a4a03.png?v=1777269503";
    const ICON_FAN_NEW = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/d7d64201a2608a78ee94649999627285.png?v=1777269503";
    const ICON_LIVEWELL = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/pump.png?v=1777269504";
    const ICON_CHARGE = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/ac33883cc0f121bc5379a6b202e65143.png?v=1777269504";
    const ICON_SAW = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/e4ddb60de1cf75dc59116e82f8aab50b.png?v=1777269504";
    const ICON_NETWORK = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/683ea1162da44c29748424195fbea1fe.png?v=1777269504";
    const ICON_COMPRESSOR = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/3317c1ea5d23cb9bf4097b224f30c7a6.png?v=1777269504";
    const ICON_ICEMAKER = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/89338c05a35362c9da77d2b28bd6bbb6.png?v=1777269504";

    const ICON_FRIDGE = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/f5094a89c4ecf911e1308dda591ebc51.png?v=1776923415";
    const ICON_COOK = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/981fad5f1dc53eec00c80855748dff57.png?v=1776923415";
    const ICON_TV = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/d6c3d5c8d50b8442e364032451f864a2.png?v=1776923415";
    const ICON_AC = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/b81c97bfdd0c7bed2a1dd4fda8c1dda3.png?v=1776923415";
    const ICON_HEATER = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/0702eee5dda81128a58d35b27a63c3ae.png?v=1776923415";
    const ICON_DEVICE = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/07f01b41cc119791d9294c24cd1052ca.png?v=1776923415";
    const ICON_PUMP = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/1412d40de3d88addc365a5544c1453eb.png?v=1776923415";
    const ICON_FISH = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/dc984894b5bbaa7068ca596ac4a2d10f.png?v=1776923415";
    const ICON_MICROWAVE = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/786bd313f034e1be03dee2b1f37c52b8.png?v=1776923415";
    const ICON_WASH = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/ccca0bebaac43027d821462d7d2e3307.png?v=1776923415";
    const ICON_LIGHT = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/4070071b8dbee6a586c1c3edfb6cd07c.png?v=1776923415";
    const ICON_URL = "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/3736c65b123c17205c6fdde2eb1ac3c8.svg?v=1776915064";

    /* =========================================================================
       全局商品数据库 
       ========================================================================= */
       const productDB = {
        "KIT-SF-RV-1.28": { id: "KIT-SF-RV-1.28", title: "ShadowFlux™ RV Solution (1.28kWh)", price: "$1,089.99", "sku": "RKIT200ASR-R20-1280Wh-1220P2", variant_id: "45229360545907", url: "https://www.renogy.com/products/shadowflux-n-type-rv-solution?variant=43945415344243", pic: "https://www.renogy.com/cdn/shop/files/1_01.jpg?v=1776237126&width=1125" },
        "KIT-SF-RV-2.56": { id: "KIT-SF-RV-2.56", title: "ShadowFlux™ RV Solution (2.56kWh)", price: "$2,189.99", "sku": "RKIT400ASR-R40-2560Wh-1220P2", variant_id: "45229360513139", url: "https://www.renogy.com/products/shadowflux-n-type-rv-solution?variant=44039569211507", pic: "https://www.renogy.com/cdn/shop/files/RKIT400ASR-R40-2560Wh-1220P2-US.jpg?v=1776237126&width=1125" },
        "KIT-RV-2.56": { id: "KIT-RV-2.56", title: "RV Solution (2.56kWh)", price: "$2,099.99", "sku": "RNG-RV-2KWH-PRO", variant_id: "43178660823155", url: "https://www.renogy.com/products/renogy-rv-solution?variant=43178660823155", pic: "https://www.renogy.com/cdn/shop/files/2.5_kWh__78511.1751595920.1280.1280.jpg?v=1776308170&width=1125" },
        "KIT-ASR-3.84": { id: "KIT-ASR-3.84", title: "ShadowFlux™ RV Solution (3.84kWh)", price: "$2,749.99", "sku": "RKIT400ASR-D50-3840Wh-1230PU", variant_id: "45229360480371", url: "https://www.renogy.com/products/shadowflux-n-type-rv-solution?variant=43945415377011", pic: "https://www.renogy.com/cdn/shop/files/1_03.jpg?v=1776237126&width=1125" },
        "KIT-RV-5.12": { id: "KIT-RV-5.12", title: "RV Solution (5.12kWh)", price: "$4,099.99", "sku": "RNG-RV-5KWH-PRO", variant_id: "43178660855923", url: "https://www.renogy.com/products/renogy-rv-solution?variant=43178660855923", pic: "https://www.renogy.com/cdn/shop/files/5kwh-G2__49663.1751595920.1280.1280.jpg?v=1776308170&width=1125" },
        "KIT-RV-7.68": { id: "KIT-RV-7.68", title: "RV Solution (7.68kWh)", price: "$3,799.99", "sku": "RNG-RV-7KWH", variant_id: "43178660888691", url: "https://www.renogy.com/products/renogy-rv-solution?variant=43178660888691", pic: "https://www.renogy.com/cdn/shop/files/5kwh-G2-2__47241.1751595920.1280.1280.jpg?v=1776308170&width=1125" },
        "KIT-SAIL-2.56": { id: "KIT-SAIL-2.56", title: "Sailboat Solution (2.56kWh)", price: "$2,699.99", "sku": "RNG-MKIT-2KWH", variant_id: "43178656268403", url: "https://www.renogy.com/products/sailboat-solution?variant=43178656268403", pic: "https://www.renogy.com/cdn/shop/files/2.4__68944.1739244411.1280.1280.jpg?v=1764222204&width=1125" },
        "KIT-SAIL-5.12": { id: "KIT-SAIL-5.12", title: "Sailboat Solution (5.12kWh)", price: "$4,289.99", "sku": "RNG-MKIT-5KWH", variant_id: "43178656301171", url: "https://www.renogy.com/products/sailboat-solution?variant=43178656301171", pic: "https://www.renogy.com/cdn/shop/files/02__09980.1732176473.1280.1280.jpg?v=1764222204&width=1125" },
        "KIT-12V-3.6": { id: "KIT-12V-3.6", title: "400W 12V Complete Solar Panel Kit with 3.6kWh Battery", price: "$2,099.99", "sku": "RKIT400BD-R40D4-AGM3-P3", variant_id: "43178651091059", url: "https://www.renogy.com/products/renogy-400w-complete-kit-for-workshop-shed", pic: "https://www.renogy.com/cdn/shop/files/RKIT400BD-R40D4-AGM3-P3-2.jpg?v=1766569910&width=1125" },
        "KIT-48V-9.6-LI": { id: "KIT-48V-9.6-LI", title: "Cabin Solution (1200W | 10.24kWh)", price: "$4,999.99", "sku": "RKIT1200CB-C43D4-A24", variant_id: "44799019352179", url: "https://www.renogy.com/products/renogy-1-2kw-essential-kit", pic: "https://www.renogy.com/cdn/shop/files/RKIT1200CB-C43D4-A24-20000.jpg?v=1780043481&width=1517" },
        "KIT-48V-19.2": { id: "KIT-48V-19.2", title: "Cabin Solution (2560W | 20.48kWh)", price: "$8,449.99", "sku": "RKIT2500CB-C43D8-A28", variant_id: "43178724589683", url: "https://www.renogy.com/products/renogy-2-5kw-essential-plus-kit", pic: "https://www.renogy.com/cdn/shop/files/2500W-2605290000.jpg?v=1780043481&width=1517" },
        "KIT-WS-5.12": { id: "KIT-WS-5.12", title: "Workshop Solution (400W | 5.12kWh)", price: "$2,999.99", "sku": "RNG-WSKIT-5KWH-PRO", variant_id: "43178660954227", url: "https://www.renogy.com/products/workshop-solution", pic: "https://www.renogy.com/cdn/shop/files/RNG-WSKIT-5KWH-PRO-2.jpg?v=1776749939&width=1125" },
        "RSP120DC-ASR": { id: "RSP120DC-ASR", title: "120W ShadowFlux Solar Panel", price: "$129.99", "sku": "RSP120DC-ASR", variant_id: "43244586860659", url: "https://www.renogy.com/products/renogy-200w-shadowflux-anti-shading-n-type-solar-panel?variant=43244586860659", pic: "https://www.renogy.com/cdn/shop/files/rsp120dc-asr_4.jpg?v=1776239519&width=1517" },
        "RSP200DC-ASR": { id: "RSP200DC-ASR", title: "200W ShadowFlux Solar Panel", price: "$239.99", "sku": "RSP200DC-ASR", variant_id: "43178668818547", url: "https://www.renogy.com/products/renogy-200w-shadowflux-anti-shading-n-type-solar-panel", pic: "https://www.renogy.com/cdn/shop/files/1-3_best_seller.jpg?v=1776239519&width=1125" },
        "RSP100DC": { id: "RSP100DC", title: "N-Type 100W Solar Panel", price: "$109.99", "sku": "RSP100DC", variant_id: "43232667795571", url: "https://www.renogy.com/products/renogy-n-type-solar-panel?variant=43232667795571", pic: "https://www.renogy.com/cdn/shop/files/RSP100DC-CA.jpg?v=1776240144&width=160" },
        "RSP200DC": { id: "RSP200DC", title: "N-Type 200W Solar Panel", price: "$179.99", "sku": "RSP200DC", variant_id: "43178667999347", url: "https://www.renogy.com/products/renogy-n-type-solar-panel?variant=43178667999347", pic: "https://www.renogy.com/cdn/shop/files/175W.jpg?v=1776240144&width=1500" },
        "RSP320DC-BKX2": { id: "RSP320DC-BKX2", title: "2PCS 320W N-Type Solar Panel", price: "$599.99", "sku": "RSP320DC-BKx2", variant_id: "43212843122803", url: "https://www.renogy.com/products/renogy-n-type-320-watt-monocrystalline-solar-panel?variant=43212843122803", pic: "https://www.renogy.com/cdn/shop/files/320DC__63423.1753179842.1280.1280.png?v=1776240286&width=1125" },
        "RSP590DCT-144X2": { id: "RSP590DCT-144X2", title: "2PCS 590W N-Type Bifacial Solar Panel", price: "$989.99", "sku": "RSP590DCT-144x2", variant_id: "43178666000499", url: "https://www.renogy.com/products/renogy-bifacial-590-watt-n-type-monocrystalline-solar-panel?variant=43178666000499", pic: "https://www.renogy.com/cdn/shop/files/01__04843.1751961378.1280.1280.jpg?v=1776240743&width=1125" },
        "RSP100DL-36": { id: "RSP100DL-36", title: "100W Flexible Solar Panel", price: "$139.99", "sku": "RSP100DL-36", variant_id: "43178715644019", url: "https://www.renogy.com/products/100-watt-12-volt-black-division-lightweight-monocrystalline-solar-panel", pic: "https://www.renogy.com/cdn/shop/files/RSP100DL-36__70595.1725257243.1280.1280.jpg?v=1764839516&width=1517" },
        "RSP200DB-72": { id: "RSP200DB-72", title: "200W Flexible Solar Panel", price: "$309.99", "sku": "RSP200DB-72", variant_id: "44275369672819", url: "https://www.renogy.com/products/200-watt-12-volt-flexible-monocrystalline-solar-panel?variant=44275369672819", pic: "https://www.renogy.com/cdn/shop/files/01_67c5e0fb-9b1d-480f-99c5-fdd72a0ae803.jpg?v=1770356769&width=1125" },
        "RBT12200LFP-BT": { id: "RBT12200LFP-BT", title: "12V 200Ah Smart Lithium Iron Phosphate Battery", price: "$939.99", "sku": "RBT12200LFP-BT", variant_id: "43747614163059", url: "https://www.renogy.com/products/12v-200ah-pro-smart-lithium-iron-phosphate-battery-w-bluetooth-self-heating-function?variant=43747614163059", pic: "https://www.renogy.com/cdn/shop/files/RBT12200LFP-BT-_01__05081.1750411627.1280.1280.jpg?v=1776395956&width=1517" },
        "RBT12200LFP-M": { id: "RBT12200LFP-M", title: "Mini Size 12V 200Ah LiFePO4 Battery", price: "$653.99", "sku": "RBT12200LFP-M", variant_id: "43178668621939", url: "https://www.renogy.com/products/core-mini-12-8v-200ah-lifepo4-battery-w-low-temperature-protection?variant=43178668621939", pic: "https://www.renogy.com/cdn/shop/files/1-1__08849.1751961224.1280.1280.jpg?v=1776309507&width=1125" },
        "RBT12300LFP-M": { id: "RBT12300LFP-M", title: "Mini Size 12V 300Ah LiFePO4 Battery", price: "$879.99", "sku": "RBT12300LFP-M", variant_id: "43178669015155", url: "https://www.renogy.com/products/core-mini-12-8v-300ah-lithium-iron-phosphate-battery-w-low-temperature-protection?variant=43178669015155", pic: "https://www.renogy.com/cdn/shop/files/RBT12300LFP-M-_02jpg__44397.1741082619.1280.1280.jpg?v=1776236663&width=1125" },
        "RBT12300LFPSH": { id: "RBT12300LFPSH", title: "12V 300Ah Deep Cycle Lithium Iron Phosphate Battery", price: "$1,088.99", "sku": "RBT12300LFPSH", variant_id: "43178721247347", url: "https://www.renogy.com/products/12v-300ah-core-series-deep-cycle-lithium-iron-phosphate-battery-w-self-heating?variant=43178721247347", pic: "https://www.renogy.com/cdn/shop/files/300core__09072.1750411659.1280.1280.jpg?v=1776239283&width=1517" },
        "RBT12100LFP-BT": { id: "RBT12100LFP-BT", title: "12V 100Ah Smart Lithium Iron Phosphate Battery", price: "$629.99", "sku": "RBT12100LFP-BT", variant_id: "43178724917363", url: "https://www.renogy.com/products/12v-100ah-pro-smart-lithium-iron-phosphate-battery-w-bluetooth-self-heating-function?variant=43178724917363", pic: "https://www.renogy.com/cdn/shop/files/100pro__09243.1750411063.1280.1280.jpg?v=1773300366&width=1517" },
        "RNG-BATT-AGM12-200": { id: "RNG-BATT-AGM12-200", title: "12V 200Ah Deep Cycle AGM Battery", price: "$395.99", "sku": "RNG-BATT-AGM12-200", variant_id: "43756629295219", url: "https://www.renogy.com/products/deep-cycle-agm-battery-12-volt-200ah?variant=43756629295219", pic: "https://www.renogy.com/cdn/shop/files/01_1__06904.1750404959.1280.1280.jpg?v=1764835983&width=1517" },
        "RNG-CTRL-RVR40": { id: "RNG-CTRL-RVR40", title: "Rover Li 40A MPPT Solar Charge Controller", price: "$205.99", "sku": "RNG-CTRL-RVR40", variant_id: "43938600878195", url: "https://www.renogy.com/products/rover-li-40-amp-mppt-solar-charge-controller?variant=43938600878195", pic: "https://www.renogy.com/cdn/shop/files/RNG-CTRL-RVR40-1.jpg?v=1772784945&width=1517" },
        "RNG-CTRL-RVR60": { id: "RNG-CTRL-RVR60", title: "Rover 60A MPPT Solar Charge Controller", price: "$399.99", "sku": "RNG-CTRL-RVR60", variant_id: "43178705617011", url: "https://www.renogy.com/products/rover-60-amp-mppt-solar-charge-controller?variant=43178705617011", pic: "https://www.renogy.com/cdn/shop/files/RVR-60A-_01__35555.1751964074.1280.1280.jpg?v=1775035844&width=1125" },
        "RNG-CTRL-RVR100": { id: "RNG-CTRL-RVR100", title: "Rover 100A MPPT Solar Charge Controller", price: "$701.99", "sku": "RNG-CTRL-RVR100", variant_id: "43178693099635", url: "https://www.renogy.com/products/rover-100-amp-mppt-solar-charge-controller?variant=43178693099635", pic: "https://www.renogy.com/cdn/shop/files/59673_source_1702887223.png?v=1764220024&width=1125" },
        "INV-1000W-12V": { id: "INV-1000W-12V", title: "1000W 12V Pure Sine Wave Inverter", price: "$175.99", "sku": "RNG-INVT-1000-12V-P2", variant_id: "44034633039987", url: "https://www.renogy.com/products/3000w-12v-pure-sine-wave-inverter?variant=44034633039987", pic: "https://www.renogy.com/cdn/shop/files/RNG-INVT-1000-12V-P2_d87b0159-62e8-4ebf-8e18-9728943d0b20.jpg?v=1773300179&width=1125" },
        "INV-2000W-12V": { id: "INV-2000W-12V", title: "2000W 12V Pure Sine Wave Inverter", price: "$285.99", "sku": "RNG-INVT-2000-12V-P2", variant_id: "44034632974451", url: "https://www.renogy.com/products/3000w-12v-pure-sine-wave-inverter?variant=44034632974451", pic: "https://www.renogy.com/cdn/shop/files/RNG-INVT-2000-12V-P2.png?v=1773300179&width=1125" },
        "INV-3000W-12V": { id: "INV-3000W-12V", title: "3000W 12V Pure Sine Wave Inverter", price: "$285.99", "sku": "RNG-INVT-3000-12V-P2", variant_id: "43178695098483", url: "https://www.renogy.com/products/3000w-12v-pure-sine-wave-inverter?variant=43178695098483", pic: "https://www.renogy.com/cdn/shop/files/RNG-INVT-3000-12V-P2_4079efd1-4c77-40f6-a8ab-5f46ae6b0ca4.jpg?v=1773391215&width=1125" },
        "INV-3500W-48V": { id: "INV-3500W-48V", title: "48V 3500W Pure Sine Wave Solar Inverter Charger", price: "$1,215.99", "sku": "RIV4835PCS-1SS", variant_id: "45368564318323", url: "https://www.renogy.com/products/48v-3500w-pure-sine-wave-solar-inverter-charger", pic: "https://www.renogy.com/cdn/shop/files/01_39734.1724736280.1280.1280.jpg?v=1764218931&width=1125" },
        "RIV1230PU-126": { id: "RIV1230PU-126", title: "12V 3000W Pure Sine Wave Inverter with UPS Transfer Switch", price: "$461.99", "sku": "RIV1230PU-126", variant_id: "44014854635635", url: "https://www.renogy.com/products/puh-12v-3000w-pure-sine-wave-inverter-with-ups-transfer-switch-and-built-in-bluetooth?variant=44014854635635", pic: "https://www.renogy.com/cdn/shop/files/RIV1230PU-126_a7162929-5f54-41a6-b570-65f47d29ebe7.jpg?v=1776262268&width=160" },
        "RIV1230RCL-1SS": { id: "RIV1230RCL-1SS", title: "3000W 12V Inverter Charger", price: "$325.99", "sku": "RIV1230RCL-1SS", variant_id: "43178704339059", url: "https://www.renogy.com/products/rego-12v-3000w-pure-sine-wave-inverter-charger-w-lcd-display?variant=43178704339059", pic: "https://www.renogy.com/cdn/shop/files/RIB1230RCL-0540SR-US.png?v=1774509166&width=160" },
        "RIV4835PCS-1SS": { id: "RIV4835PCS-1SS", title: "48V 3500W Pure Sine Wave Solar Inverter Charger", price: "$1,215.99", "sku": "RIV4835PCS-1SS", variant_id: "45368564318323", url: "https://www.renogy.com/products/48v-3500w-pure-sine-wave-solar-inverter-charger", pic: "https://www.renogy.com/cdn/shop/files/01__39734.1724736280.1280.1280.jpg?v=1764218931&width=1125" },
        "RBC50D1S": { id: "RBC50D1S", title: "12V 50A DC-DC Battery Charger with MPPT", price: "$307.99", "sku": "RBC50D1S", variant_id: "43178701783155", url: "https://www.renogy.com/products/dcc50s-12v-50a-dc-dc-on-board-battery-charger-with-mppt?variant=43178701783155", pic: "https://www.renogy.com/cdn/shop/files/RBC30.jpg?v=1774510555&width=1517" },
        "RKIT-RV-200ASR-D50-3840Wh": { id: "RKIT-RV-200ASR-D50-3840Wh", title: "RV Solution | Go Far 3.8kWh", price: "$2,199.99", "sku": "RKIT-RV-200ASR-D50-3840Wh", variant_id: "44039569211507", url: "https://www.renogy.com/products/shadowflux-n-type-rv-solution", pic: "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/01_f3fbbe3f-e293-4215-a389-46bfe68497ad.jpg?v=1781504167" },
        "RKIT-RV-400ASR-D50-7680Wh": { id: "RKIT-RV-400ASR-D50-7680Wh", title: "RV Solution | Go Further 7.6kWh", price: "$3,279.99", "sku": "RKIT-RV-400ASR-D50-7680Wh", variant_id: "43945415377011", url: "https://www.renogy.com/products/shadowflux-n-type-rv-solution", pic: "https://cdn.shopify.com/s/files/1/0631/0137/0483/files/02_1b9e9f28-c91d-401c-9adb-ebbf316da10e.jpg?v=1781504167" },
        "RIV1220PU-126": { id: "RIV1220PU-126", title: "2000W 12V Pure Sine Wave Inverter with UPS Transfer Switch", price: "$364.99", "sku": "RIV1220PU-126", variant_id: "43178652336243", url: "https://www.renogy.com/products/2000w-12v-pure-sine-wave-inverter-with-ups-transfer-switch-and-built-in-bluetooth", pic: "https://www.renogy.com/cdn/shop/files/RIV1220PU-126_134e2f5d-126d-4276-b068-cfa4cde5622c.png?v=1767753297&width=1125" },
        "KIT-PWR-10.8": { id: "KIT-PWR-10.8", title: "10.8kWh Power Kit | 4*320W Panel, 3000W Inverter", price: "$4,109.99", "sku": "bundle", url: "https://www.renogy.com/products/10-2kwh-solar-kit-4pcs-320w-n-type-panel", pic: "https://www.renogy.com/cdn/shop/files/10.8.jpg?v=1766129175&width=1125" },
        "KIT-PWR-14.4": { id: "KIT-PWR-14.4", title: "14.4kWh Power Kit | 4*590W Panel, 3500W Inverter", price: "$5,299.99", "sku": "bundle", url: "https://www.renogy.com/products/14-4kwh-solar-kit-4pcs-590w-n-type-panel", pic: "https://www.renogy.com/cdn/shop/files/14-4_51266ba5-f066-4b3e-8904-7f94d90e2698.jpg?v=1770281447&width=1125" }
    };

    function applyProductCatalog() {
        const node = document.getElementById('calculator-general-us-catalog');
        if (!node) return;

        let raw = '';
        try {
            raw = JSON.parse(node.textContent || '""');
        } catch (error) {
            console.error('[Calculator-General-US] Product catalog setting could not be read.', error);
            return;
        }
        if (raw == null || String(raw).trim() === '') return;

        let catalog;
        try {
            catalog = JSON.parse(raw);
        } catch (error) {
            console.error('[Calculator-General-US] Product catalog is not valid JSON.', error);
            return;
        }
        if (!catalog || typeof catalog !== 'object' || Array.isArray(catalog)) {
            console.error('[Calculator-General-US] Product catalog must be a JSON object keyed by SKU.');
            return;
        }

        Object.keys(catalog).forEach((sku) => {
            const entry = catalog[sku];
            if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return;
            const current = productDB[sku] || { id: sku, title: sku, price: '$TBD', url: '#', pic: '', variant_id: '' };
            const variantId = String(entry.variant_id || '').trim();
            productDB[sku] = {
                id: sku,
                title: entry.title || current.title,
                price: entry.price || current.price,
                url: entry.url || current.url,
                pic: entry.pic || entry.image || current.pic,
                variant_id: variantId || current.variant_id || ''
            };
        });
    }

    applyProductCatalog();

    const configData = {
        'rv': {
            title: "Choose RV Type",
            subtypes: [
                { id: 'rv-suv', maxWh: 11520, image: IMG_RV_SUV, title: 'Pickup/SUV', appliances: [ 
                    { id: "rv-suv-1", name: "Refrigerator", baseWatts: 50, defaultHours: 24, icon: ICON_FRIDGE }, 
                    { id: "rv-suv-2", name: "Lighting", baseWatts: 20, defaultHours: 4, icon: ICON_LIGHT }, 
                    { id: "rv-suv-3", name: "Water Pump", baseWatts: 40, defaultHours: 1, icon: ICON_PUMP }, 
                    { id: "rv-suv-4", name: "Phone / Laptop", baseWatts: 60, defaultHours: 3, icon: ICON_DEVICE }, 
                    { id: "rv-suv-5", name: "Starlink", baseWatts: 30, defaultHours: 8, icon: ICON_NETWORK }, 
                    { id: "rv-suv-6", name: "Fan", baseWatts: 30, defaultHours: 2, icon: ICON_FAN_NEW }, 
                    { id: "rv-suv-7", name: "TV / Entertainment", baseWatts: 40, defaultHours: 2, icon: ICON_TV }, 
                    { id: "rv-suv-8", name: "Microwave", baseWatts: 800, defaultHours: 0.2, icon: ICON_MICROWAVE }, 
                    { id: "rv-suv-9", name: "Roof Air Conditioner", baseWatts: 800, defaultHours: 1, icon: ICON_AC } 
                ]},
                { id: 'rv-b', maxWh: 11520, image: IMG_RV_CLASS_B, title: 'Class B', appliances: [ 
                    { id: "rv-b-1", name: "Refrigerator", baseWatts: 50, defaultHours: 24, icon: ICON_FRIDGE }, 
                    { id: "rv-b-2", name: "Lighting", baseWatts: 30, defaultHours: 5, icon: ICON_LIGHT }, 
                    { id: "rv-b-3", name: "Water Pump", baseWatts: 60, defaultHours: 1, icon: ICON_PUMP }, 
                    { id: "rv-b-4", name: "Phone / Laptop", baseWatts: 60, defaultHours: 3, icon: ICON_DEVICE }, 
                    { id: "rv-b-5", name: "Starlink", baseWatts: 30, defaultHours: 8, icon: ICON_NETWORK }, 
                    { id: "rv-b-6", name: "Fan", baseWatts: 30, defaultHours: 4, icon: ICON_URL }, 
                    { id: "rv-b-7", name: "TV / Entertainment", baseWatts: 40, defaultHours: 2, icon: ICON_TV }, 
                    { id: "rv-b-8", name: "Microwave", baseWatts: 1000, defaultHours: 0.2, icon: ICON_MICROWAVE }, 
                    { id: "rv-b-9", name: "Roof Air Conditioner", baseWatts: 1000, defaultHours: 1, icon: ICON_AC } 
                ]},
                { id: 'rv-c', maxWh: 11520, image: IMG_RV_CLASS_C, title: 'Class C', appliances: [ 
                    { id: "rv-c-1", name: "Refrigerator", baseWatts: 60, defaultHours: 24, icon: ICON_FRIDGE }, 
                    { id: "rv-c-2", name: "Lighting", baseWatts: 50, defaultHours: 6, icon: ICON_LIGHT }, 
                    { id: "rv-c-3", name: "Water Pump", baseWatts: 80, defaultHours: 1.5, icon: ICON_PUMP }, 
                    { id: "rv-c-4", name: "Phone / Laptop", baseWatts: 80, defaultHours: 4, icon: ICON_DEVICE }, 
                    { id: "rv-c-5", name: "Starlink", baseWatts: 60, defaultHours: 12, icon: ICON_NETWORK }, 
                    { id: "rv-c-6", name: "Fan", baseWatts: 40, defaultHours: 5, icon: ICON_FAN_NEW }, 
                    { id: "rv-c-7", name: "TV / Entertainment", baseWatts: 80, defaultHours: 3, icon: ICON_TV }, 
                    { id: "rv-c-8", name: "Microwave", baseWatts: 1000, defaultHours: 0.5, icon: ICON_MICROWAVE }, 
                    { id: "rv-c-9", name: "Roof Air Conditioner", baseWatts: 1500, defaultHours: 1, icon: ICON_AC } 
                ]},
                { id: 'rv-t', maxWh: 20480, image: IMG_RV_TRAILER, title: 'Trailer', appliances: [ 
                    { id: "rv-t-1", name: "Refrigerator", baseWatts: 60, defaultHours: 24, icon: ICON_FRIDGE }, 
                    { id: "rv-t-2", name: "Lighting", baseWatts: 50, defaultHours: 6, icon: ICON_LIGHT }, 
                    { id: "rv-t-3", name: "Water Pump", baseWatts: 80, defaultHours: 1.5, icon: ICON_PUMP }, 
                    { id: "rv-t-4", name: "Phone / Laptop", baseWatts: 80, defaultHours: 4, icon: ICON_DEVICE }, 
                    { id: "rv-t-5", name: "Starlink", baseWatts: 60, defaultHours: 12, icon: ICON_NETWORK }, 
                    { id: "rv-t-6", name: "Fan", baseWatts: 40, defaultHours: 6, icon: ICON_FAN_NEW }, 
                    { id: "rv-t-7", name: "TV / Entertainment", baseWatts: 80, defaultHours: 4, icon: ICON_TV }, 
                    { id: "rv-t-8", name: "Microwave", baseWatts: 1000, defaultHours: 0.5, icon: ICON_MICROWAVE }, 
                    { id: "rv-t-9", name: "Roof Air Conditioner", baseWatts: 1500, defaultHours: 1, icon: ICON_AC }, 
                    { id: "rv-t-10", name: "Electric Stabilizer Jacks", baseWatts: 1500, defaultHours: 0.1, icon: ICON_JACKS } 
                ]}
            ]
        },
        'marine': { 
            title: "Choose Boat Type", 
            subtypes: [
                { id: 'marine-f', maxWh: 11520, image: IMG_MAR_FISHING, title: 'Fishing Boat', appliances: [ 
                    { id: "mar-f-1", name: "Fish Finder", baseWatts: 30, defaultHours: 4, icon: ICON_FISH }, 
                    { id: "mar-f-2", name: "Livewell Pump", baseWatts: 50, defaultHours: 4, icon: ICON_LIVEWELL }, 
                    { id: "mar-f-3", name: "Navigation Electronics", baseWatts: 50, defaultHours: 6, icon: ICON_NAV }, 
                    { id: "mar-f-4", name: "Boat Lighting", baseWatts: 80, defaultHours: 5, icon: ICON_BOAT_LIGHT }, 
                    { id: "mar-f-5", name: "Device Charging", baseWatts: 20, defaultHours: 4, icon: ICON_CHARGE }, 
                    { id: "mar-f-6", name: "Marine Radio", baseWatts: 10, defaultHours: 2, icon: ICON_MARINE_RADIO }, 
                    { id: "mar-f-7", name: "Fridge", baseWatts: 50, defaultHours: 8, icon: ICON_FRIDGE } 
                ]},
                { id: 'marine-s', maxWh: 11520, image: IMG_MAR_SAIL, title: 'Sailboat', appliances: [ 
                    { id: "mar-s-1", name: "Navigation Electronics", baseWatts: 50, defaultHours: 10, icon: ICON_NAV }, 
                    { id: "mar-s-2", name: "Boat Lighting", baseWatts: 100, defaultHours: 6, icon: ICON_BOAT_LIGHT }, 
                    { id: "mar-s-3", name: "Device Charging", baseWatts: 60, defaultHours: 6, icon: ICON_CHARGE }, 
                    { id: "mar-s-4", name: "Marine Radio", baseWatts: 10, defaultHours: 4, icon: ICON_MARINE_RADIO }, 
                    { id: "mar-s-5", name: "Fridge", baseWatts: 60, defaultHours: 12, icon: ICON_FRIDGE }, 
                    { id: "mar-s-6", name: "Water Pump", baseWatts: 60, defaultHours: 1, icon: ICON_PUMP }, 
                    { id: "mar-s-7", name: "Fan", baseWatts: 30, defaultHours: 8, icon: ICON_FAN_NEW }, 
                    { id: "mar-s-8", name: "Autopilot / Rudder Servo", baseWatts: 50, defaultHours: 6, icon: ICON_NAV } 
                ]},
                { id: 'marine-y', maxWh: 20480, image: IMG_MAR_YACHT, title: 'Yacht', appliances: [ 
                    { id: "mar-y-1", name: "Navigation Electronics", baseWatts: 100, defaultHours: 8, icon: ICON_NAV }, 
                    { id: "mar-y-2", name: "Boat Lighting", baseWatts: 100, defaultHours: 6, icon: ICON_BOAT_LIGHT }, 
                    { id: "mar-y-3", name: "Device Charging", baseWatts: 60, defaultHours: 6, icon: ICON_CHARGE }, 
                    { id: "mar-y-4", name: "Fridge", baseWatts: 100, defaultHours: 24, icon: ICON_FRIDGE }, 
                    { id: "mar-y-5", name: "Microwave", baseWatts: 800, defaultHours: 0.5, icon: ICON_MICROWAVE }, 
                    { id: "mar-y-6", name: "Air Conditioner", baseWatts: 2000, defaultHours: 1, icon: ICON_AC }, 
                    { id: "mar-y-7", name: "Ice Maker", baseWatts: 300, defaultHours: 1, icon: ICON_ICEMAKER }, 
                    { id: "mar-y-8", name: "Hot Water Heater", baseWatts: 2000, defaultHours: 1, icon: ICON_HEATER }, 
                    { id: "mar-y-9", name: "Entertainment", baseWatts: 100, defaultHours: 2, icon: ICON_TV } 
                ]}
            ] 
        },
        'tiny_house': { 
            title: "Choose Property Type", 
            subtypes: [
                { id: 'th-c', maxWh: 20480, image: IMG_TH_CABIN, title: 'Cabin', appliances: [ 
                    { id: "th-c-1", name: "Mini-Split AC", baseWatts: 800, defaultHours: 1, icon: ICON_AC }, 
                    { id: "th-c-2", name: "Refrigerator", baseWatts: 200, defaultHours: 8, icon: ICON_FRIDGE }, 
                    { id: "th-c-3", name: "Induction Cooktop", baseWatts: 1800, defaultHours: 0.5, icon: ICON_COOK }, 
                    { id: "th-c-4", name: "Starlink", baseWatts: 40, defaultHours: 8, icon: ICON_NETWORK }, 
                    { id: "th-c-5", name: "Phone / Laptop", baseWatts: 60, defaultHours: 4, icon: ICON_DEVICE }, 
                    { id: "th-c-6", name: "Lighting", baseWatts: 40, defaultHours: 5, icon: ICON_LIGHT }, 
                    { id: "th-c-7", name: "Water Pump", baseWatts: 50, defaultHours: 1, icon: ICON_PUMP }, 
                    { id: "th-c-8", name: "Hot Water Heater", baseWatts: 1500, defaultHours: 0.5, icon: ICON_HEATER }, 
                    { id: "th-c-9", name: "TV", baseWatts: 60, defaultHours: 2, icon: ICON_TV } 
                ]},
                { id: 'th-o', maxWh: 20480, image: IMG_TH_OFFGRID, title: 'Full-time Off-grid Home', appliances: [ 
                    { id: "th-o-1", name: "Mini-Split AC", baseWatts: 800, defaultHours: 1, icon: ICON_AC }, 
                    { id: "th-o-2", name: "Refrigerator", baseWatts: 200, defaultHours: 8, icon: ICON_FRIDGE }, 
                    { id: "th-o-3", name: "Induction Cooktop", baseWatts: 1800, defaultHours: 1, icon: ICON_COOK }, 
                    { id: "th-o-4", name: "Microwave", baseWatts: 1000, defaultHours: 0.5, icon: ICON_MICROWAVE }, 
                    { id: "th-o-5", name: "Starlink", baseWatts: 40, defaultHours: 12, icon: ICON_NETWORK }, 
                    { id: "th-o-6", name: "Phone / Laptop", baseWatts: 60, defaultHours: 4, icon: ICON_DEVICE }, 
                    { id: "th-o-7", name: "Lighting", baseWatts: 40, defaultHours: 5, icon: ICON_LIGHT }, 
                    { id: "th-o-8", name: "Water Pump", baseWatts: 50, defaultHours: 1, icon: ICON_PUMP }, 
                    { id: "th-o-9", name: "Hot Water Heater", baseWatts: 1500, defaultHours: 1, icon: ICON_HEATER }, 
                    { id: "th-o-10", name: "TV", baseWatts: 60, defaultHours: 2, icon: ICON_TV }, 
                    { id: "th-o-11", name: "Washing Machine", baseWatts: 800, defaultHours: 1, icon: ICON_WASH } 
                ]},
                { id: 'th-w', maxWh: 20480, image: IMG_TH_WORKSHOP, title: 'Workshop', appliances: [ 
                    { id: "th-w-1", name: "Lighting", baseWatts: 80, defaultHours: 8, icon: ICON_LIGHT }, 
                    { id: "th-w-2", name: "Fan", baseWatts: 100, defaultHours: 8, icon: ICON_FAN_NEW }, 
                    { id: "th-w-3", name: "Fridge", baseWatts: 60, defaultHours: 12, icon: ICON_FRIDGE }, 
                    { id: "th-w-4", name: "Device Charging", baseWatts: 60, defaultHours: 6, icon: ICON_CHARGE }, 
                    { id: "th-w-5", name: "Water Pump", baseWatts: 50, defaultHours: 1, icon: ICON_PUMP }, 
                    { id: "th-w-6", name: "Power Drill", baseWatts: 500, defaultHours: 1, icon: ICON_DRILL }, 
                    { id: "th-w-7", name: "Table Saw", baseWatts: 1000, defaultHours: 1, icon: ICON_SAW }, 
                    { id: "th-w-8", name: "Welder", baseWatts: 1500, defaultHours: 0.5, icon: ICON_WELDER }, 
                    { id: "th-w-9", name: "Air Compressor", baseWatts: 1000, defaultHours: 1, icon: ICON_COMPRESSOR }, 
                    { id: "th-w-10", name: "Heat Gun Iron", baseWatts: 200, defaultHours: 1, icon: ICON_HEAT_GUN } 
                ]}
            ] 
        }
    };

    let totalWh = 0; 
    let peakPowerW = 0; 
    let peakCheckState = {}; 
    let currentRenderedSubType = null; 
    let currentRenderedScenario = null; 
    let customDeviceCount = 1;

    let currentPvOptions = []; 
    let currentPvOptionIndex = 0; 
    let isPvOptionsOpen = false; 
    let latestPlanSnapshot = null;
    let recommendationActionStatusTimer = null;

    // Paid-installation interest widget (recommendation page footer). This is
    // a lightweight market-research prompt only -- there is no install
    // service to book yet, see INSTALL_SURVEY copy below. State resets
    // whenever a brand-new recommendation is calculated (goToStep ->
    // generateRecommendation()) but survives a keepIndex=true re-render
    // (e.g. switching the selected solar panel option), same as
    // currentPvOptionIndex.
    // Single-question survey: 'ask' -> 'done'. There used to be a second
    // "what's the main reason?" step here (INSTALL_SURVEY_REASONS + a
    // 'reason' state) -- removed per request, the survey now only ever asks
    // the one yes/no question.
    let installSurveyState = { step: 'ask', choice: null };

    function translateWiring(w) {
        if(!w) return "";
        return w.replace('2串联2并联', '2 Series 2 Parallel (2S2P)')
                .replace('3串联2并联', '3 Series 2 Parallel (3S2P)')
                .replace('4串联2并联', '4 Series 2 Parallel (4S2P)')
                .replace('2串联4并联', '2 Series 4 Parallel (2S4P)')
                .replace('2串联', '2 Series (2S)')
                .replace('3串联', '3 Series (3S)')
                .replace('4串联', '4 Series (4S)')
                .replace('并联', 'Parallel')
                .replace('串联', 'Series');
    }

    function setCookie(name, value, days) { 
        let d = new Date(); 
        d.setTime(d.getTime() + (days*24*60*60*1000)); 
        document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + d.toUTCString() + ";path=/"; 
    }
    
    function getCookie(name) { 
        let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)")); 
        return matches ? decodeURIComponent(matches[1]) : undefined; 
    }

    function saveStateToCookie() {
        const scenarioEl = document.querySelector('input[name="main_scenario"]:checked');
        const subTypeEl = document.querySelector('input[name="sub_type"]:checked');
        if(!scenarioEl || !subTypeEl) return;
        
        const state = { 
            scenario: scenarioEl.value, 
            subType: subTypeEl.value, 
            appliances: {}, 
            customAppliances: [], 
            peakState: peakCheckState 
        };
        
        document.querySelectorAll('.standard-app-card').forEach(card => {
            const id = card.dataset.id;
            state.appliances[id] = { 
                checked: card.querySelector('.app-check').checked, 
                watts: card.querySelector('.live-watts').value, 
                hours: card.querySelector('.apple-slider').value 
            };
        });
        
        document.querySelectorAll('.custom-app-card').forEach(card => {
            const id = card.dataset.id;
            state.customAppliances.push({ 
                id, 
                name: card.querySelector('.custom-name-text').innerText, 
                watts: card.querySelector('.live-watts').value, 
                hours: card.querySelector('.apple-slider').value 
            });
        });
        
        setCookie('power_config_state', JSON.stringify(state), 7);
    }

    function initFromCookie() {
        const savedStr = getCookie('power_config_state');
        if (savedStr) {
            try {
                const state = JSON.parse(savedStr);
                const sc = document.querySelector(`input[name="main_scenario"][value="${state.scenario}"]`); 
                if(sc) sc.checked = true;
                
                updateSubTypes(); 
                
                const su = document.querySelector(`input[name="sub_type"][value="${state.subType}"]`);
                if(su) {
                    su.checked = true; 
                    renderAppliances(); 
                    
                    if (state.appliances) {
                        for (let id in state.appliances) {
                            const card = document.querySelector(`.standard-app-card[data-id="${id}"]`);
                            if (card) {
                                const st = state.appliances[id];
                                card.querySelector('.app-check').checked = st.checked;
                                if (st.checked) card.classList.add('active');
                                card.querySelector('.live-watts').value = st.watts;
                                const durSlider = card.querySelector('.apple-slider');
                                durSlider.value = st.hours; 
                                durSlider.previousElementSibling.innerText = st.hours + 'h';
                            }
                        }
                    }
                    
                    if (state.customAppliances) {
                        state.customAppliances.forEach(ca => {
                            const caIdNum = parseInt(ca.id.split('-')[1]);
                            if (!isNaN(caIdNum) && caIdNum >= customDeviceCount) customDeviceCount = caIdNum + 1;
                            
                            const html = `
                                <div class="app-card custom-app-card" data-id="${ca.id}">
                                    <div class="app-card-top" style="align-items: flex-start;">
                                        <div class="app-card-left">
                                            <div class="app-icon"><img src="${ICON_DEVICE}" alt=""></div>
                                            <div class="app-info" style="flex:1;">
                                                <div style="display: flex; align-items: center; gap: 6px;" class="custom-name-area">
                                                    <span class="app-title custom-name-text">${ca.name}</span>
                                                    <span class="btn-action icon-btn" data-action="edit-custom-name"><img src="${ICON_EDIT}"></span>
                                                    <input type="text" class="custom-name-input hidden" value="${ca.name}" maxlength="60" aria-label="Custom device name">
                                                    <span class="btn-action hidden icon-btn" data-action="save-custom-name"><img src="${ICON_CONFIRM}"></span>
                                                </div>
                                                <span class="app-desc subtext" style="margin-top: 8px;">${ca.watts}W / ${ca.hours}h/day</span>
                                            </div>
                                        </div>
                                        <button type="button" class="btn-action" data-action="remove-custom" style="background: none; border: none; font-size: 20px; color: #a1a1a6; cursor: pointer; padding: 0;">✕</button>
                                    </div>
                                    <div class="app-expanded">
                                        <div class="watts-input-wrapper"><input type="number" class="inline-input live-watts" value="${ca.watts}" min="1" max="99999" step="1"><span class="watts-label">W</span></div>
                                        <div class="slider-wrapper"><span class="slider-label">${ca.hours}h</span><input type="range" class="apple-slider" min="0.1" max="24" step="0.1" value="${ca.hours}"></div>
                                    </div>
                                </div>`;
                            document.getElementById('add-custom-btn-wrapper').insertAdjacentHTML('beforebegin', html);
                        });
                    }
                    
                    if (state.peakState) peakCheckState = state.peakState;
                    updateDashboard(); 
                    return; 
                }
            } catch(e) { console.error("Failed to restore state", e); }
        }
        updateSubTypes(); 
    }

    function buildBatteryDetailHtml(qtyStr, id, isModal = false, sysVoltage = 12, wiringStr = "") {
        const qty = parseInt(qtyStr) || 1;
        let translatedWiring = translateWiring(wiringStr);
        let wiringText = `Based on your calculated capacity requirement, we recommend connecting the batteries in ${translatedWiring ? '<strong>'+translatedWiring+'</strong>' : 'series or parallel'}.`;

        let S = 1, P = 1;
        let wStr = wiringStr || "";
        let mSP = wStr.match(/(\d+)串联(\d+)并联/);
        let mS = wStr.match(/(\d+)串联/);
        let mP = wStr.match(/(\d+)并联/);
        
        if (mSP) { S = parseInt(mSP[1]); P = parseInt(mSP[2]); } 
        else if (mS && mP) { S = parseInt(mS[1]); P = parseInt(mP[1]); } 
        else if (mS) { S = parseInt(mS[1]); P = Math.max(1, Math.floor(qty / S)); } 
        else if (mP) { P = parseInt(mP[1]); S = Math.max(1, Math.floor(qty / P)); } 
        else if (wStr.includes('串联') && wStr.includes('并联')) { S = 2; P = Math.max(1, Math.floor(qty / 2)); } 
        else if (wStr.includes('串联')) { S = qty; P = 1; } 
        else if (wStr.includes('并联')) { S = 1; P = qty; } 
        else {
            if (sysVoltage === 48) {
                if (qty === 4) { S = 4; P = 1; }
                else if (qty >= 8) { S = 4; P = Math.floor(qty / 4); }
                else { S = 1; P = qty; }
            } else {
                S = 1; P = qty;
            }
        }
        S = Math.max(1, S); P = Math.max(1, P);

        const isHorizontal = window.innerWidth > 768;
        let bw = isHorizontal ? 80 : 60;
        let bh = isHorizontal ? 50 : 80;
        let gx = 40, gy = 40;
        let StartX = isHorizontal ? 80 : 60;
        let StartY = isHorizontal ? 60 : 80;

        let TotalW = isHorizontal ? (StartX * 2 + S * bw + (S - 1) * gx) : (StartX * 2 + P * bw + (P - 1) * gx);
        let TotalH = isHorizontal ? (StartY * 2 + P * bh + (P - 1) * gy) : (StartY * 2 + S * bh + (S - 1) * gy);

        let visualHtml = `<div style="text-align:center; margin: 16px 0; overflow-x: auto; overflow-y: hidden;">
            <svg viewBox="0 0 ${TotalW} ${TotalH}" style="width:100%; min-width:${Math.min(TotalW, 280)}px; max-width: ${TotalW}px; height:auto; max-height: ${isHorizontal ? 260 : 400}px; display:block; margin: 0 auto;">`;

        if (isHorizontal) {
            if (P > 1) {
                let busX = StartX - 30, busY1 = StartY + bh/2, busY2 = StartY + (P - 1) * (bh + gy) + bh/2;
                visualHtml += `<path d="M ${busX} ${busY1} L ${busX} ${busY2}" stroke="#E65100" stroke-width="4" stroke-linecap="round"/>`;
                visualHtml += `<path d="M ${busX} ${busY1} L ${busX} ${busY1 - 20} L ${busX - 20} ${busY1 - 20}" stroke="#E65100" stroke-width="4" fill="none"/>`;
                visualHtml += `<circle cx="${busX - 20}" cy="${busY1 - 20}" r="5" fill="#E65100"/>`;
                visualHtml += `<text x="${busX - 20}" y="${busY1 - 32}" font-family="sans-serif" font-size="14" font-weight="600" fill="#E65100" text-anchor="middle">POS (+)</text>`;
            } else {
                let px = StartX, py = StartY + bh/2;
                visualHtml += `<path d="M ${px} ${py} L ${px - 30} ${py} L ${px - 30} ${py - 20}" stroke="#E65100" stroke-width="4" fill="none"/>`;
                visualHtml += `<circle cx="${px - 30}" cy="${py - 20}" r="5" fill="#E65100"/>`;
                visualHtml += `<text x="${px - 30}" y="${py - 32}" font-family="sans-serif" font-size="14" font-weight="600" fill="#E65100" text-anchor="middle">POS (+)</text>`;
            }

            if (P > 1) {
                let busX = StartX + S * bw + (S - 1) * gx + 30, busY1 = StartY + bh/2, busY2 = StartY + (P - 1) * (bh + gy) + bh/2;
                visualHtml += `<path d="M ${busX} ${busY1} L ${busX} ${busY2}" stroke="#1d1d1f" stroke-width="4" stroke-linecap="round"/>`;
                visualHtml += `<path d="M ${busX} ${busY1} L ${busX} ${busY1 - 20} L ${busX + 20} ${busY1 - 20}" stroke="#1d1d1f" stroke-width="4" fill="none"/>`;
                visualHtml += `<circle cx="${busX + 20}" cy="${busY1 - 20}" r="5" fill="#1d1d1f"/>`;
                visualHtml += `<text x="${busX + 20}" y="${busY1 - 32}" font-family="sans-serif" font-size="14" font-weight="600" fill="#1d1d1f" text-anchor="middle">NEG (-)</text>`;
            } else {
                let nx = StartX + S * bw + (S - 1) * gx, ny = StartY + bh/2;
                visualHtml += `<path d="M ${nx} ${ny} L ${nx + 30} ${ny} L ${nx + 30} ${ny - 20}" stroke="#1d1d1f" stroke-width="4" fill="none"/>`;
                visualHtml += `<circle cx="${nx + 30}" cy="${ny - 20}" r="5" fill="#1d1d1f"/>`;
                visualHtml += `<text x="${nx + 30}" y="${ny - 32}" font-family="sans-serif" font-size="14" font-weight="600" fill="#1d1d1f" text-anchor="middle">NEG (-)</text>`;
            }

            for(let p = 0; p < P; p++) {
                for(let s = 0; s < S; s++) {
                    let bx = StartX + s * (bw + gx), by = StartY + p * (bh + gy);
                    let px = bx, nx = bx + bw, py = by + bh/2;
                    visualHtml += `<rect x="${bx}" y="${by}" width="${bw}" height="${bh}" rx="6" fill="#f0f9ff" stroke="#00A8E8" stroke-width="2"/>`;
                    visualHtml += `<rect x="${px}" y="${py-8}" width="6" height="16" rx="2" fill="#E65100"/>`; 
                    visualHtml += `<rect x="${nx-6}" y="${py-8}" width="6" height="16" rx="2" fill="#1d1d1f"/>`; 
                    visualHtml += `<text x="${bx + bw/2}" y="${by + bh/2 + 5}" font-family="sans-serif" font-size="16" fill="#003399" text-anchor="middle" font-weight="600">BATT</text>`;

                    if (s === 0 && P > 1) visualHtml += `<path d="M ${px} ${py} L ${StartX - 30} ${py}" stroke="#E65100" stroke-width="3" fill="none"/>`;
                    if (s === S - 1 && P > 1) visualHtml += `<path d="M ${nx} ${py} L ${StartX + S*bw + (S-1)*gx + 30} ${py}" stroke="#1d1d1f" stroke-width="3" fill="none"/>`;
                    if (s < S - 1) visualHtml += `<path d="M ${nx} ${py} L ${StartX + (s + 1) * (bw + gx)} ${py}" stroke="#86868b" stroke-width="3" fill="none"/>`;
                }
            }
        } else {
            if (P > 1) {
                let busY = StartY - 30, busX1 = StartX + bw/2, busX2 = StartX + (P - 1) * (bw + gx) + bw/2;
                visualHtml += `<path d="M ${busX1} ${busY} L ${busX2} ${busY}" stroke="#E65100" stroke-width="4" stroke-linecap="round"/>`;
                visualHtml += `<path d="M ${busX1} ${busY} L ${busX1 - 20} ${busY} L ${busX1 - 20} ${busY - 20}" stroke="#E65100" stroke-width="4" fill="none"/>`;
                visualHtml += `<circle cx="${busX1 - 20}" cy="${busY - 20}" r="5" fill="#E65100"/>`;
                visualHtml += `<text x="${busX1 - 20}" y="${busY - 32}" font-family="sans-serif" font-size="14" font-weight="600" fill="#E65100" text-anchor="middle">POS (+)</text>`;
            } else {
                let px = StartX + bw/2, py = StartY;
                visualHtml += `<path d="M ${px} ${py} L ${px} ${py - 30} L ${px - 20} ${py - 30}" stroke="#E65100" stroke-width="4" fill="none"/>`;
                visualHtml += `<circle cx="${px - 20}" cy="${py - 30}" r="5" fill="#E65100"/>`;
                visualHtml += `<text x="${px - 20}" y="${py - 42}" font-family="sans-serif" font-size="14" font-weight="600" fill="#E65100" text-anchor="middle">POS (+)</text>`;
            }

            if (P > 1) {
                let busY = StartY + S * bh + (S - 1) * gy + 30, busX1 = StartX + bw/2, busX2 = StartX + (P - 1) * (bw + gx) + bw/2;
                visualHtml += `<path d="M ${busX1} ${busY} L ${busX2} ${busY}" stroke="#1d1d1f" stroke-width="4" stroke-linecap="round"/>`;
                visualHtml += `<path d="M ${busX2} ${busY} L ${busX2 + 20} ${busY} L ${busX2 + 20} ${busY + 20}" stroke="#1d1d1f" stroke-width="4" fill="none"/>`;
                visualHtml += `<circle cx="${busX2 + 20}" cy="${busY + 20}" r="5" fill="#1d1d1f"/>`;
                visualHtml += `<text x="${busX2 + 20}" y="${busY + 40}" font-family="sans-serif" font-size="14" font-weight="600" fill="#1d1d1f" text-anchor="middle">NEG (-)</text>`;
            } else {
                let nx = StartX + bw/2, ny = StartY + S * bh + (S - 1) * gy;
                visualHtml += `<path d="M ${nx} ${ny} L ${nx} ${ny + 30} L ${nx + 20} ${ny + 30}" stroke="#1d1d1f" stroke-width="4" fill="none"/>`;
                visualHtml += `<circle cx="${nx + 20}" cy="${ny + 30}" r="5" fill="#1d1d1f"/>`;
                visualHtml += `<text x="${nx + 20}" y="${ny + 48}" font-family="sans-serif" font-size="14" font-weight="600" fill="#1d1d1f" text-anchor="middle">NEG (-)</text>`;
            }

            for(let p = 0; p < P; p++) {
                for(let s = 0; s < S; s++) {
                    let bx = StartX + p * (bw + gx), by = StartY + s * (bh + gy);
                    let px = bx + bw/2, py = by, ny = by + bh;
                    visualHtml += `<rect x="${bx}" y="${by}" width="${bw}" height="${bh}" rx="6" fill="#f0f9ff" stroke="#00A8E8" stroke-width="2"/>`;
                    visualHtml += `<rect x="${px-8}" y="${py}" width="16" height="6" rx="2" fill="#E65100"/>`; 
                    visualHtml += `<rect x="${px-8}" y="${ny-6}" width="16" height="6" rx="2" fill="#1d1d1f"/>`; 
                    visualHtml += `<text x="${bx + bw/2}" y="${by + bh/2 + 5}" font-family="sans-serif" font-size="16" fill="#003399" text-anchor="middle" font-weight="600">BATT</text>`;

                    if (s === 0 && P > 1) visualHtml += `<path d="M ${px} ${py} L ${px} ${StartY - 30}" stroke="#E65100" stroke-width="3" fill="none"/>`;
                    if (s === S - 1 && P > 1) visualHtml += `<path d="M ${px} ${ny} L ${px} ${StartY + S*bh + (S-1)*gy + 30}" stroke="#1d1d1f" stroke-width="3" fill="none"/>`;
                    if (s < S - 1) visualHtml += `<path d="M ${px} ${ny} L ${px} ${StartY + (s + 1) * (bh + gy)}" stroke="#86868b" stroke-width="3" fill="none"/>`;
                }
            }
        }
        visualHtml += `</svg></div>`;

        let content = `
            <div style="text-align: left; padding: ${isModal ? '0' : '10px 0'}; width: 100%; min-width: 280px;">
                ${!isModal ? `<h4 style="font-size: 18px; color: #1d1d1f; margin: 0 0 12px 0; font-weight: 600;">Battery Connection</h4>` : ''}
                <p style="font-size: 16px; color: #86868b; margin: 0 0 16px 0; line-height: 1.5;">${wiringText}</p>
                ${visualHtml}
                <div style="margin-top: 16px; padding: 12px 16px; background: #fbfbfd; border-radius: 8px; text-align: left;">
                    <p style="font-size: 14px; color: #a1a1a6; margin: 0; line-height: 1.4;"><strong>Disclaimer:</strong> Always use appropriately sized cables and fuses. Ensure all batteries are at the same state of charge before connecting.</p>
                </div>
            </div>
        `;
        return isModal ? content : `<div>${content}</div>`;
    }

    function buildPvDetailHtml(qtyStr, id, isModal = false, sysVoltage = 12, wiringStr = "") {
        
        // 新增规则：如果是成对出售的特定太阳能板，绘制排版时实际板子数量需要乘以 2
        // 1. 先用 let 声明并初始化 qty
        // 1. qty 保持为常量，仅代表用户选择的“套数”
        const qty = parseInt(qtyStr) || 1;
    
        // 2. 新增 drawQty 变量，专门用于绘图计算
        let drawQty = qty;
    
        if (id === "RSP320DC-BKX2" || id === "RSP590DCT-144X2") {
            drawQty = qty * 2; 
        }
        
      let dimStr = "";
      // ... 下方代码保持不变
        
        const modelMatch = id.match(/(RSP[A-Z0-9-x]+)/i); 
        if (modelMatch && pvSpecsDB[modelMatch[1].toUpperCase()]) {
            dimStr = pvSpecsDB[modelMatch[1].toUpperCase()].dim;
        }

        let l = 41.4, w = 22.8; 
        if (dimStr) {
            let m = dimStr.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/);
            if(m) { 
                l = parseFloat(m[1]); 
                w = parseFloat(m[2]); 
                if (w > l) { let temp = l; l = w; w = temp; } 
            }
        }

        const getMatrix = (c, q) => {
            let r = Math.ceil(q / c); 
            let mat = [];
            for(let i=0; i<r; i++) { 
                let row = []; 
                for(let j=0; j<c; j++) { 
                    row.push((i*c + j < q) ? 1 : 0); 
                } 
                mat.push(row); 
            }
            return mat;
        };

        const rot90 = mat => {
            let rows = mat.length, cols = mat[0].length; 
            let res = Array.from({length: cols}, () => Array(rows).fill(0));
            for(let i=0; i<rows; i++) { 
                for(let j=0; j<cols; j++) { 
                    res[j][rows - 1 - i] = mat[i][j]; 
                } 
            }
            return res;
        };

        const flipH = mat => mat.map(row => [...row].reverse());

        const getD4 = m => {
            if(!m || !m.length) return [];
            let m1 = m; let m2 = rot90(m1); let m3 = rot90(m2); let m4 = rot90(m3);
            return [m1, m2, m3, m4, flipH(m1), flipH(m2), flipH(m3), flipH(m4)];
        };

        const matsEqual = (m1, m2) => {
            if (m1.length !== m2.length || m1[0].length !== m2[0].length) return false;
            for(let i=0; i<m1.length; i++) { 
                for(let j=0; j<m1[0].length; j++) { 
                    if(m1[i][j] !== m2[i][j]) return false; 
                } 
            } 
            return true;
        };

        const isSymmetricEquivalent = (m1, m2) => { 
            let transforms = getD4(m1); 
            for(let t of transforms) { 
                if (matsEqual(t, m2)) return true; 
            } 
            return false; 
        };

        let allConfigs = [];
        for (let c = 1; c <= drawQty; c++) {
            let r = Math.ceil(drawQty / c); 
            let W = c * w; 
            let H = r * l; 
            let score = Math.max(W/H, H/W); 
            let mat = getMatrix(c, drawQty);
            allConfigs.push({ c, r, W, H, score, mat });
        }
        allConfigs.sort((a,b) => a.score - b.score);

        let selected = [];
        for(let config of allConfigs) {
            let isDup = false;
            for(let sel of selected) { 
                if(isSymmetricEquivalent(config.mat, sel.mat)) { 
                    isDup = true; break; 
                } 
            }
            if(!isDup) { 
                selected.push(config); 
                if(selected.length === 2) break; 
            }
        }

            if (selected.length < 2 && drawQty > 1) {
            selected = [];
            for(let config of allConfigs) {
                // ...
                let isDup = false;
                for(let sel of selected) { 
                    if(matsEqual(config.mat, sel.mat)) { 
                        isDup = true; break; 
                    } 
                }
                if(!isDup) { 
                    selected.push(config); 
                    if(selected.length === 2) break; 
                }
            }
        }

        let layoutsHtml = '';
        selected.forEach((config, idx) => {
            let cols = config.c; 
            let rows = config.r;
            const pW = 100; 
            const pH = (l / w) * pW; 
            const pGap = 8;
            const tW = cols * pW + (cols - 1) * pGap; 
            const tH = rows * pH + (rows - 1) * pGap;

            let svg = `<svg viewBox="-20 -40 ${tW + 70} ${tH + 60}" style="width:100%; height:100%; max-height: 200px; display:block; margin: 0 auto;">`;
            for(let i=0; i<drawQty; i++) {
                let currR = Math.floor(i / cols); 
                // ...
                let currC = i % cols; 
                let x = currC * (pW + pGap); 
                let y = currR * (pH + pGap);
                svg += `<rect x="${x}" y="${y}" width="${pW}" height="${pH}" rx="4" fill="#f0f9ff" stroke="#00A8E8" stroke-width="2"/>`;
                svg += `<line x1="${x+pW/3}" y1="${y}" x2="${x+pW/3}" y2="${y+pH}" stroke="#00A8E8" stroke-width="1" opacity="0.3"/>`;
                svg += `<line x1="${x+pW*2/3}" y1="${y}" x2="${x+pW*2/3}" y2="${y+pH}" stroke="#00A8E8" stroke-width="1" opacity="0.3"/>`;
                svg += `<line x1="${x}" y1="${y+pH/3}" x2="${x+pW}" y2="${y+pH/3}" stroke="#00A8E8" stroke-width="1" opacity="0.3"/>`;
                svg += `<line x1="${x}" y1="${y+pH*2/3}" x2="${x+pW}" y2="${y+pH*2/3}" stroke="#00A8E8" stroke-width="1" opacity="0.3"/>`;
            }
            svg += `<path d="M 0 -10 L 0 -20 M ${tW} -10 L ${tW} -20 M 0 -15 L ${tW} -15" stroke="#a1a1a6" stroke-width="1.5" fill="none"/>
                    <text x="${tW/2}" y="-25" font-family="sans-serif" font-size="14" fill="#86868b" text-anchor="middle">${(cols * w).toFixed(1)} in</text>`;
            svg += `<path d="M ${tW + 10} 0 L ${tW + 20} 0 M ${tW + 10} ${tH} L ${tW + 20} ${tH} M ${tW + 15} 0 L ${tW + 15} ${tH}" stroke="#a1a1a6" stroke-width="1.5" fill="none"/>
                    <g transform="translate(${tW + 25}, ${tH/2})"><text x="0" y="0" font-family="sans-serif" font-size="14" fill="#86868b" text-anchor="middle" transform="rotate(90)">${(rows * l).toFixed(1)} in</text></g></svg>`;

            layoutsHtml += `<div class="pv-layout-card"><h4 class="pv-layout-card-title">${qty === 1 ? 'Array Layout' : `Layout Option ${idx + 1}`}</h4><div class="pv-layout-svg-wrapper">${svg}</div></div>`;
        });

        let wiringHtml = '';
        if (drawQty > 1) {
            let translatedWiring = translateWiring(wiringStr);
            // ...
            let wiringText = `To match the device's operating voltage, we recommend connecting the solar panels in ${translatedWiring ? '<strong>'+translatedWiring+'</strong>' : 'parallel'}.`;
            let topBorder = isModal ? "margin-top: 24px; padding-top: 24px; border-top: 1px solid #e5e5e5;" : "margin-top: 16px; padding-top: 16px; border-top: 1px dashed #e5e5e5;";
            wiringHtml = `<div style="${topBorder} text-align: left;"><h4 style="font-size: 18px; color: #1d1d1f; margin: 0 0 8px 0; font-weight: 600;">Wiring Recommendation</h4><p style="font-size: 16px; color: #86868b; margin: 0; line-height: 1.5;">${wiringText}</p></div>`;
        }

        let disclaimerHtml = `<div style="margin-top: 16px; padding: 12px 16px; background: #fbfbfd; border-radius: 8px; text-align: left;"><p style="font-size: 14px; color: #a1a1a6; margin: 0; line-height: 1.4;"><strong>Disclaimer:</strong> Layout graphics are for reference only. Actual installation varies.</p></div>`;

        return `
            <div class="${isModal ? "pv-layouts-wrapper is-modal" : "pv-layouts-wrapper is-tooltip"}">
                ${layoutsHtml}
            </div>
            ${wiringHtml}
            ${isModal ? disclaimerHtml : (qty === 1 ? `<p style="font-size: 14px; color: #86868b; margin: 16px 0 0 0; line-height: 1.4; text-align: center;"></p>` : '')}
        `;
    }

    const initApp = () => {
        initFromCookie(); 
        
        document.addEventListener('click', function(e) {
            const navBtn = e.target.closest('.btn-nav');
            if(navBtn) { 
                if(navBtn.classList.contains('disabled-state')) return; 
                e.preventDefault(); 
                goToStep(navBtn.dataset.target); 
            }
            
            const actionBtn = e.target.closest('.btn-action');
            if(actionBtn) {
                if(actionBtn.dataset.action === 'open-pv-modal' || actionBtn.dataset.action === 'open-batt-modal') {
                    e.preventDefault(); 
                    e.stopPropagation();
                    const qty = actionBtn.dataset.qty || 1;
                    const id = actionBtn.dataset.id;
                    const sysVoltage = parseInt(actionBtn.dataset.sysvoltage) || 12;
                    const wiring = actionBtn.dataset.wiring || "";
                    const isPv = (actionBtn.dataset.action === 'open-pv-modal');
                    const modalContentBody = document.getElementById('pv-modal-body');
                    const subtitleEl = document.querySelector('.pv-modal-subtitle');
                    
                    if (isPv) {
                        document.querySelector('.pv-modal-title').innerText = 'Array Layout Options';
                        subtitleEl.innerText = 'Optimal installation arrangements for your selected quantity.';
                        subtitleEl.style.display = 'block'; 
                        modalContentBody.innerHTML = buildPvDetailHtml(qty, id, true, sysVoltage, wiring); 
                    } else {
                        document.querySelector('.pv-modal-title').innerText = 'Battery Connection';
                        subtitleEl.style.display = 'none'; 
                        modalContentBody.innerHTML = buildBatteryDetailHtml(qty, id, true, sysVoltage, wiring); 
                    }
                    
                    document.getElementById('pv-info-modal').style.display = 'flex';
                    document.body.style.overflow = 'hidden'; 
                    return;
                }
                
                e.preventDefault(); 
                const action = actionBtn.dataset.action;
                
                if(action === 'add-all-to-cart') {
                    addRecommendedSolutionToCart(actionBtn);
                }
                if(action === 'export-plan') exportPlanPdf();
                if(action === 'install-interest') {
                    const choice = actionBtn.dataset.value;
                    installSurveyState = { step: 'done', choice };
                    renderInstallSurvey();
                    AnalyticsTracker.recordInstallInterest(choice, null);
                }
                if(action === 'add-custom') addCustomItem();
                if(action === 'remove-custom') { 
                    actionBtn.closest('.custom-app-card').remove(); 
                    updateDashboard(); 
                }
                if(action === 'open-reset-modal') { 
                    document.getElementById('reset-modal').style.display = 'flex'; 
                    document.body.style.overflow = 'hidden'; 
                }
                if(action === 'close-reset-modal') { 
                    document.getElementById('reset-modal').style.display = 'none'; 
                    document.body.style.overflow = 'auto'; 
                }
                if(action === 'confirm-reset') { 
                    resetAll(); 
                    document.getElementById('reset-modal').style.display = 'none'; 
                    document.body.style.overflow = 'auto'; 
                }
                if(action === 'show-more') { 
                    const list = document.getElementById('dynamic-appliance-list');
                    if (list.classList.contains('app-list-collapsed')) {
                        list.classList.remove('app-list-collapsed'); 
                        actionBtn.innerHTML = `Show Less Devices <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg>`;
                    } else {
                        list.classList.add('app-list-collapsed'); 
                        actionBtn.innerHTML = `Show More Devices <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>`; 
                        const rect = list.getBoundingClientRect();
                        window.scrollTo({ top: window.scrollY + rect.top - 100, behavior: 'smooth' });
                    }
                }
                
                if(action === 'close-sheet') goToStep('usage1');
                
                if(action === 'edit-custom-name') {
                    const area = actionBtn.closest('.custom-name-area'); 
                    area.querySelector('.custom-name-text').classList.add('hidden'); 
                    actionBtn.closest('.icon-btn').classList.add('hidden');
                    const input = area.querySelector('.custom-name-input'); 
                    input.classList.remove('hidden'); 
                    area.querySelector('[data-action="save-custom-name"]').classList.remove('hidden'); 
                    input.focus();
                }
                if(action === 'save-custom-name') {
                    const area = actionBtn.closest('.custom-name-area'); 
                    const input = area.querySelector('.custom-name-input'); 
                    const text = area.querySelector('.custom-name-text');
                    text.innerText = input.value || 'Custom Device'; 
                    input.classList.add('hidden'); 
                    actionBtn.closest('.icon-btn').classList.add('hidden'); 
                    text.classList.remove('hidden'); 
                    area.querySelector('[data-action="edit-custom-name"]').classList.remove('hidden'); 
                    updateDashboard(); 
                }
                if(action === 'open-modal') {
                    const expertModal = document.getElementById('expert-modal');
                    const expertIframe = expertModal ? expertModal.querySelector('iframe') : null;
                    if (expertIframe) expertIframe.src = buildExpertFormUrl();
                    expertModal.style.display = 'flex';
                    document.body.style.overflow = 'hidden';
                }
                if(action === 'close-modal') { 
                    document.getElementById('expert-modal').style.display = 'none'; 
                    document.body.style.overflow = 'auto'; 
                }
                if(action === 'close-pv-modal') { 
                    document.getElementById('pv-info-modal').style.display = 'none'; 
                    document.body.style.overflow = 'auto'; 
                }
                if(action === 'toggle-pv-options') {
                    const container = document.getElementById('pv-inline-options'); 
                    const btn = document.getElementById('pv-toggle-btn');
                    if(container) {
                        container.classList.toggle('open'); 
                        isPvOptionsOpen = container.classList.contains('open'); 
                        btn.innerHTML = isPvOptionsOpen ? `Show Less Options <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg>` : `Show More Options <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>`;
                    }
                }
                if(action === 'select-pv-inline') { 
                    currentPvOptionIndex = parseInt(actionBtn.dataset.index); 
                    generateRecommendation(true); 
                }
            }
            if(e.target.classList.contains('modal-overlay')) { 
                e.target.style.display = 'none'; 
                document.body.style.overflow = 'auto'; 
            }
        });

        document.addEventListener('change', function(e) {
            if(e.target.name === 'main_scenario') updateSubTypes();
            if(e.target.name === 'sub_type') currentRenderedSubType = null;
            if(e.target.classList.contains('app-check')) {
                const card = e.target.closest('.app-card');
                if(e.target.checked) card.classList.add('active'); 
                else card.classList.remove('active');
                updateDashboard();
            }
            if(e.target.classList.contains('peak-checkbox')) { 
                peakCheckState[e.target.dataset.id] = e.target.checked; 
                calculatePeakPower(); 
            }
            if(e.target.classList.contains('live-watts')) {
                let val = parseInt(e.target.value); 
                if (isNaN(val) || val < 1) { e.target.value = 1; } 
                else if (val > 99999) { e.target.value = 99999; } 
                updateDashboard();
            }
        });

        document.addEventListener('input', function(e) {
            if(e.target.classList.contains('apple-slider')) { 
                e.target.previousElementSibling.innerText = e.target.value + 'h'; 
                updateDashboard(); 
            }
            if(e.target.classList.contains('live-watts')) { 
                let val = parseInt(e.target.value); 
                if (val > 99999) { e.target.value = 99999; } 
                updateDashboard(); 
            }
        });
        
        window.addEventListener('scroll', updateStickyFooter, { passive: true });
        window.addEventListener('resize', updateStickyFooter);
    };

    if (document.readyState === 'loading') { 
        document.addEventListener("DOMContentLoaded", initApp); 
    } else { 
        initApp(); 
    }
   /* =========================================================================
   高级数据追踪分析模块 (Analytics Tracker) - 单列整合配置版
   ========================================================================= */
const AnalyticsTracker = (function() {
    // 【重要】：确保填入你的 Web App URL
    const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxzWKnhR3PY95DsVRZrGqUyJBOQi0QB_va5Mxw9sCBMY8_rAo6sJO4OksPdSxmCG2TyIQ/exec';

    let state = {
        virtualId: crypto.randomUUID ? crypto.randomUUID() : 'uid-' + Date.now() + '-' + Math.floor(Math.random()*1000),
        iteration: 1,
        startTime: Date.now(),
        lastEventName: '加载配置器 (Page Load)',
        // Captured once at load: static for the life of this page view, so
        // there's no need to re-derive them on every snapshot.
        deviceType: window.innerWidth <= 768 ? 'mobile' : 'desktop',
        referrer: document.referrer || '',
        landingParams: location.search || '',
        journeyPath: [],
        urlClicks: [],
        modalOpens: [],
        expertClicks: 0,
        resetCount: 0,
        showMoreCount: 0,
        solarSwitchCount: 0,
        depth: 1,
        installInterest: null,
        installInterestReason: null,
        addToCartClickCount: 0,
        addToCartOutcome: null,
        cartTotalValue: 0,
        exportClickCount: 0,
        lastExportedPlanId: null,
        lastExportedVerificationCode: null,
        lastExportedAt: null
    };

    let hasStarted = false;
    let debounceTimer;

    function sendDataDebounced() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            syncToGoogleSheet();
        }, 1500); 
    }

    function captureCurrentSnapshot() {
        const scenarioEl = document.querySelector('input[name="main_scenario"]:checked');
        const scenario = scenarioEl ? scenarioEl.value : '';
        const subtypeEl = document.querySelector('input[name="sub_type"]:checked');
        const subtype = subtypeEl ? subtypeEl.value : '';
        
        if (scenario) state.depth = Math.max(state.depth, 1);
        if (subtype) state.depth = Math.max(state.depth, 2);
        if (document.getElementById('step-usage').classList.contains('active-section')) state.depth = Math.max(state.depth, 3);
        if (document.getElementById('step-recommendation').classList.contains('active-section')) state.depth = Math.max(state.depth, 4);

        const selectedAppliances = [];
        const modifiedAppliances = [];
        document.querySelectorAll('.standard-app-card.active').forEach(card => {
            const id = card.dataset.id;
            const name = card.dataset.name;
            const watts = parseInt(card.querySelector('.live-watts').value) || 0;
            const hours = parseFloat(card.querySelector('.apple-slider').value) || 0;
            selectedAppliances.push({ name, watts, hours });

            const subtypeData = configData[scenario]?.subtypes.find(s => s.id === subtype);
            const originalApp = subtypeData?.appliances.find(a => a.id === id);
            if (originalApp && originalApp.baseWatts !== watts) {
                modifiedAppliances.push({ name, originalWatts: originalApp.baseWatts, newWatts: watts });
            }
        });

        const customAppliances = [];
        document.querySelectorAll('.custom-app-card').forEach(card => {
            const name = card.querySelector('.custom-name-text').innerText;
            const watts = parseInt(card.querySelector('.live-watts').value) || 0;
            const hours = parseFloat(card.querySelector('.apple-slider').value) || 0;
            customAppliances.push({ name, watts, hours });
        });

        // 【新增】：将预设电器和自定义电器统一合并为直观的字符串数组
        const allActiveAppliances = [...selectedAppliances, ...customAppliances].map(a => `${a.name}: ${a.watts}W, ${a.hours}h`);

        const peakAppliances = [];
        document.querySelectorAll('.peak-checkbox:checked').forEach(chk => {
            const name = chk.closest('.peak-item').querySelector('.app-title').innerText;
            peakAppliances.push(name);
        });

        let recKit = '';
        let recProducts = [];
        if (state.depth === 4) {
            document.querySelectorAll('.rec-card').forEach(card => {
                const title = card.querySelector('.rec-title')?.innerText;
                const qtyEl = card.querySelector('.rec-qty');
                const qtyText = qtyEl ? qtyEl.innerText : '';
                const isKit = card.previousElementSibling && card.previousElementSibling.innerText.includes('Recommended Kit');
                if (title) {
                    if (isKit && !recKit) recKit = title;
                    else recProducts.push(qtyText ? `${title} [${qtyText}]` : title);
                }
            });
            const activeInlinePv = document.querySelector('.inline-option-item.selected .inline-item-title');
            if (activeInlinePv) {
                let cleanTitle = activeInlinePv.innerText.replace('CURRENT', '').trim();
                recProducts.push(cleanTitle);
            }
        }

        return {
            virtualId: state.virtualId,
            iteration: state.iteration, 
            timestamp: new Date().toLocaleString('zh-CN', { timeZone: 'Asia/Taipei' }),
            eventName: state.lastEventName,
            durationSeconds: Math.floor((Date.now() - state.startTime) / 1000),
            type: scenario,
            subtype: subtype,
            totalKwh: parseFloat(document.getElementById('live-kwh').innerText) || 0,
            allActiveAppliances, // <--- 这里发给后端合并后的一列数据
            modifiedAppliances,
            peakPower: parseInt(document.getElementById('live-peak').innerText.replace(/,/g, '')) || 0,
            peakAppliances,
            recKit,
            recProducts,  
            urlClicks: state.urlClicks,
            modalOpens: state.modalOpens,
            expertClicks: state.expertClicks,
            journeyPath: state.journeyPath,
            depth: state.depth,
            resetCount: state.resetCount,
            showMoreCount: state.showMoreCount,
            solarSwitchCount: state.solarSwitchCount,
            installInterest: state.installInterest,
            installInterestReason: state.installInterestReason,
            addToCartClickCount: state.addToCartClickCount,
            addToCartOutcome: state.addToCartOutcome,
            cartTotalValue: state.cartTotalValue,
            exportClickCount: state.exportClickCount,
            lastExportedPlanId: state.lastExportedPlanId,
            lastExportedVerificationCode: state.lastExportedVerificationCode,
            lastExportedAt: state.lastExportedAt,
            deviceType: state.deviceType,
            referrer: state.referrer,
            landingParams: state.landingParams,
            customApplianceCount: customAppliances.length,
            peakWarningShown: (latestPlanSnapshot && latestPlanSnapshot.recommendation && latestPlanSnapshot.recommendation.warning) ? 'yes' : 'no'
        };
    }

    function syncToGoogleSheet() {
        if (!GOOGLE_SCRIPT_URL.startsWith('http')) return;
        const payload = captureCurrentSnapshot();
        fetch(GOOGLE_SCRIPT_URL, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        }).catch(e => console.error("Analytics Sync Error", e));
    }

    // Last-resort flush for the case where the tab closes/backgrounds while
    // a 1500ms debounce is still pending -- a plain fetch can get cancelled
    // mid-flight when the page unloads, silently dropping the final state
    // (e.g. the very last click before checkout). sendBeacon is designed to
    // survive exactly this: the browser guarantees the request is queued
    // even if the page is gone before it completes. The payload is sent as
    // a text/plain Blob (rather than application/json) purely so it stays a
    // CORS-safelisted "simple request" -- sendBeacon cannot follow a
    // preflight response, and doPost() already parses e.postData.contents
    // as raw text regardless of the declared content type, so this changes
    // nothing server-side.
    function flushAnalyticsOnExit() {
        if (!hasStarted) return;
        if (!GOOGLE_SCRIPT_URL.startsWith('http')) return;
        if (typeof navigator.sendBeacon !== 'function') return;
        clearTimeout(debounceTimer);
        try {
            const payload = captureCurrentSnapshot();
            const blob = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });
            navigator.sendBeacon(GOOGLE_SCRIPT_URL, blob);
        } catch (e) { /* best effort only -- never block unload on this */ }
    }

    function logAction(actionName, extraInfo = '') {
        if (!hasStarted) hasStarted = true;
        const timeOffset = Math.floor((Date.now() - state.startTime) / 1000);
        const detail = extraInfo ? `: ${extraInfo}` : '';
        const logEntry = `[${timeOffset}s] ${actionName}${detail}`;
        
        state.lastEventName = actionName + detail; 
        if (state.journeyPath.length > 500) state.journeyPath.shift(); 
        state.journeyPath.push(logEntry);
        
        sendDataDebounced();
    }

    function attachListeners() {
        document.addEventListener('click', (e) => {
            const recCard = e.target.closest('.rec-card');
            if (recCard && !e.target.closest('.btn-action')) {
                const title = recCard.querySelector('.rec-title')?.innerText;
                state.urlClicks.push(title);
                logAction('点击跳转单品', title);
            }

            const actionBtn = e.target.closest('.btn-action');
            if (actionBtn) {
                const action = actionBtn.dataset.action;
                if (action === 'export-plan') logAction('Clicked recommendation action', 'Export Plan PDF');
                if (action === 'open-pv-modal' || action === 'open-batt-modal') {
                    const parentCard = actionBtn.closest('.rec-card') || actionBtn.closest('.inline-option-item');
                    const productTitle = parentCard ? (parentCard.querySelector('.rec-title') || parentCard.querySelector('.inline-item-title'))?.innerText : actionBtn.dataset.id;
                    const cleanTitle = productTitle ? productTitle.replace('CURRENT', '').trim() : actionBtn.dataset.id;
                    state.modalOpens.push(`唤出: ${cleanTitle}`);
                    logAction('主动点击查看接线', cleanTitle);
                }
                if (action === 'open-modal') {
                    state.expertClicks++;
                    logAction('点击按钮', 'Talk to Expert');
                }
                if (action === 'confirm-reset') {
                    state.resetCount++;
                    logAction('点击按钮', '确认 Reset All');
                }
                if (action === 'show-more') {
                    state.showMoreCount++;
                    logAction('切换设备列表显示', actionBtn.innerText.includes('More') ? '展开更多' : '折叠部分');
                }
                if (action === 'select-pv-inline') {
                    state.solarSwitchCount++;
                    logAction('切换备选 Solar Panel', actionBtn.querySelector('.inline-item-title')?.innerText.replace('CURRENT', '').trim());
                }
                if (action === 'add-custom') logAction('点击按钮', 'Add Custom Device');
                if (action === 'remove-custom') logAction('删除了自定义设备', actionBtn.closest('.custom-app-card').querySelector('.custom-name-text').innerText);
            }

            const navBtn = e.target.closest('.btn-nav');
            if (navBtn && !navBtn.classList.contains('disabled-state')) {
                const target = navBtn.dataset.target;
                const isCurrentlyOnRecommendation = document.getElementById('step-recommendation').classList.contains('active-section');
                
                if (isCurrentlyOnRecommendation && target !== 'recommendation') {
                    state.iteration++; 
                    logAction('返回修改配置', `自动开启第 ${state.iteration} 套方案设计记录`);
                } else {
                    logAction('进入下一步骤', target);
                }
            }
        });

        let hoverTimeout;
        document.addEventListener('mouseover', (e) => {
            const trigger = e.target.closest('.info-trigger-btn');
            if (trigger && window.innerWidth > 768) { 
                clearTimeout(hoverTimeout);
                hoverTimeout = setTimeout(() => {
                    const parentCard = trigger.closest('.rec-card') || trigger.closest('.inline-option-item');
                    const cleanTitle = (parentCard ? (parentCard.querySelector('.rec-title') || parentCard.querySelector('.inline-item-title'))?.innerText : trigger.dataset.id).replace('CURRENT', '').trim();
                    const logString = `悬浮: ${cleanTitle}`;
                    if (state.modalOpens[state.modalOpens.length - 1] !== logString) {
                        state.modalOpens.push(logString);
                        logAction('鼠标悬浮查看接线', cleanTitle);
                    }
                }, 800); 
            }
        });

        document.addEventListener('mouseout', (e) => {
            if (e.target.closest('.info-trigger-btn')) clearTimeout(hoverTimeout);
        });

        document.addEventListener('change', (e) => {
            if (e.target.name === 'main_scenario') logAction('切换大类场景', e.target.nextElementSibling.querySelector('.card-title').innerText);
            if (e.target.name === 'sub_type') logAction('切换车辆/房屋型号', e.target.nextElementSibling.querySelector('.card-title').innerText);
            if (e.target.classList.contains('app-check')) logAction(`勾选电器 [${e.target.closest('.app-card').querySelector('.app-title').innerText}]`, e.target.checked ? '开启 (ON)' : '关闭 (OFF)');
            if (e.target.classList.contains('peak-checkbox')) logAction(`峰值用电勾选 [${e.target.closest('.peak-item').querySelector('.app-title').innerText}]`, e.target.checked ? '加入峰值并发' : '移出峰值并发');
            if (e.target.classList.contains('live-watts')) logAction(`修改功率 [${e.target.closest('.app-card').querySelector('.app-title')?.innerText || 'Unknown'}]`, `${e.target.value}W`);
            if (e.target.classList.contains('apple-slider')) logAction(`修改使用时长 [${e.target.closest('.app-card').querySelector('.app-title')?.innerText || 'Unknown'}]`, `${e.target.value}h`);
            if (e.target.classList.contains('custom-name-input')) logAction('重命名自定义设备', e.target.value);
        });
        
        document.addEventListener('input', (e) => {
             if (e.target.type === 'range' || e.target.type === 'number') sendDataDebounced();
        });

        // pagehide fires reliably on both tab close and mobile Safari's
        // back/forward-cache navigation (unlike beforeunload, which mobile
        // Safari often skips); visibilitychange covers the app-switch/lock
        // case where the tab never technically "closes" but the user is
        // effectively gone. Both funnel into the same best-effort beacon.
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') flushAnalyticsOnExit();
        });
        window.addEventListener('pagehide', flushAnalyticsOnExit);
    }

    return {
        init: () => {
            attachListeners();
            logAction('会话开始 (Session Started)', '用户加载了配置器');
        },
        // Called by the paid-installation interest widget on the recommendation
        // page. `reasonLabel` is null for the first tap (yes/no) and filled in
        // once the visitor also picks a follow-up reason chip.
        recordInstallInterest: (choice, reasonLabel) => {
            state.installInterest = choice;
            state.installInterestReason = reasonLabel || null;
            logAction('安装服务意向调查 (Install interest survey)', reasonLabel ? `${choice} - ${reasonLabel}` : choice);
        },
        recordAddToCartClick: (outcome, cartValue) => {
            state.addToCartClickCount++;
            state.addToCartOutcome = outcome;
            state.cartTotalValue = cartValue || 0;
            logAction('点击按钮', `Add to Cart (${outcome}, $${(cartValue || 0).toFixed(2)})`);
        },
        recordExport: (planId, verificationCode) => {
            state.exportClickCount++;
            state.lastExportedPlanId = planId;
            state.lastExportedVerificationCode = verificationCode;
            state.lastExportedAt = new Date().toLocaleString('zh-CN', { timeZone: 'Asia/Taipei' });
            logAction('导出方案 PDF (Export plan)', `${planId} / ${verificationCode}`);
        }
    }
})();

AnalyticsTracker.init();

  
    function updateStickyFooter() {
        const stickyEl = document.getElementById('summary-sticky-wrapper'); 
        if (!stickyEl) return;

        if (window.innerWidth > 768) { 
            stickyEl.classList.remove('is-absolute'); 
            stickyEl.style.position = ''; 
            stickyEl.style.width = ''; 
            stickyEl.style.left = ''; 
            stickyEl.style.bottom = ''; 
            return; 
        }
        
        const container = document.querySelector('#usage-container .split-pane'); 
        if (!container) return;
        
        if(!document.getElementById('step-usage').classList.contains('active-section') || 
           !document.getElementById('usage-container').classList.contains('usage-single-mode')) {
               return;
        }

        if (container.getBoundingClientRect().bottom <= window.innerHeight) {
            stickyEl.classList.add('is-absolute'); 
            stickyEl.style.position = 'absolute'; 
            stickyEl.style.width = 'calc(100% + 40px)'; 
            stickyEl.style.left = '-20px'; 
            stickyEl.style.bottom = '0';
        } else {
            stickyEl.classList.remove('is-absolute'); 
            stickyEl.style.position = 'fixed'; 
            stickyEl.style.width = '100vw'; 
            stickyEl.style.left = '0'; 
            stickyEl.style.bottom = '0';
        }
    }

function goToStep(targetId) {
        if(targetId === 'subtype') updateSubTypes(); 
        if(targetId === 'usage1') renderAppliances(); 
        if(targetId === 'usage2' && totalWh === 0) return;
        
        const container = document.getElementById('usage-container'); 
        const peakPane = document.getElementById('peak-power-pane');
        const action1 = document.getElementById('action-usage-1'); 
        const action2 = document.getElementById('action-usage-2');
        const backdrop = document.getElementById('mobile-sheet-backdrop');
        const configuratorContainer = document.getElementById('apple-configurator');

        // 通用的平滑滚动函数（计算偏移量，防止被顶部导航遮挡）
        const scrollToConfigurator = () => {
            const rect = configuratorContainer.getBoundingClientRect();
            // 减去一个固定的偏移量（例如 50px），确保容器顶部完全可见
            window.scrollTo({ top: window.scrollY + rect.top - 50, behavior: 'smooth' });
        };

        if(targetId === 'usage1' || targetId === 'usage2') {
            document.querySelectorAll('.step-section').forEach(s => s.classList.remove('active-section')); 
            document.getElementById('step-usage').classList.add('active-section');
            
            if(targetId === 'usage1') {
                container.className = 'usage-single-mode'; 
                peakPane.classList.remove('sheet-open'); 
                backdrop.classList.remove('show');
                action1.classList.remove('hidden'); 
                action2.classList.add('hidden'); 
                document.body.style.overflow = '';
                
                setTimeout(() => { 
                    if (container.className === 'usage-single-mode') peakPane.classList.add('hidden'); 
                    updateStickyFooter(); 
                }, 300);

                updateDashboard();
                scrollToConfigurator(); // 替换原有的跳跃逻辑
            } else if (targetId === 'usage2') {
                container.className = 'usage-split-mode'; 
                peakPane.classList.remove('hidden'); 
                
                if(window.innerWidth <= 768) { 
                    backdrop.classList.add('show'); 
                    document.body.style.overflow = 'hidden'; 
                    setTimeout(() => peakPane.classList.add('sheet-open'), 10); 
                } else { 
                    action1.classList.add('hidden'); 
                    action2.classList.remove('hidden'); 
                    scrollToConfigurator(); // 替换原有的跳跃逻辑
                }
            }
            updateDashboard();
        } else {
            if(targetId === 'recommendation') generateRecommendation(); 
            document.querySelectorAll('.step-section').forEach(s => s.classList.remove('active-section')); 
            document.body.style.overflow = ''; 
            
            setTimeout(() => { 
                document.getElementById('step-' + targetId).classList.add('active-section'); 
                scrollToConfigurator(); // 替换原有的跳跃逻辑
            }, 50);
        }
        
        document.querySelectorAll('.nav-item').forEach(n => n.classList.remove('active'));
        if(targetId === 'scenario') document.getElementById('nav-step-scenario').classList.add('active');
        if(targetId === 'subtype') document.getElementById('nav-step-subtype').classList.add('active');
        if(targetId === 'usage1' || targetId === 'usage2') document.getElementById('nav-step-usage').classList.add('active');
        if(targetId === 'recommendation') document.getElementById('nav-step-recommendation').classList.add('active');
    }

    function updateSubTypes() { 
        const scenario = document.querySelector('input[name="main_scenario"]:checked').value;
        if (currentRenderedScenario === scenario) return;
        
        currentRenderedScenario = scenario; 
        currentRenderedSubType = null; 
        const data = configData[scenario] || configData['rv']; 
        document.getElementById('subtype-title').innerText = data.title;
        
        let html = `<div class="selection-grid">`;
        data.subtypes.forEach((sub, i) => { 
            html += `
                <label class="selection-card">
                    <input type="radio" name="sub_type" value="${sub.id}" ${i===0?'checked':''}>
                    <div class="card-box">
                        <img src="${sub.image}" class="card-img" alt="">
                        <span class="card-title">${sub.title}</span>
                    </div>
                </label>`; 
        });
        html += `</div>`; 
        document.getElementById('sub-grids-container').innerHTML = html;
        saveStateToCookie(); 
    }

    function renderAppliances() { 
        const scenario = document.querySelector('input[name="main_scenario"]:checked').value;
        const subTypeId = document.querySelector('input[name="sub_type"]:checked').value;
        if(currentRenderedSubType === subTypeId) return; 
        
        currentRenderedSubType = subTypeId; 
        peakCheckState = {}; 
        
        const subtypeData = configData[scenario].subtypes.find(s => s.id === subTypeId);
        const container = document.getElementById('dynamic-appliance-list'); 
        container.innerHTML = '';
        
        if (subtypeData && subtypeData.appliances) {
            subtypeData.appliances.forEach(item => {
                container.insertAdjacentHTML('beforeend', `
                    <div class="app-card standard-app-card" data-id="${item.id}" data-name="${item.name}">
                        <div class="app-card-top">
                            <div class="app-card-left">
                                <div class="app-icon"><img src="${item.icon}" alt=""></div>
                                <div class="app-info">
                                    <span class="app-title">${item.name}</span>
                                    <span class="app-desc subtext">${item.baseWatts}W / ${item.defaultHours}h/day</span>
                                </div>
                            </div>
                            <label class="ios-switch"><input type="checkbox" class="app-check"><span class="slider"></span></label>
                        </div>
                        <div class="app-expanded">
                            <div class="watts-input-wrapper">
                                <input type="number" class="inline-input live-watts" value="${item.baseWatts}" min="1" max="99999" step="1">
                                <span class="watts-label">W</span>
                            </div>
                            <div class="slider-wrapper">
                                <span class="slider-label">${item.defaultHours}h</span>
                                <input type="range" class="apple-slider" min="0.1" max="24" step="0.1" value="${item.defaultHours}">
                            </div>
                        </div>
                    </div>`);
            });
        }
        
        container.insertAdjacentHTML('beforeend', `
            <div id="add-custom-btn-wrapper" class="app-card add-custom-card btn-action" data-action="add-custom">
                <span style="font-size:28px; line-height: 1;">+</span> Add Custom Device
            </div>
        `);
        
        const showMoreBtn = document.getElementById('show-more-btn');
        if (window.innerWidth <= 768 && subtypeData.appliances.length >= 4) {
            container.classList.add('app-list-collapsed'); 
            showMoreBtn.classList.remove('hidden'); 
            showMoreBtn.innerHTML = `Show More Devices <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>`;
        } else {
            container.classList.remove('app-list-collapsed'); 
            showMoreBtn.classList.add('hidden');
        }
        updateDashboard();
    }

    function addCustomItem() { 
        const id = 'c-' + Date.now(); 
        const defaultName = 'Device ' + customDeviceCount++;
        const html = `
            <div class="app-card custom-app-card" data-id="${id}">
                <div class="app-card-top" style="align-items: flex-start;">
                    <div class="app-card-left">
                        <div class="app-icon"><img src="${ICON_DEVICE}" alt=""></div>
                        <div class="app-info" style="flex:1;">
                            <div style="display: flex; align-items: center; gap: 6px;" class="custom-name-area">
                                <span class="custom-name-text app-title">${defaultName}</span>
                                <span class="btn-action icon-btn" data-action="edit-custom-name"><img src="${ICON_EDIT}"></span>
                                <input type="text" class="custom-name-input hidden" value="${defaultName}" maxlength="60" aria-label="Custom device name">
                                <span class="btn-action hidden icon-btn" data-action="save-custom-name"><img src="${ICON_CONFIRM}"></span>
                            </div>
                            <span class="app-desc subtext" style="margin-top: 8px;">120W / 1h/day</span>
                        </div>
                    </div>
                    <button type="button" class="btn-action" data-action="remove-custom" style="background: none; border: none; font-size: 20px; color: #a1a1a6; cursor: pointer; padding: 0;">✕</button>
                </div>
                <div class="app-expanded">
                    <div class="watts-input-wrapper">
                        <input type="number" class="inline-input live-watts" value="120" min="1" max="99999" step="1">
                        <span class="watts-label">W</span>
                    </div>
                    <div class="slider-wrapper">
                        <span class="slider-label">1h</span>
                        <input type="range" class="apple-slider" min="0.1" max="24" step="0.1" value="1">
                    </div>
                </div>
            </div>`;
        document.getElementById('add-custom-btn-wrapper').insertAdjacentHTML('beforebegin', html); 
        updateDashboard();
    }

    function resetAll() { 
        document.querySelectorAll('.app-check').forEach(chk => { 
            chk.checked = false; 
            chk.closest('.app-card').classList.remove('active'); 
        }); 
        document.querySelectorAll('.custom-app-card').forEach(card => card.remove()); 
        customDeviceCount = 1; 
        peakCheckState = {}; 
        updateDashboard(); 
    }

    function updateDashboard() {
        let currentWh = 0;
        document.querySelectorAll('.standard-app-card.active, .custom-app-card').forEach(card => { 
            const w = parseFloat(card.querySelector('.live-watts').value) || 0; 
            const h = parseFloat(card.querySelector('.apple-slider').value) || 0;
            currentWh += (w * h); 
            card.querySelector('.subtext').innerText = `${w}W / ${h}h/day`;
        });

        // 原来的这几行代码：
        // const selectedScenario = document.querySelector('input[name="main_scenario"]:checked');
        // const scenarioValue = selectedScenario ? selectedScenario.value : 'rv';
        // const maxCap = configData[scenarioValue]?.maxWh || 61440;

        // 替换为下面的代码：
        const selectedScenario = document.querySelector('input[name="main_scenario"]:checked');
        const scenarioValue = selectedScenario ? selectedScenario.value : 'rv';
        const subTypeId = document.querySelector('input[name="sub_type"]:checked')?.value;
        const subData = configData[scenarioValue]?.subtypes.find(s => s.id === subTypeId);
        const maxCap = subData?.maxWh || 11520;
        
        const capLabelEl = document.getElementById('max-cap-label'); 
        const kwhEl = document.getElementById('live-kwh'); 
        const barEl = document.getElementById('energy-bar');

        capLabelEl.innerText = `*Max Cap: ${(maxCap/1000).toFixed(2)}kWh`; 
        totalWh = currentWh; 
        kwhEl.innerText = (totalWh / 1000).toFixed(2);
        barEl.style.width = Math.min((totalWh / maxCap) * 100, 100) + "%";
        
        if (totalWh > maxCap) { 
            kwhEl.classList.add('warning'); 
            barEl.classList.add('warning'); 
            capLabelEl.classList.add('warning'); 
        } else { 
            kwhEl.classList.remove('warning'); 
            barEl.classList.remove('warning'); 
            capLabelEl.classList.remove('warning'); 
        }
        
        if(totalWh === 0) { 
            document.getElementById('btn-to-usage2').classList.add('disabled-state'); 
            document.getElementById('btn-to-usage2-mobile').classList.add('disabled-state'); 
        } else { 
            document.getElementById('btn-to-usage2').classList.remove('disabled-state'); 
            document.getElementById('btn-to-usage2-mobile').classList.remove('disabled-state'); 
        }
        
        if(document.getElementById('usage-container').classList.contains('usage-split-mode')) {
            renderPeakPowerList();
        }

        if (window.innerWidth > 768) {
            const container = document.getElementById('usage-container'); 
            const peakPane = document.getElementById('peak-power-pane');
            const action1 = document.getElementById('action-usage-1'); 
            const action2 = document.getElementById('action-usage-2');
            
            if (totalWh > 0 && container.classList.contains('usage-single-mode')) {
                container.className = 'usage-split-mode'; 
                peakPane.classList.remove('hidden'); 
                action1.classList.add('hidden'); 
                action2.classList.remove('hidden'); 
                renderPeakPowerList();
            } else if (totalWh === 0 && container.classList.contains('usage-split-mode')) {
                container.className = 'usage-single-mode'; 
                peakPane.classList.add('hidden'); 
                action1.classList.remove('hidden'); 
                action2.classList.add('hidden');
            }
        }
        
        updateStickyFooter(); 
        saveStateToCookie(); 
    }

    function renderPeakPowerList() {
        let html = '';
        const build = (id, name, w, icon, isCustom) => {
            if(peakCheckState[id] === undefined) peakCheckState[id] = true;
            return `
                <div class="peak-item">
                    <div class="peak-item-left">
                        <div class="app-icon"><img src="${icon || ICON_DEVICE}"></div>
                        <div class="app-info">
                            <span class="app-title">${name}</span>
                            <span class="app-desc">${w}W</span>
                        </div>
                    </div>
                    <input type="checkbox" class="peak-checkbox" data-id="${id}" data-watts="${w}" ${peakCheckState[id]?'checked':''}>
                </div>`;
        };
        
        document.querySelectorAll('.standard-app-card.active').forEach(card => { 
            html += build(card.dataset.id, card.dataset.name, parseFloat(card.querySelector('.live-watts').value)||0, card.querySelector('.app-icon img').src, false); 
        });
        
        document.querySelectorAll('.custom-app-card').forEach(card => { 
            const w = parseFloat(card.querySelector('.live-watts').value)||0; 
            if(w > 0) {
                html += build(card.dataset.id, card.querySelector('.custom-name-text').innerText, w, ICON_DEVICE, true); 
            }
        });
        
        document.getElementById('peak-list-container').innerHTML = html || '<div style="color: #a1a1a6; font-size: 14px; text-align: center; margin-top: 40px;">Toggle an appliance on the left to add it here.</div>';
        calculatePeakPower();
    }

    function calculatePeakPower() { 
        peakPowerW = 0; 
        document.querySelectorAll('.peak-checkbox:checked').forEach(chk => { 
            peakPowerW += parseFloat(chk.dataset.watts); 
        }); 
        
        const peakEl = document.getElementById('live-peak'); 
        const peakTipsEl = document.getElementById('peak-tips-label');
        peakEl.innerText = peakPowerW.toLocaleString(); 
        
        const scenario = document.querySelector('input[name="main_scenario"]:checked').value;
        const subType = document.querySelector('input[name="sub_type"]:checked').value; // 获取具体的子类型
        let e = totalWh / 1000;
        
        let peakLimit = (e <= 11.52) ? 3000 : 3500;
        
        if (scenario === 'tiny_house') {
            if (subType === 'th-w') {
                peakLimit = 3000; // Workshop 属于特例，在其 0-5.12 范围内均是 3000W
            } else {
                // Cabin (th-c) 和 Off-grid Home (th-o) 按照新规：0-3.84 是 3000W，大于 3.84 是 3500W
                peakLimit = (e <= 3.84) ? 3000 : 3500; 
            }
        }
     
        if (totalWh === 0) { 
            peakEl.classList.remove('warning'); 
            peakTipsEl.classList.add('hidden'); 
        } else if (peakPowerW > peakLimit) { 
            peakEl.classList.add('warning'); 
            peakTipsEl.innerText = `*Tips: max ${peakLimit}W`; 
            peakTipsEl.classList.remove('hidden'); 
        } else { 
            peakEl.classList.remove('warning'); 
            peakTipsEl.classList.add('hidden'); 
        }
        
        const btnToRec = document.getElementById('btn-to-rec'); 
        const btnToRecMobile = document.getElementById('btn-to-rec-mobile');
        
        if (totalWh === 0) { 
            if (btnToRec) btnToRec.classList.add('disabled-state'); 
            if (btnToRecMobile) btnToRecMobile.classList.add('disabled-state'); 
        } else { 
            if (btnToRec) btnToRec.classList.remove('disabled-state'); 
            if (btnToRecMobile) btnToRecMobile.classList.remove('disabled-state'); 
        }
        
        saveStateToCookie(); 
    }

    const pvSpecsDB = {
        "RSP120DC-ASR": { name: "120W, and keeps producing power even in partial shade.", dim: "41.42 x 22.76 x 1.18 in", weight: "15.87 lbs" }, 
        "RSP200DC-ASR": { name: "Best-selling anti-shading panel – 85% efficiency even in shade.", dim: "49.69 x 30.08 x 1.18 in", weight: "23.83 lbs" },
        "RSP100DC": { name: "25% efficiency with N-Type cells for higher output and durability", dim: "34.1 x 22.8 x 1.2 in", weight: "13.00 lbs" }, 
        "RSP200DC": { name: "N-type cell, and perfect for Class B van. ", dim: "49.7 x 30.1 x 1.2 in", weight: "23.40 lbs" },
        "RSP320DC-BKX2": { name: "Pair of 320W bifacial N-type panels – ideal for building installations", dim: "64.6 x 34.7 x 1.4 in", weight: "32.90 lbs" }, 
        "RSP590DCT-144X2": { name: "High-wattage bifacial pair with rear-side reflected light gain.", dim: "89.7 x 44.6 x 1.4 in", weight: "58.40 lbs" },
        "RSP100DL-36": { name: "Lightweight and bendable for tight or curved spaces.", dim: "43.0 x 22.9 x 0.1 in", weight: "5.30 lbs" }, 
        "RSP200DB-72": { name: "High power with flexible, space-saving design.", dim: "63.2 x 29.5 x 0.1 in", weight: "10.80 lbs" }
    };

    const recRules = {
        "rv": {
            "rv-suv": [
                {"c":"0<e<=2.56","t":"kit","ks":["KIT-RV-2.56"],"pv":{"options":[{"id":"RSP200DC","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":1,"wiring":"","spec":""},"inv":"INV-2000W-12V*1","oth":null},
                {"c":"2.56<e<=3.84","t":"kit","ks":["RKIT-RV-200ASR-D50-3840Wh"],"pv":{"options":[{"id":"RSP200DC-ASR","qty":1,"wiring":""}]},"ctrl":null,"batt":{"id":"RBT12300LFP-M","qty":1,"wiring":"","spec":""},"inv":"RIV1220PU-126*1","oth":{"id":"RBC50D1S","qty":1,"spec":""}},
                {"c":"3.84<e<=5.12","t":"kit","ks":["KIT-RV-5.12"],"pv":{"options":[{"id":"RSP200DC","qty":3,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":2,"wiring":"并联","spec":""},"inv":"INV-3000W-12V*1","oth":null},
                {"c":"5.12<e<=7.68","t":"kit","ks":["RKIT-RV-400ASR-D50-7680Wh"],"pv":{"options":[{"id":"RSP200DC-ASR","qty":2,"wiring":"并联"}]},"ctrl":null,"batt":{"id":"RBT12300LFP-M","qty":2,"wiring":"并联","spec":""},"inv":"RIV1230PU-126*1","oth":{"id":"RBC50D1S","qty":1,"spec":""}},
                {"c":"7.68<e<=10.24","t":"custom","ks":[],"pv":{"options":[{"id":"RSP120DC-ASR","qty":3,"wiring":"并联"},{"id":"RSP200DC-ASR","qty":2,"wiring":"并联"},{"id":"RSP100DC","qty":4,"wiring":"2串联2并联"},{"id":"RSP200DC","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-M","qty":4,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"10.24<e<=11.52","t":"custom","ks":[],"pv":{"options":[{"id":"RSP120DC-ASR","qty":3,"wiring":"并联"},{"id":"RSP200DC-ASR","qty":2,"wiring":"并联"},{"id":"RSP100DC","qty":4,"wiring":"2串联2并联"},{"id":"RSP200DC","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12300LFP-M","qty":3,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"e>11.52","t":"custom","ks":[],"pv":null,"ctrl":null,"batt":null,"inv":"-","oth":null}
            ],
            "rv-b": [
                {"c":"0<e<=2.56","t":"kit","ks":["KIT-RV-2.56"],"pv":{"options":[{"id":"RSP200DC","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":1,"wiring":"","spec":""},"inv":"INV-2000W-12V*1","oth":null},
                {"c":"2.56<e<=3.84","t":"kit","ks":["RKIT-RV-200ASR-D50-3840Wh"],"pv":{"options":[{"id":"RSP200DC-ASR","qty":1,"wiring":""}]},"ctrl":null,"batt":{"id":"RBT12300LFP-M","qty":1,"wiring":"","spec":""},"inv":"RIV1220PU-126*1","oth":{"id":"RBC50D1S","qty":1,"spec":""}},
                {"c":"3.84<e<=5.12","t":"kit","ks":["KIT-RV-5.12"],"pv":{"options":[{"id":"RSP200DC","qty":3,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":2,"wiring":"并联","spec":""},"inv":"INV-3000W-12V*1","oth":null},
                {"c":"5.12<e<=7.68","t":"kit","ks":["RKIT-RV-400ASR-D50-7680Wh"],"pv":{"options":[{"id":"RSP200DC-ASR","qty":2,"wiring":"并联"}]},"ctrl":null,"batt":{"id":"RBT12300LFP-M","qty":2,"wiring":"并联","spec":""},"inv":"RIV1230PU-126*1","oth":{"id":"RBC50D1S","qty":1,"spec":""}},
                {"c":"7.68<e<=10.24","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DC-ASR","qty":3,"wiring":"并联"},{"id":"RSP200DC","qty":3,"wiring":"并联"},{"id":"RSP320DC-BKX2","qty":1,"wiring":""}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-M","qty":4,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"10.24<e<=11.52","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DC-ASR","qty":3,"wiring":"并联"},{"id":"RSP200DC","qty":3,"wiring":"并联"},{"id":"RSP320DC-BKX2","qty":1,"wiring":""}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12300LFP-M","qty":3,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"e>11.52","t":"custom","ks":[],"pv":null,"ctrl":null,"batt":null,"inv":"-","oth":null}
            ],
            "rv-c": [
                {"c":"0<e<=2.56","t":"kit","ks":["KIT-RV-2.56"],"pv":{"options":[{"id":"RSP200DC","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":1,"wiring":"","spec":""},"inv":"INV-2000W-12V*1","oth":null},
                {"c":"2.56<e<=3.84","t":"kit","ks":["RKIT-RV-200ASR-D50-3840Wh"],"pv":{"options":[{"id":"RSP200DC-ASR","qty":1,"wiring":""}]},"ctrl":null,"batt":{"id":"RBT12300LFP-M","qty":1,"wiring":"","spec":""},"inv":"RIV1220PU-126*1","oth":{"id":"RBC50D1S","qty":1,"spec":""}},
                {"c":"3.84<e<=5.12","t":"kit","ks":["KIT-RV-5.12"],"pv":{"options":[{"id":"RSP200DC","qty":3,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":2,"wiring":"并联","spec":""},"inv":"INV-3000W-12V*1","oth":null},
                {"c":"5.12<e<=7.68","t":"kit","ks":["RKIT-RV-400ASR-D50-7680Wh"],"pv":{"options":[{"id":"RSP200DC-ASR","qty":2,"wiring":"并联"}]},"ctrl":null,"batt":{"id":"RBT12300LFP-M","qty":2,"wiring":"并联","spec":""},"inv":"RIV1230PU-126*1","oth":{"id":"RBC50D1S","qty":1,"spec":""}},
                {"c":"7.68<e<=10.24","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DC-ASR","qty":4,"wiring":"2串联2并联"},{"id":"RSP200DC","qty":4,"wiring":"2串联2并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-M","qty":4,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"10.24<e<=11.52","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DC-ASR","qty":4,"wiring":"2串联2并联"},{"id":"RSP200DC","qty":4,"wiring":"2串联2并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12300LFP-M","qty":3,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"e>11.52","t":"custom","ks":[],"pv":null,"ctrl":null,"batt":null,"inv":"-","oth":null}
            ],
            "rv-t": [
                {"c":"0<e<=2.56","t":"kit","ks":["KIT-RV-2.56"],"pv":{"options":[{"id":"RSP200DC","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":1,"wiring":"","spec":""},"inv":"INV-2000W-12V*1","oth":null},
                {"c":"2.56<e<=3.84","t":"kit","ks":["RKIT-RV-200ASR-D50-3840Wh"],"pv":{"options":[{"id":"RSP200DC-ASR","qty":1,"wiring":""}]},"ctrl":null,"batt":{"id":"RBT12300LFP-M","qty":1,"wiring":"","spec":""},"inv":"RIV1220PU-126*1","oth":{"id":"RBC50D1S","qty":1,"spec":""}},
                {"c":"3.84<e<=5.12","t":"kit","ks":["KIT-RV-5.12"],"pv":{"options":[{"id":"RSP200DC","qty":3,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":2,"wiring":"并联","spec":""},"inv":"INV-3000W-12V*1","oth":null},
                {"c":"5.12<e<=7.68","t":"kit","ks":["RKIT-RV-400ASR-D50-7680Wh"],"pv":{"options":[{"id":"RSP200DC-ASR","qty":2,"wiring":"并联"}]},"ctrl":null,"batt":{"id":"RBT12300LFP-M","qty":2,"wiring":"并联","spec":""},"inv":"RIV1230PU-126*1","oth":{"id":"RBC50D1S","qty":1,"spec":""}},
                {"c":"7.68<e<=10.24","t":"custom","ks":[],"pv":{"options":[{"id":"RSP590DCT-144X2","qty":1,"wiring":"并联"},{"id":"RSP200DC-ASR","qty":6,"wiring":"3串联2并联"},{"id":"RSP200DC","qty":6,"wiring":"3串联2并联"},{"id":"RSP320DC-BKX2","qty":2,"wiring":"2串联2并联"}]},"ctrl":{"id":"RNG-CTRL-RVR100","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-M","qty":4,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"10.24<e<=11.52","t":"custom","ks":[],"pv":{"options":[{"id":"RSP590DCT-144X2","qty":1,"wiring":"并联"},{"id":"RSP200DC-ASR","qty":6,"wiring":"3串联2并联"},{"id":"RSP200DC","qty":6,"wiring":"3串联2并联"},{"id":"RSP320DC-BKX2","qty":2,"wiring":"2串联2并联"}]},"ctrl":{"id":"RNG-CTRL-RVR100","qty":1,"spec":""},"batt":{"id":"RBT12300LFP-M","qty":3,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"11.52<e<=15.36","t":"custom","ks":[],"pv":{"options":[{"id":"RSP590DCT-144X2","qty":1,"wiring":"串联"},{"id":"RSP200DC-ASR","qty":6,"wiring":"3串联2并联"},{"id":"RSP200DC","qty":6,"wiring":"3串联2并联"},{"id":"RSP320DC-BKX2","qty":2,"wiring":"2串联2并联"}]},"ctrl":null,"batt":{"id":"RBT12300LFP-M","qty":4,"wiring":"串联","spec":""},"inv":"见注2","oth":null},
                {"c":"15.36<e<=20.48","t":"custom","ks":[],"pv":{"options":[{"id":"RSP590DCT-144X2","qty":1,"wiring":"串联"},{"id":"RSP200DC-ASR","qty":6,"wiring":"3串联2并联"},{"id":"RSP200DC","qty":6,"wiring":"3串联2并联"},{"id":"RSP320DC-BKX2","qty":2,"wiring":"2串联2并联"}]},"ctrl":null,"batt":{"id":"RBT12200LFP-M","qty":8,"wiring":"4串联2并联","spec":""},"inv":"见注2","oth":null},
                {"c":"e>20.48","t":"custom","ks":[],"pv":null,"ctrl":null,"batt":null,"inv":"-","oth":null}
            ]
        },
        "marine": {
            "marine-f": [
                {"c":"0<e<=2.56","t":"kit","ks":["KIT-SAIL-2.56"],"pv":{"options":[{"id":"RSP200DB-72","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":1,"wiring":"","spec":""},"inv":"INV-2000W-12V*1","oth":null},
                {"c":"2.56<e<=5.12","t":"kit","ks":["KIT-SAIL-5.12"],"pv":{"options":[{"id":"RSP200DB-72","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":2,"wiring":"并联","spec":""},"inv":"RIV1230RCL-1SS*1","oth":null},
                {"c":"5.12<e<=7.68","t":"custom","ks":[],"pv":{"options":[{"id":"RSP100DL-36","qty":4,"wiring":"2串联2并联"},{"id":"RSP200DB-72","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12300LFP-M","qty":2,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"7.68<e<=10.24","t":"custom","ks":[],"pv":{"options":[{"id":"RSP100DL-36","qty":4,"wiring":"2串联2并联"},{"id":"RSP200DB-72","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-M","qty":4,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"10.24<e<=11.52","t":"custom","ks":[],"pv":{"options":[{"id":"RSP100DL-36","qty":4,"wiring":"2串联2并联"},{"id":"RSP200DB-72","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12300LFP-M","qty":3,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"e>11.52","t":"custom","ks":[],"pv":null,"ctrl":null,"batt":null,"inv":"-","oth":null}
            ],
            "marine-s": [
                {"c":"0<e<=2.56","t":"kit","ks":["KIT-SAIL-2.56"],"pv":{"options":[{"id":"RSP200DB-72","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":1,"wiring":"","spec":""},"inv":"INV-2000W-12V*1","oth":null},
                {"c":"2.56<e<=5.12","t":"kit","ks":["KIT-SAIL-5.12"],"pv":{"options":[{"id":"RSP200DB-72","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":2,"wiring":"并联","spec":""},"inv":"RIV1230RCL-1SS*1","oth":null},
                {"c":"5.12<e<=7.68","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DB-72","qty":3,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12300LFP-M","qty":2,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"7.68<e<=10.24","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DB-72","qty":3,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-M","qty":4,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"10.24<e<=11.52","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DB-72","qty":3,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12300LFP-M","qty":3,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"e>11.52","t":"custom","ks":[],"pv":null,"ctrl":null,"batt":null,"inv":"-","oth":null}
            ],
            "marine-y": [
                {"c":"0<e<=2.56","t":"kit","ks":["KIT-SAIL-2.56"],"pv":{"options":[{"id":"RSP200DB-72","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":1,"wiring":"","spec":""},"inv":"INV-2000W-12V*1","oth":null},
                {"c":"2.56<e<=5.12","t":"kit","ks":["KIT-SAIL-5.12"],"pv":{"options":[{"id":"RSP200DB-72","qty":2,"wiring":"并联"}]},"ctrl":{"id":"RNG-CTRL-RVR60","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":2,"wiring":"并联","spec":""},"inv":"RIV1230RCL-1SS*1","oth":null},
                {"c":"5.12<e<=7.68","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DB-72","qty":6,"wiring":"3串联2并联"},{"id":"RSP590DCT-144X2","qty":1,"wiring":"并联"},{"id":"RSP200DC-ASR","qty":6,"wiring":"3串联2并联"},{"id":"RSP200DC","qty":6,"wiring":"3串联2并联"},{"id":"RSP320DC-BKX2","qty":2,"wiring":"2串联2并联"}]},"ctrl":{"id":"RNG-CTRL-RVR100","qty":1,"spec":""},"batt":{"id":"RBT12300LFP-M","qty":2,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"7.68<e<=10.24","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DB-72","qty":6,"wiring":"3串联2并联"},{"id":"RSP590DCT-144X2","qty":1,"wiring":"并联"},{"id":"RSP200DC-ASR","qty":6,"wiring":"3串联2并联"},{"id":"RSP200DC","qty":6,"wiring":"3串联2并联"},{"id":"RSP320DC-BKX2","qty":2,"wiring":"2串联2并联"}]},"ctrl":{"id":"RNG-CTRL-RVR100","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-M","qty":4,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"10.24<e<=11.52","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DB-72","qty":6,"wiring":"3串联2并联"},{"id":"RSP590DCT-144X2","qty":1,"wiring":"并联"},{"id":"RSP200DC-ASR","qty":6,"wiring":"3串联2并联"},{"id":"RSP200DC","qty":6,"wiring":"3串联2并联"},{"id":"RSP320DC-BKX2","qty":2,"wiring":"2串联2并联"}]},"ctrl":{"id":"RNG-CTRL-RVR100","qty":1,"spec":""},"batt":{"id":"RBT12300LFP-M","qty":3,"wiring":"并联","spec":""},"inv":"见注1","oth":null},
                {"c":"11.52<e<=15.36","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DB-72","qty":8,"wiring":"4串联2并联"},{"id":"RSP590DCT-144X2","qty":1,"wiring":"串联"},{"id":"RSP200DC-ASR","qty":6,"wiring":"3串联2并联"},{"id":"RSP200DC","qty":6,"wiring":"3串联2并联"},{"id":"RSP320DC-BKX2","qty":2,"wiring":"2串联2并联"}]},"ctrl":null,"batt":{"id":"RBT12300LFP-M","qty":4,"wiring":"串联","spec":""},"inv":"见注2","oth":null},
                {"c":"15.36<e<=20.48","t":"custom","ks":[],"pv":{"options":[{"id":"RSP200DB-72","qty":8,"wiring":"4串联2并联"},{"id":"RSP590DCT-144X2","qty":1,"wiring":"串联"},{"id":"RSP200DC-ASR","qty":6,"wiring":"3串联2并联"},{"id":"RSP200DC","qty":6,"wiring":"3串联2并联"},{"id":"RSP320DC-BKX2","qty":2,"wiring":"2串联2并联"}]},"ctrl":null,"batt":{"id":"RBT12200LFP-M","qty":8,"wiring":"4串联2并联","spec":""},"inv":"见注2","oth":null},
                {"c":"e>20.48","t":"custom","ks":[],"pv":null,"ctrl":null,"batt":null,"inv":"-","oth":null}
            ]
        },
        "tiny_house": {
            "th-c": [
                {"c":"0<e<=3.84","t":"kit","ks":["KIT-12V-3.6"],"pv":{"options":[{"id":"RSP100DC","qty":4,"wiring":"2串联2并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12100LFP-BT","qty":3,"wiring":"并联","spec":""},"inv":"INV-3000W-12V*1","oth":null},
                {"c":"3.84<e<=10.24","t":"kit","ks":["KIT-48V-9.6-LI"],"pv":{"options":[{"id":"RSP320DC-BKX2","qty":2,"wiring":"2串联2并联"}]},"ctrl":null,"batt":{"id":"RBT12200LFP-M","qty":4,"wiring":"串联","spec":""},"inv":"RIV4835PCS-1SS*1","oth":null},
                {"c":"10.24<e<=20.48","t":"kit","ks":["KIT-48V-19.2"],"pv":{"options":[{"id":"RSP320DC-BKX2","qty":4,"wiring":"4串联2并联"}]},"ctrl":null,"batt":{"id":"RBT12200LFP-M","qty":8,"wiring":"4串联2并联","spec":""},"inv":"RIV4835PCS-1SS*1","oth":null},
                {"c":"e>20.48","t":"custom","ks":[],"pv":null,"ctrl":null,"batt":null,"inv":"-","oth":null}
            ],
            "th-o": [
                {"c":"0<e<=3.84","t":"kit","ks":["KIT-12V-3.6"],"pv":{"options":[{"id":"RSP100DC","qty":4,"wiring":"2串联2并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12100LFP-BT","qty":3,"wiring":"并联","spec":""},"inv":"INV-3000W-12V*1","oth":null},
                {"c":"3.84<e<=10.24","t":"kit","ks":["KIT-48V-9.6-LI"],"pv":{"options":[{"id":"RSP320DC-BKX2","qty":2,"wiring":"2串联2并联"}]},"ctrl":null,"batt":{"id":"RBT12200LFP-M","qty":4,"wiring":"串联","spec":""},"inv":"RIV4835PCS-1SS*1","oth":null},
                {"c":"10.24<e<=20.48","t":"kit","ks":["KIT-48V-19.2"],"pv":{"options":[{"id":"RSP320DC-BKX2","qty":4,"wiring":"4串联2并联"}]},"ctrl":null,"batt":{"id":"RBT12200LFP-M","qty":8,"wiring":"4串联2并联","spec":""},"inv":"RIV4835PCS-1SS*1","oth":null},
                {"c":"e>20.48","t":"custom","ks":[],"pv":null,"ctrl":null,"batt":null,"inv":"-","oth":null}
            ],
            "th-w": [
                {"c":"0<e<=5.12","t":"kit","ks":["KIT-WS-5.12"],"pv":{"options":[{"id":"RSP100DC","qty":4,"wiring":"2串联2并联"}]},"ctrl":{"id":"RNG-CTRL-RVR40","qty":1,"spec":""},"batt":{"id":"RBT12200LFP-BT","qty":2,"wiring":"并联","spec":""},"inv":"INV-3000W-12V*1","oth":null},
                {"c":"e>5.12","t":"custom","ks":[],"pv":null,"ctrl":null,"batt":null,"inv":"-","oth":null}
            ]
        }
    };

    function calculateRecommendation(totalWh,peakPowerW, scenario, subtype) {
        let e = totalWh / 1000; 
        let P = peakPowerW;
        
        if (e === 0) return { error: true };

        let rec = { 
            type: '', 
            titles: [], 
            spec: e.toFixed(2) + 'kWh', 
            sysVoltage: 12, 
            pv: null, 
            battery: null, 
            controller: null, 
            inverter: { id: '', spec: '', warning: '' }, 
            other: null 
        };
        
        const rules = recRules[scenario]?.[subtype]; 
        if (!rules) return { error: true };

        let matched = null;
        for (let r of rules) {
            let valid = false;
            if (r.c.includes('<e<=')) { 
                let parts = r.c.split('<e<='); 
                valid = e > parseFloat(parts[0]) && e <= parseFloat(parts[1]); 
            } else if (r.c.includes('e>')) { 
                valid = e > parseFloat(r.c.replace('e>', '')); 
            }
            if (valid) { 
                matched = r; 
                break; 
            }
        }

        if (!matched || matched.c.includes('e>')) return { error: true };

        // 新代码：利用逻辑或 (||) 提供默认值，防止赋值为 undefined
rec.type = matched.t || 'custom'; 
rec.titles = matched.ks || []; 
rec.pv = matched.pv || null; 
rec.controller = matched.ctrl || null; 
rec.battery = matched.batt || null; 

// 重点修复了逆变器的读取逻辑，确保即使 matched.inv 为空，也能安全返回 '-'
rec.inverter.id = (typeof matched.inv === 'string') ? matched.inv.replace(/\*\d+$/, '') : (matched.inv ? matched.inv.id : '-'); 
rec.other = matched.oth || null;
        
        let sysVoltage = (e <= 11.52) ? 12 : 48; 
        rec.sysVoltage = sysVoltage; 
        
        if (rec.inverter.id === '见注1' || rec.inverter.id === '见注2') {
            if (sysVoltage === 12) {
                if (P <= 1000) { 
                    rec.inverter.id = "INV-1000W-12V"; 
                    rec.inverter.spec = "1000W"; 
                } else if (P <= 2000) { 
                    rec.inverter.id = "INV-2000W-12V"; 
                    rec.inverter.spec = "2000W"; 
                } else { 
                    rec.inverter.id = "INV-3000W-12V"; 
                    rec.inverter.spec = "3000W"; 
                    if (P > 3000) rec.inverter.warning = "Your system is designed to comfortably handle up to 3000W of continuous power. For maximum reliability, we suggest staying within this limit."; 
                }
            } else {
                rec.inverter.id = "INV-3500W-48V"; 
                rec.inverter.spec = "3500W";
                if (P > 3500) rec.inverter.warning = "Total peak power exceeds inverter output capacity. We recommend keeping simultaneous device usage under 3500W.";
            }
        } else {
            let invMatch = rec.inverter.id.match(/(\d+)W/); 
            if (!invMatch && rec.inverter.id.includes('3000')) invMatch = [null, 3000];
            if (invMatch) {
                let limit = parseInt(invMatch[1]); 
                rec.inverter.spec = limit + "W";
                if (P > limit && rec.type === 'custom') { 
                    rec.inverter.warning = `Total peak power exceeds inverter output capacity. We recommend keeping simultaneous device usage under ${limit}W.`; 
                }
            }
        }
        return rec;
    }

    const getDBInfo = (id) => { 
        return productDB[id] || { id: id, title: id, price: "$TBD", url: "#", pic: "https://placehold.co/200x200/f8f9fa/a0aec0?text=Image+Not+Found", variant_id: "" }; 
    };

    /* ========================================================================
       Proposal export contract
       The browser-generated document is deliberately data-first: the PDF is
       built from this snapshot rather than from the visible recommendation DOM.
       ======================================================================== */
    const PROPOSAL_PDF_FORMAT = Object.freeze({
        version: '1.1',
        title: 'Renogy Power System Recommendation',
        filenamePrefix: 'power-system-recommendation',
        page: Object.freeze({ orientation: 'portrait', unit: 'mm', format: 'a4' }),
        margin: Object.freeze({ top: 18, right: 14, bottom: 16, left: 14 }),
        colors: Object.freeze({
            brand: [0, 51, 153],
            ink: [29, 29, 31],
            muted: [104, 104, 110],
            pale: [244, 247, 252],
            line: [220, 225, 235],
            warning: [230, 81, 0]
        }),
        sections: Object.freeze([
            'System overview',
            'Appliance load summary',
            'Recommended components',
            'Connection notes',
            'Important system note'
        ])
    });

    // Embedded from the user-supplied Renogy_Logo.png so PDF export has no file-path or network dependency.
    const RENOGY_LOGO_PNG_DATA_URL = 'data:image/png;base64,' + [
        'iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAIAAAAErfB6AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVY',
        'dFNvZnR3YXJlAFBhaW50Lk5FVCA1LjEuOBtp6qgAAAC2ZVhJZklJKgAIAAAABQAaAQUAAQAAAEoAAAAbAQUAAQAAAFIAAAAoAQMAAQAAAAIAAAAxAQIAEAAA',
        'AFoAAABphwQAAQAAAGoAAAAAAAAAYAAAAAEAAABgAAAAAQAAAFBhaW50Lk5FVCA1LjEuOAADAACQBwAEAAAAMDIzMAGgAwABAAAAAQAAAAWgBAABAAAAlAAA',
        'AAAAAAACAAEAAgAEAAAAUjk4AAIABwAEAAAAMDEwMAAAAACrgCETU544KAAAPmVJREFUeF7tvWmwZclx3/fLrDrn3vteL7MAGAAcbBxwGVAiGCJIyxRJiQtC',
        'NMVFmyWZkCXZEQpJEfpif7E+OMIK2+HwFgrbYWuhIiyHbdGWHUE5RC3UykUkxX2nQIAEiMEAM713v+3ee86pyvSHPOe+1/1eT9/XPTPCNPsfZ2pu33dPnTqV',
        'VVmZWZlZ4u48weMLvfeLJ3i88ITAjzmeEPgxxxMCP+Z4QuDHHE8I/JjjCYEfczwh8GOOJwR+zPGEwI85ZBtTZfxC7vl34PjbE9+f/HILjPX7iRvHzzb9Ve/b',
        'gPM/7sE4+cLxedO2u1u47Ru/0Q2+Px5MYAfDAEXl5AsHThN47Ag78YfXgqPxU3XG+gUc1MA8iIyCagyC6avjHr/riRNPurdPt20PMa5EXRjv2zxOj4ddtLOg',
        'BukUJ5TxngmbxrjeO1DeYLxOBA6SbL4/L+M/fv8Tby7mmI1fjQRmQ+OTfXQv8ZST7dyMgC3h4IZQRR1yEDTmq5ptqOyAFsGguYf93NU/91BaeROpuxWBN60d',
        'W3U3ae8h9NihTgz/bSAOFDzmr0x8T2NUnRgtGh8NKmXzhOhujTuPf7lpicI5GhMQcKyHIHDUb9iAGyQko8n1eDie7MKTn2NsCcF0nHH2p5gqbwq2IvBdmN4q',
        'btuMz82knUb3udBBQTT6c2LaemKuwDSIKlapTswlBFGQzfwefxrt2ozMfK4WGThWgLsIzIAZJDSjaaLYSMV7cGLN3lB3WkLsC4/A94zK4+bavTN4s1JuDzEY',
        'YtZulrOxhpPlpktOdNyGfZ6EgGJQhVg/FZoTI/ABiCWpgo+0ZKxG8DQSKW3I5ZBwKUb0owCG6qnHbZo/jto3C/e24wzcl7rHfznZ+gnxk21KnGQkSILKSUkq',
        'PhyLUdMHB0McMZKTfPzLmXMJJhI525SCKZawBCmeNY2zzePYNCbhglGdAsWohoMZdlI4Cx4QFZ5v9D8ytpjBJ4WaieHE3D1NV4l/PajKe7Eh2+bGia6xfMYT',
        'daS5CPmuX94D2ci+m7+lUbrZEseiMzBJRuhJvQgAqwCWqNMbbESC8XGj8HXXbRZVvTk4H4F9Ev8dixaexXDO05WBE53Jht53ySaheJgGxb3hTNJusGnTqcY9',
        'GBu2gU0y8GaAH7+dQ4WKARlN4813D+6Tn6PC+LBRlt54bE3g4+l7PHfVXUQwxxnf0R2VCkYFFRxCQFGnCmkcvyfKBBIrnoJSwTEwA3dP0kTPJI1OHUiJ4mhC',
        'oA7khIAFd5+61E+s4hIz8N7n3q8UiEYAnmI2jxOU6rjggiaSlEn6j1Eev9WYr0H/IPu4cmyGS4yS80+Dh8IWjzmxsp3kehrk9NBC0kh8I0aMINM8fHDJxNUq',
        'VhkqQ6WCZ5HkVSup+tjpqQElJWoByGnVHXXD2rVWrE4r38heJpx+4muX4ycFoSAraiF6IUMKydqKu5siCawc31gr8f40jDfdXbWzXbe/TthiBm/mwUhgi9aO',
        'AogBio2S42j9OXHXg8sJVUqlGiVYWIOKKZbxBFgxSy5tKu7N5gkS0oAZtjERCYCm6MSTAsSZTz+zhFLHlww+7LhXvyCZDggqO+pQaykpzTY3IjhW8Wo1aR5Z',
        'wkjSN0872uDcBJ5IisTHCkBShCrjNGtPGXBeGy7uYnas4FpCM1msHeuPPlXKpIkCpRYza5tQZExRn359UugTV3waettAqIpDAqdWzBDIAu1GfxBMMB9yMH9L',
        'AFbNq6lokokdR0NE0VOa+puErQkcb87dBHalVFJCKEIPBQQW0+pzLpweEmKIBNsnZ6p11YcmJdBaLacGtPQ1pUaE2ntqR3OWS8gKo9Sd0Jg9p+fq6bJCD4rP',
        'rGBGjnapo+KNFYqOM9thjquL27QOY45VTEa1eOwq4djU+ibTeAsCnxKyYjoRBK6QqBK2KHoY4AAG2Ag2pzvxnjK6MJ1481hKazADaOApmMOM0lAFHCmeTTSe',
        'OMARDFCne0/ivCuewgKegl1oKZQedbT1moakR3AIa+ghwWx6kbCntNBABqW2G7oTQ2TEFySBY3WRUwQGFzpYQ4Gbtf7Y517927/68o3ZAhOjiivq4upiZ5ZV',
        'RyG1NUuGuLpor1pUTKWul5fUXtid/e53veOjL7zzvTB3a4a+aedHcAc+Az/8G1d+7Dc+e828n817zVVRR70kL9k9ZHCTINy9MvPpUt3K6uhLn3n62z/4xd/8',
        'zsVzcAHXfk3TdKZHST8F/+xTN37myvWX95frkhY7O+2Myzvt+596+svfcflLLvA8vA0uwhzSZAULphdLyFm65RuFLQgcE+pYgoj/x3LsSKoyzt1b8I9++Vf/',
        '6r/48b0Pfc212UVzqbijqIgDUU4QDwHcJjkzmSUjuVaRImoJVOlXu2qLw/3na/exr/7KP/Huy88YO0IxjhKfhr/z6Rv/4Nd/8/OD16fedijJkiCKg5uaZzOg',
        'Tnt/20CwRUp64/qHFu33fPhDf/i59jnIpUOkpPZV+L7PH/6dX/y1z1SpF57uvTFNVdYzKZf6ulitnx66L7504Wve/76vfP6pFxfswgWYhdomVGHcodoIocfm',
        '3o0IZhCWBn303aftCBxwJsF1NDtgimh1BsXgt4w/+T/81U9KK89/sF56Ku8sBsldqFIopGQqoG5AVavqI/cc1ZoKJEtAVQUEwYp6bak78ML64H//tq/5ICSn',
        'Cofw885/9IM//ZnZhSKzQbRoDBcnNGNI5oCL3KM4vQbUXZGmDrtWP6z9937Th98LmQJa0d+E//Cf/Nwn2t1DGCSJNaRcdYC609OaqZfkVSnzOrx4+anf/+KX',
        'fuvTPAe7lZ1RfKupiqjiXm1IWVel09wKqR3tJAWpFVOyWENsOG/d/nuw1fI0DgEx7jKlxidTHTnQavBbpKU2RzdvDof79IOXNVZolCaDuwRXV5Og7dTqEHSF',
        'kGCrBLc0dcQxSavU3m4We01bosWTQa2r3JG0l2drzZV8wh45rsIuci7qAiZi0Em6k5s7mkMtCv3ejBXc8XwnzbqUTNVVJvae1jkdNM2d2eL64sLVncuf233q',
        'J9bd//TjP/OX/skv/b1rdiVxS1kBJAl5SySltO5WbW772mtQd5zWjO9wwgjxcNiKwPfFidlvUEoxM8xZr+v1G4c3r+ehLlLSUiiDpGSCqQWbkpA6LHj0fSGh',
        '1rpb4MQzJ6N+GPZfT4iIu5tZrXWjpomIOwa1VosnioTs1A7kgglVMVF1cpFkupR0Zbf5yXn5L3/+R/7zX/rET1T2iBrA8dIjPp8tyjBcSLteok4crTTQQCpC',
        'TedQ8U7j9SHwsblGRJOSE6s1N2+t925L32UzNcMrmImFsQ8QVzVVU33NnYCRxuAnlpO7RraM2Hzx6FDVkxWqKoQ+ePxVENj9RP8HV3JVV/FEnvU7F26av3rx',
        'wr+4ce2//Sc/+v999vBlOMwcOda01SqQSPQ0OkqsRuhUObyWNiPs4fBaPftgHKt2yNQL4kjtJSu12PUby2tX21J2skodkIqYqZmYo9ER6vrgHTSRkY6TpWqk',
        'sSDxn5xHmNgOrzFi7hpzwqCUE35ZwZVCkK8HNS/e3tvOqz77eDv/Xz79yf/q45/7VThIrMFVailZZ7J26mgpSpA2tnRib/vh8WgEhpN8OtiaeaFWtQEb6Dv2',
        '945u3fDVcp5FKeMuroxLjIa97z4YzdonOjo+bWjpPn6OR29+9ojYVHXiQSP7MDCz8fsoReyk3uMWNK6iTbuz2Hmm7JeUL+nFd96Q9pO5+YHPf+5v/vKnPg53',
        'oKfV1GAwE3qOZQfAST7asx8FrwOBN9h0R0pSa0cdSDB0fvPG0Y1rvl5lM/Uyrp6hVY8caSucZNHTN3f/+3XC6UUhvtk8biMZjP8O4cgd9xjBptTE+vBgtVzN',
        'FhdtLbXTvPO26vNbs4s/+MrVv/5zH/8MHEANO5tAS0ieFUMKBjVcDB7Jgr1t574GTnIyEVFVo6asOataYRgYOo4OV9evNVaPaSxmYiF2nVeIuJd5iqhqLBCv',
        'C06u6JshFN/FSnRyBCgpmJAeu6A4aoixu0g7834YzNyMsnJ8VnXn4NKzP/zK1b/1s7/2KqzASvBlwnFw4smFk24tD4vXrVM2/W7uplTx6sW9ijjuLFfcvLW+',
        'dZNuPUfaadfU1Cw9QI05NW9H+GYNdj9mm68HguHHut5M34x/2vzILPScWqs6uSJOstDyDSpa0aF65w00qsjMdWeQWa/rkvZ2n/2hg+5v/MpLByANQ6Jo7LLY',
        '6LGUIMVa9kh4PQl8F8RcQEwwccMLVuv1a2V/T7q1dyvKQHISeLgvvoUReoG4TDpfKDw2XsQOtWl0BXhqOmlflZ1/+fk7//iz5ZqyhkoZnUTCKoASbgGPZth8',
        'YwgsIKPQ7yDuI427ld26eXTrRlPLolG1AetJYSt4q8LDOLPZCw+xUQwHr3jFS3KDMmhZtbXL1YchtburYXGNS9/7i7/0E5U1ZMLma66KKKa4dmLr0fPrIfHG',
        'EPjual1MqOJVcmZ1xO1b3f6d0I/FDC+vIUi/NSBjqIszGb03a2eI2zLaMC0Zaqh48dni6YM8/6Sm//uXP3UHOlIZxaxjFGwY9z0fEm8MgcM/DgV1NVfz4FSl',
        'JyX6oV69trx6pRmGhSLDcG8kz1sOpthoyXKw2CTw8EyRcHW3sCc7Wplp9lL7YbVOfvTMUz917doPXb1zh3bJrJJGpi5UYXT1uvd558DrT2ABNRWbdkIg+Bhi',
        'bkWt4IWhZ/9gefsmq24n5wcbOr6AMclW42oZpnl11XABtY3X7XFsTSllNmt8OKKhEw6axff/wr++Cmsmw8a0fdei7Vlu9Nvj4e+8H8Q1uahNm4PjVqi5kJJY',
        'HaRWTYlS/eat5a0b3nevfyP+TWG0tKmJiEuu2hbNRbVo2KlBTbXC2rr8TEO53WLrqr/a139+QAd5dFcoQZtsmm0LS9/9sVXfim8kw5OG7/HTtJmNiTuYbExK',
        'k7PkOLqphqqqitWBfkW/5vBgee1KY11rVU3xhI+7pWHznBST8Vl1tM1OlqYztyrc8Ah88EnniO91q9JVXGV6z+ggF3U0XiPUd1BcZHq1CfGygsdqqqDqqKt6',
        'VCYgkhNeS9+xs+hXS71wYe/C5R/4pY934aA72dmFR1WCtyOwR5eNzkqjy3G8WHSCW0RogZVknq1mn6RKGYV+z5BJyVSrgBhZEGN1wM2r/c1X8mpvYbPWL8Qu',
        'CuIiA9K7FiNjrZoiVqBQoAol9qJqTJrYtxPAW7NsBSloQco0GhSJNj+gVNdcNbkCPoXSDEi4WSpUNVdiLIoncXHRieTTJWqiRdlcFvXHADJDMzTUxHx+aOWw',
        'nb90cPDxfVajv2oelSY1UjmfC+Pd2ILAQWM4NhtvxtRmT2cU/k60Y/p+VBJPXoGYZ2ZYGW5cscMD7Qf6Qi0kIYtHMBAx/EV9o/dHm3XiD4TZNvYt1EV8syJm',
        'PDyZpyduVVpVq9OmSNy66SYHP9HdLtWlmhTE4t7jesRgqmTShnHARlXKGqzBEyia16n5xZdfOoD1JowJIkh687iHwHYEnohyHDslhO++M1YikFxzDQVu4i1b',
        'Xt2wvnH94NYVtaNZNryj9qRsZLxRk2wkt2zaQkbxRtEEuZKrpqrZwpakeHaaygxfYDvYDjZTBwZl2Ka0NJS2q7OuplK1hk0pG4nwyw82DlLRoeTOcoecUc/9',
        'SnUntkqL6qBtn/OQqFIl/9RLL1+DA1hJTHpwfYCd70HYmsCTyD4hdvbvGl3JNLloVfFYrLe6wMmJfsmdV7vDawx7ygoG3BAdtyLEJ9/pYwTzjKUBzLVUNVPr',
        'E1UUj9Uhb95xNDJtUW6w4RBiiFOpBcSzhH01pmlM37PqObM0sarmUpEqVMGifV3Sl7rhM9BPvqFVYmU5Z+Tc3djizngMqmEmNXCm0Ct8mt/qiIu4Ckjsh2x/',
        '0dMYfug3P93d/K22HqZGsD6e71Krlr7p180wQAmlK2QYx8Vqql0zdHng5KUDDEiPVGPD9ba4POW+SX3bDG1T0uQ/6kgZKD3gKdemKW1bGjyC1mMh2O5SyJ01',
        'K8urmrshDX0eSHWV5WDnwq/dGhxmUHGJBU0eKVJtCwJPJDx+yuhWHtQe4+nGLe4N3z09Ve9zQbg8GVbpV+zdXt+8bsuVpkarJlPxce23cbNl/Dw+VAy1quax',
        'gbNppZmaZfNpTTlDnjq7dFXXpqZkaXQ1OY69ilGV1VqNtXOUNCPPwFm1nS5DzGb0cbNp/pjkZXPxE69cT9A44fBbY0BP7/QQ2IrAQbMREt+EDMsmRNqhKCWZ',
        'JVwS3mx7WaO0dBF3MqevXLvj1/fS0puasqVkSS1jeTakXWgrEX9QRzWpTJ6nSmzD1qwlzYY8H1JbJVuMu40E9KBSrCpDWCmEAXqh09HNvRn9PlOv2o9GpuBp',
        'p+q5bymUOWVBWWidpbrQuqA2YrPO59dv9wkoRFBlEPhRsBWBJygYoeRM1B2ZNlh4wm7UuNMj974l7mhuRDIVOqer7B0N167Nas2j3+u0EMR4YnwiMkn2UZUl',
        'TNVi6TbXWlItqcQKsv3lYqa1ihe1KVRCHFXyyD+iO9yg4Ba86zyXqKXJV0nEw4M0H7ku7djoMFi3UVMeGuci8IZ4xJ1pY1cDg3UZwnUdq1glFKHNFVF3py93',
        'Vzcxd8Sk9dxW5PCQ61eXVz7Xsk4LqWkgFdvRo0iLMnJNaq02FFyRTIwUc8OqlHVer5plv9ivzdKkSJUtL8zxoq2V1NmM5fSs8IvugKyiZeYl9Z1063mbU/XT',
        '9dzvwty9mPSmvWtv9CYd0pkOdSY3y+pOOEJDK032MXjnoXFOAsMU3KAC9IWwmhrAzu6sljVDh4okTaqioiIxA3FTVVROl6ijgiSRJKIZmZunWsrtq3s3XxnW',
        'e3iPDaVfNqOjwziPxfXS4qJUpxQ0IQlNiIQxilxJRvDoeMQWZXjx1epYyeilCOuuMa5SC6vhqB+OzMvOzk7TzteHa+SMeu5XikT3hHkGb9yTkYTk+Ho5LFME',
        'uVQP/2kvj7IEb0fgSRu5C4oi4e8wjjgf1m2/3smqVqnF61RGZLbV42/u+msJ/2bMzBicwd2siPWixW5dGfav7WTfFZrVABiOkyUeK93BUUuW2WzyYxUsopoS',
        'paFXCuBVrUrdqhR3mbfs5D6lw34GrZGd7FPwai7tQkry/cF6mzG7VDWWp7NqO12Ka3UdEHOPbXKJpXZo52LD4QqqkFJydzDVMI88JLYi8CmoIBJR/CGACQIL',
        '6vsvXNS9veyVyZ9B1DXxWteoaTriJLfkJWNptPexvMWVz60/99LFO4cv7Dy1A02sC4UEz+1wufju0KdhTXeEgpAkZ7LKTJiJ7+BzJKNKki1LH4quhme6+sL8',
        'UjtJUdQ6QzO8c8asu5OkpDYRtljVM+s5sxRVkSySPVoV3EXIVvXg9rsutExkEXPC8e4NN1XejWk2a6zDNHTVEuX52cXv+PDves6YWXUxozrVw7mOer/L3aW6',
        'lEg91pOL52FIXrXacMSFeZYqL7986crtr33m+V1DwmVv6H0oz8LXv/CBd9Vhcbg3a9C6VOtTrWLiplLbNMzy0GqZZIUtLjVbNLJbj75c5Vve9975GGNsZMnw',
        'HHzLB97zXL9vq6vu+3lY5b7XMWx9q0uqFk+FmYcC7UL1PPjFvj6zPPi9X/bCUwDUISTHgvfw8ATezl98EzAz/TbssWJKaEfYjNrR/Mba/t7P/dL3/asfO0hq',
        'oeZJAnOXzWdCGp9KcdQ8jDVFWTfFRNuSkkNySpeG4R2Lp771q7/hz3zDl78f5j1gNCC2T/44/J8/+9mfuvKZfcVTi6ds6uReG1xbM3ErqbqGLGYPLAWrw+r9',
        'Ozvf/Ny7//jveOf7nFypMlRFaA6FT8P/+4nP/Kvr16+uB1bs7Fxa9V3V2N6/t7YzSsCTpVREnSGzaqu3db5b+2/88Hv+wPve9SI863iJ/DQdXtDZJiTxvDgP',
        'geOHUYY51ukNSwjW2Fq0WdHsO3eMXsKsZ4Iijotz6lWnFx4j4M1Nrctm5NkgKVI1ST/LZGRHmgsw89qKd2iGTLdeyzCf34B9WE+jpgEbN8+ZT+Noi5ccEXrR',
        's/A0XIJ5qai42kCOKNkGDiGMxqXSppBAtkVMxlG5g1nslECGi8oC2soihFjBqSJn5rPdFtsReIPJ5OEKmLj2HulPLJXDnBZ441CnlGUn+Pl492lsftYC0GGG',
        'xmtXpVpt1QEnFyfLYJMZoC0H6NxrUzOd0FHnSNgDK/SoniBwvYdv3L+ssKI2SPJuLqPzjakOpEhQsWPRTqoSi1z0/Zm1nVlW3JAUgWuRQCbUk+QiBZK5mmBO',
        'BpW47yGxJYENcHSzfV7DiddyZOcYqHN6QVkl2swUtB84ERF5BhwiKLTFcCuioDmsY4qArYs2GQGh64fZrBkKTQIGaiXN+8ixRWlxoCfFFkUOBwkHDcc/jajq',
        'B5YVB6leW0lWSsrZ0QKR3GmOYt6LIc3xluVZ9ZxZbmz4aRODFMuzxIo8GMXRQlPNd8NG+gies9sMjVE8sFGfDdYBgBvFqTSkGk2Y5X5dnOPdpE2C0ftdx8Ya',
        'tzH12DSvI1t0ULcfMGPWNl6tSQDWr8lSBVX6rjTHgfMa3SXBGSSavG0Zo17AiuOSNIcdK0NG1GvtelRENPjqJlPmmbWdLmMRmVwkYOMQIxTzgisGQ2VoNI3D',
        'f5s5eB9sM4ODwFpRIunEOINr8kQRb4KJDINbsVlO475J1HxvmMkphA4o0LohNVzYIuFnkc00poL7MJMCtTArXuZSIa1LKzmFKp7Bp+226LQpPew243iEQc+6',
        'Ic/GvHuVodAsYptAgAFSKNh1hxTJsbd3XU7Y9PPGcKOAqqexEh9aKcBAI+TcQ0yRB/TifbENgUcWXVA5JnABT6TSe25SdVStRw9hYMynFLwnTSw6AnDOXJNi',
        'wrUO0MvIk4DemE17ZbuwgNlwOG/Cf9gb6rLSpd1lRHFBZPQJJ52H5mrR2hk8BU8ZbWxUiHpFkqG6Mg4T16HADnSOnI/AI6vZJASKNEIZGrgAT2Pi1aUBrCcd',
        '72g/DM5HYGJVA9fBsESDa9fV2Sz1dRhycxX+1k/8wg/89M8dqFCt4glxFTGv+BkrkgOCZ8GSD1VtSGqRzcONVNSqDsOz7eLbf883fs/XfOjd0KyMVJo2V6tH',
        '2nwGvv/j1//lb3zqIKdOrEgyXyhkq4KFFj55k58eWmeXwzB86TPP/oH3f/Dbnuc5aIahaRrcGKy2+dPw//zmzX985TMvL492+52ss0L1URTapsQZnU5NXVln',
        'WFjaqfbNH37x9z9/4cth0XdN0yRRHLNB02QxPD+2I7CDjPtWU16wwTFoBK0DKePCNfhbP/lL3/tDP3xttnuUG6qhIhOBXUJdurdktB2bUquapUzkbHZDB/rV',
        'zmwnr1bPNfM/+fVf/+c+8mVvcxIgrGq9ndJ/8c9+9seu79/cvbC6eGmpVqTFZ+KptSoevhNubJwkHwxxnTdzvXHrK+f5Yx/+4B98pzwDimWgcgP9Xz996//6',
        'rd/69Yb1/GI7LGrvkv2ko9aDoE52URdHBrxXs7nJpdI/M6y+58Mf+jNftPt2j+3C0X82tMh7q9kO57jt9BuU2g+1pFj6YFX5/n/5I7dTrog4KirxwWNr8H5X',
        'OKBu0jBMl4guZqgss6x22t88uP73fvqHb8EgEcTjktL1yj/88R/9159/6chtVYeSsGSWrCbvlT4xJPokJXtN215FGaw5yrNfteU/ffU396HHSnhjqd5J/PDn',
        'PvspZ82CknppbT4vidP13PdSQ3qVDu2QATVLrJLvZ32l73/i4792AJFlZjBfWh2i/x4W2905TvIwtY3fCWjKOeWQf2vlsK83+7Ju2j4EKxURccHMqo+W9dOl',
        '4VW8ihVxD0mjSsS72FFHO6f4gMyevnzrcH8aS4AUuHrrdr64Y8r+K5/vDg6bGueiGFgNZ9UI5DrXcix0/SpfXuzvpl+58bl+dMnJ1SQS+v36nb3+4tN55yIm',
        'WO+cyDW7DcTdHbNkoxUUSa5Nn5v22be9cnA4WkIqSSVpE1moHhrbERjO+qlG0DOCJCTRVetni3XKlpKHw6fj4c4ikRLprEvEk3uK8EoFVdMUHv2WkrWURodG',
        '+jS3pqksbNRMFED6rjSidJWXr6Tbe7NVNzfJkcJHlEjWHclIt7vULad+qHesHZgR+nRyWkSdNchit3Mv3ZpUJK/xA7yerud+l5qoN+IJk1RFa2ytJPN8WMTb',
        'nZBMs5LM59DeFWF/bpyi2pm45wnjDq/EzeGBBVSREllVY39UwhXvQWVsRoY7VTxIDCJeLUQwFQ/NK49nnUxj2sVLsqqWvGDD8tVXy/6eDispvZcBBxnThsae',
        'zTaXOLFkJ5Ns4YZPtMUmJ9DQ7cNVWy1ik7a9cB2pLADioqaRO6zT3GsaBfLJve0RI/O2IzDEuiDHLFpxFXSjJo99PnqUOWEd2LL0En53YhaploZch+Seraoj',
        'WlXDB6pMNoEx/3vqu9xbHmoa0DVlf9i/urxzK3vZbVI7uHQle9YxGmWrC8/YrCmLS6vF5eViFk8TIvGqQa5JaguNsUh1kctCPJ2u535XDBRLZqnUVCanQBBq',
        'ki6Npi42C8tdHnHnxjkIfPdPR7lOGT1xRu3pZGviwzYlCoipjF634UURIyd+plW1iPYnfIQlvheNvWmARlkdcef6cHBHh1VDST64DcEPtr+KSpWMZ/VRadjY',
        'E0NHT74JyUmgLpyu5H7X6Hp92tVZFNWiY6qPcCkkGOUj8OhTj7kfpmXPRxY9XeObmwNi2dCqYsFXtywTJKRxEoiahv9rOLMlGwkP0iftIQ4kw0mQ6iLVBTaT',
        '2qgpvSNKtyxXXj648bkkR82sr+xZGkx92ytX2mGY9QczO2jHNMniKIRXNlhyFy9IX9NQUqla763k/heglrQ2eMayjj6jERGyycZolTFz6SPMXs5DYDheizeT',
        'z+P/kbLb1C27JbcQn2CrkhjOEwfTOPdiJLKBpeiWWMAgWFw0RuMUow33C6tTqazXvre3un3NhsNmFhaG80AM9Qj5PNm/CRMwqSbhhu0uZnruVCk6rqw2ZjKJ',
        'k7bGFTd487TBNHHKh8bD3HxsNPDjyRzNSREjhLtYBJs8sBxHSHgvx1ZjcrLRVPJQU4GSvDRWGyszyBgUE1NIRFxQLI6gyuBatGWW1sNw43Z3+zbVxsBUS1uV',
        'lhhgIJsmS5vgNXEW1Bm42pAj3yAmSJyjdbqe+5TqCoYMpI7U1dS59kivXnDLZi20m22Maao8NLYm8GlBehIBNh832My0LcuYixArWXghHS/zNsX/BOkTBu6T',
        'KVfGeWAOFBPRLFCG2vWs1hzsDzeuN2bJghNMUzk2ehkzZYYcy7SvqT7KxqOAP30vccZKTHFxmKIqx3eO+f6gcoxJNHzU9VxGH37cxjN20TG28tGouy2Bz7Dz',
        'bSxOHppmAq2ifaIfs6Oe3hi830WQ1tRM3UO2Ki39jDJLNZv6kGpRqmgFJyuN0IRuopZxdTVLhaQuVClVi7SQjINDXn3V7tzU7rCh1zEUqiKGSkjXoRppRJJp',
        'ResmC1+kYKiCRzwdedwIGc8TOjG9YkHZojSxUQOsc+oiwuNcxIXI5VkgNu5i5T+j88+DrQh8EpNaNrn6yXSuMHgcCHnuKsdu8nHcxMsLlqSOriqu5hHrfQLR',
        't6OVebSajFPNtY5VmlPLcO1VO9xPVqT2+IAKKeG+Cf89Ey6E8OzBWhiNZDLmVDjlzTp2yIPKMfIYtUZrgk18aFQaIydwb/zmQ+D81HjLwWG5rDeuLW/easwX',
        'mqQU+i42WauOWTNHPCh/9VsOvw0IjJMSq7XfutHv7evQN1Q8Yn1tNN/Eujcmr773/rc0fhsQ2JFaSULfl6tXjq7faMx2mkzpx4Um2GaYwadV+bHB409gcfCa',
        'aqUWujX7d1a3bvl6uWiyevg33rXMjSelPS54fN7k/jBVqaXDBpLSre3GtdWNGzp02U09XCgJXn3CmvKY4PEnsAvVS2o05UTt6Tq6NYcHy5s3GysTjUONoaqd',
        'nXvrLYvHn8AAyStuVgSXsEstj/zqlX5vj27VCo2GomUbI+Fjg8frbc5EKMdjXnmT2Cdww+pw5dVycKBDx9AzdMQORphBHhf8NiAwED5ho1vHCRqvV3bzxurW',
        'rcbKPIvUgdpPaRoeEzxWL/NaGO1ed9M4J1ZLv3mj39tLZWioRIbmxwi/DQjs43Zk7C5saAxO7VGh78qVV4+uXc+17KjQ95GM7vHAbwMCo2Inzi8UJgt+7N4U',
        'rIZ+vL59x9fdonlr56++B48/geOMm9GBYPzKQubKSawUMZMmU6rdvL66eetxyEB/AuchsGswPAMiFAsgjoy2UVY96aexJVxcGH3jXQj/FXEwFzeJSZfD7SEe',
        'OWWN3mR/maoSYv/YgTQKw+Fto5s/jy+ikXldVbMKw8DqiHXHwf7qxo3WSvaSvAgW7pw6ug3FU0w9zsnGxVynnaItMZ3YGKeDAbGhZCLqdnyQnZyTOvfBVlXI',
        'uJKBx37WeKaxa/gNlYhraVPLUFtN4iIukZtEXLDwfh6/uedCxLUZM7JI09a2tawIydDiVpGMp0ZSqnUuWB0GarhxDL3P2wXmmBBHiGX3LN44qSJVESVH2h0Z',
        '8xaluJSkqUHVIt13TkhleejXXpXbN3fKIGWdsVm42JtQMTcBs16wmWt2x4YpkdXpfe77X5bFs8XeaIzgSDYlkvGyiRhVeXRhYCsCT09R0NgWDUTkfLjNZVgk',
        'uajKculW3auZmVeP097AJU42HL/flJhhPT5eZsWsGj3ekRypDP0sNeXO/q7oDFJKaXriB971dD04aIa+tUq/xnosdFzDBrx69YirqFSLE1CrY0Z1czNz81rd',
        'zCOb00DtKeujlz+tB7eeteE9F3bYRLgqKjTwRYvFhXWfSimrbtSyx53crS51a0RUXNPkV62OeCO0q6OLeAPhReZx8te9287nw4MJ7GDEKVdAOLZvmB0JrFQl',
        'qfvlzB/75m96mrJQyBEx5ZHdmyTj58Sp0lUHtCf15L7MutIOkcNM6pru8NIszY4O3rNz8Tu+4ZsSYNqaz9fLds07Ex/98O98h3Ch9PNakldGHyJFMpLiyDvV',
        'M597v9LJ9fan//Uz12980/PP74LP8Ln1tkrUZ+Eb3/X+91RmtbRNcyEvOOiyedr6Uip1SV1aXWIrbEk9nPfLy6ujd5fhox968W3gdZxEQ+nu9vs7Nx4cXehQ',
        'scj3HasOhOc5EZfppZesNtR1O3sJ/sYP/ew/+oWfWbrEcXMRUhand54ZDC5Y8uJiffYq4xHvLiS3hYity1x3Ftp+9Pd83Z/+uq94D1xcrUmQEt6sMx+Hv/4P',
        'fvRf/eLPyXy+X7tBFLKDay+uuTagdfTu2wqu1jTpqXb2R7/um/69r/zAc5CGVWqygJe+z7u/Cd//8b0f/fxLV1brWbPTl0HzOc72Eiy5VfGiUtWR0rhc6JuL',
        'xb/uxS/5ji95+kVo1kftfCch3nfaNPDwrtHbEhgi1TqEFAq4uuMVTWAVkZr0JizjwEWjVmeK8A8Cn3l+pDgRyNsnN5E4lEOc5Fi3vrwzX/Zo4nKihcteZ2K4',
        '9KtV2zTezPdgDYeFVWfaqAsRch+7vGKZKaHElohE3/OGC3ABLoNQVnikce7RFWkJezBA8OhNxPo22DRkdACCDDuV1rjc0MCOWyNWkEyiQK20J0+mPh+2IbAN',
        'GGi7ITCT16NTB5JCrTSOSCephsvntHI/sGGjECr0YgWNvbuQXQVKxRSRsS/mFKE6DSBUJ/WmopSBtpme9dpJX7ZDKAviNG6IrcULtkAT4xDsnEEYnFZPJNzY',
        'DsYYGh1dpDCbHH/B0OJJBhLQRsKi8z7gBM5J4ONGGKEphaCVgB5xtFku1/PFTvzuLJZ8LyTiNDBydWQgA80YBEYZhtQ2Fe9XZbFo3HsVqTRr65LiuNrciud2',
        'jCy+G2NE/fbTaxyRRr9epVlOKdF1tE0vDjTmEgGukgZRzwSRMpHO48x4/nvLkAB9lErG0djGEULLI3bbmjiiQguyOE4H+pDYisAVA81j6ABoITRX1CvjUbGp',
        'gPdd184iOdXWvRoEFiNVkEjrOobYGTTWl67Js1BDh2HZtG1vCZVCl0iZnCINitWkk1ocVKIaKQ6iP0X7+8OhVJIghhmuJF2Wrm1mOWr1CpCazj1LsLJzwLDC',
        'ACmRxUPPdHVpHLxQl6Xd6RAjKcxAqqd0jubfg20JLGi6m8AVNddIbCAJlzL5RnhCfDo9W8cg01gZz2yo1ogzjn/EsbkGTjHSjEKtVmfahpMyLi45WNokUMGU',
        'Y3nkegIyQKko6DlFFBXU7IQjPJRSU5sGAGutglXVZb++2O6G0/62Itaocw2KzDyL4Wl04dcI2rCu6szDE7mM73Su+XIPtiKwYcoU/AMRSWBoNW0ED60y02NG',
        '7olDUzbGprGT7rcyRl6cOHYq9K4UsTrQCrfrMEtNgjk8BXZ0eHHnAgZCUVbuKrI/IM2YPSkaGN3tFCeP5D75yNdEDJgGnoFszJ2YPyYs3VVFYQ23pnccpuSJ',
        'Z7Djs8oww8XsjIC2GB8tPA0L0OqLiL3ecPA3Oo1SJMQZu02I4P0ILAjzZHFMWMKr2N//mV/4P374Jw+1qcWdiqtoZLs6laVSDFcTc8HFTQug1oiro6bFtbPa',
        '7+S8W+Tf/sCX/bnv/PYXW3YHdF2ZJ8vsCa/C//YjP/FDv/Azt62unCIt3pigVHHDG3UdTYBnPf10WbXeKQdf9cUf+O4v+8qPfdWXvw2aQrG+aXNFV3AD/u5v',
        'XP+Blz7z6WV34akvWi9XYp24nUnO0yVYUpJlLdnESl5Zsiz5Ui1/4EMvfMf7nvsS2I0DZwSSmdc3PsvOZjQBSh3dWhQohSaPA/kOfN/P/Pxf+8F/fv3C2/dz',
        '6xbydhIJPeL0y46lUjcBHckySFXQyupOfvqSrUs+WD21Kh994YP/9Z/8rucn+1mv3FL+0x/4wR/8xK/fctZt4+0MibM+FBlwwVpc4+Dl0889s3QtzJ2D/efX',
        '9S9953f/qa9430Vj8F6TQt6D//HHfvVv//InVy988FqzU6RFE6mmWJi3QGx+JMti6mp9XrmWJHppKM/eufFnP/JVf/r5p94+Zdf0VAqWR7PRw2C72zZjQBjz',
        'zcRMdpoUCU9M4HpX/u6P//QNnR1a9drjBSpe3Ivb4DZ4fL7nsuLVtKCFNGjTe9Ojg1FgfqH02FHx+eV68eKvvPxbQ2Qv9oGEK3vwI7/4KzcG0s7TXjM1AgON',
        'oTAUGYY0FC3F7dRD739hxrrizQ3J//Dnf74H6yyntqJr61bwj3/xF15dHu5fu3HJKnT5YsKHKmXLq4j1Ti9elUI1T2Z5qPmOpBvz3X/2yU9ehU7xhsj58igp',
        'drYm8AYS65yx0YkNxMWrOUXyy4dDuXi5pkSS8QoBYYyDPCt/g/oY6YXiYwB4iti6vtI7F942VFlKWiYx6Nxq9ip0A5999Y7tXNbLzx4VkBmWcFFDPcIVLD7c',
        '+8TXLt2lZ9bsDrPFS3t3etC5GlRqo+nqevn5O3fKbH549cqdqy/vyLrcuYKMuUW3ukRpGm+Sty6tppTRltzWPC8XL3/2cNlPq7srmbANnZNMJ3C+O51InTP+',
        'A8dLxTwo37TIhacOu4pKZBZlPIEypJ+4Yfp+U2KezLN5piZKwpQq7mJ5tsO6UgTJQ05F6SELSaWv3byhzYvbR8vV0dq1Jc+mtDCGVNdqyUoyE5Mzn3ufUo3W',
        'kK7W6r2mfeiF4t6S8LIzXzQ7875byaWF7d3sr7/ybNK2oDVteeGKVfOh9663wUqhVAanst97zbM4SI06HhShtcp2q+iZ2JrA0zPCwLb5h2RFjVrbTCkMtTCf',
        'TbdU3LGwBBsSBlsVRzxKxO+O0VNKHGMmgNa+0s7wimqxWkVbRrUtpQYwKym3eukytXIsTGxUJVzHHHTxrK1KyKnp+362s1j362h0EjEnSTKzdd+Tk3dHeCmv',
        'vHLw6pVZLdktj2xjehPOTr8y/jEpqqKKSkqJlCRlaVrLsxUI5BAJHJWHzPUe2ILA09yLPlOO40VJkKp59dyYk4xnL8yydeI2/nTMr+EeK/Z0MIq4OOKiYy6l',
        'OLPUBHfTOqTqCC7uJFXqGuki5KBAQ87M4tRzkyEnt25NisMcTqijcWJxyJGCi255mbCismj7YTlPRI5QQESdprpnjZPXDCuI9jdurG/fkPVeK0NOZvRGMa1x',
        'wvuUun0MgCZXUoU4z2I6iNQdH9xKWOybjU4kjmiYRx8aWxD4bow6pQO4F8A1MtDyTMvbdmeN9ZFpZPx13LURwhmTVkFE4MboFom1Ekb/Goi5Pg2uEj/fuGdM',
        'JwzUE7XHGJy2FeLgFt9oxdvCBRO1SCXpdjKZvhH5QBD3FLzHwBmuX6kHezL0MqzxSo4JWDfT2TcuL5t/Y5FZwAQLvXDiQCesGnauRMVnYgsCR7M2pNpMX4im',
        'hk3PjQTvfubppi8pXsg18nuZaCRFiB4iMpiM4/qYqb1V4bDuy82bBzevyVDmqmqVYRBNJ+OPR7vzmx5/vAWBN9NWmMbXKEKLRsp8HY9rhi/7oi9auKsjriHG',
        'cpzSjTEFlBDnLI1z+Dx7eV+QMFJiuebmrW7/jvZdU02sukX8sZ2MPyZOz34TcR4Cjx/vmsGj8xkkpYGPfPADF6wI5kIyTVVwiQPtHRVMRsl5us5lRfzChEPt',
        'NQm12LXrRzeuNbXsZFUrkXMjrog/TqbpzY0x34rAU3vs7hUirH/j+RnADN6/2z47b5NZOEGGEwgirpP1y8cMZzF9g8Bv4vu+IRCr6gUrDD17d45u3fDVcpZQ',
        'j0O8Yg6Mq9KbHH/84CdNksSY7uukkDXtWosCRoan4CNf9kJIBpGikzjoILT8oLrFwaxR0WMwhU2zltpRBxKU3m9cX964RrfOZsc0Ho05b/ZofjCBgThyBSIG',
        'ZFpHRyggpPBz3YHf97u+amYl+Xio3fRLGacsKCY+pRIKC9KmsrcmjJoazY1KHeh7ho6jw9W1q43VYxpjkdfuTZYrtyLw2eNubKXpuJ9GnGXxte965wcvP71T',
        'h6J9H4dNlAKRfndMhTT5aBL2wUex1Pybh+BqVbx6ITJeA6s1t26vb9309WrmtBKuYm5qNpph3yRsQ+Bx8bjrxxKeVHePRSFjO/BHvuHr26ODlA1ZM6zyxUtU',
        'Z10iMeuYS0vGDFHHe/1vXUjskU8hCnForNV67WrZ39O+825FGURdFPwRD20/H7Yh8FksVCY37rurSNgcvu1D7/vQM8/MtFCX7MzK4UEyTSbio+q0uWfcV3iL',
        'z2DGMymI3GniPtK4X/utm0c3rze1LJKoDW49aas+f73w4IeFp/tdv5sIfqweH6/K3sI74GPf8k3cuZ0XLUOHm637RZ4zpfcfb3Y0Ukw/Rhjjj6niVXJmveT2',
        'rW7/Thr6bIZFfq43750fTOCJkBpeVTFIxxilaOimtQKQsQvwrS++9xu++IXZnT26dc4p59zXiTVJ5AIdb7S39vyNbtgEH2vY6VwMzIcOVYZSr147vHYlDf1O',
        'EsrwZo7prQgMBHU3ETbg45nIodQG7QmVyeLYsD//nd/1Rd7sDLX2nc5yb5FMOyLAxlrvSiP4VsVksxuVfkY/ezG8JqtYoe/Y21/evsmq28lvavzxFgSOEXr3',
        'FxEyevxvCCeT8d9uu/CRCzt/9lu+/bk8n6XUDWvmzShJb4TyyPb5Vqexo64aSu7xumUupCRWB601p0wxbt5a3riuff9mxh9vQeBTmCTqaWk+sSTH7lgSa+Ci',
        '88c+8qHf88ILF/texKE6o9vGyNOmgGNwlzpG9HpEV6qOW4ZRcRzgN5q1Tz7Oww1jAxNAXAUnNjosnW/GuIgjlhx1iVNlR9qFZxKIeMKThB/wtN8MG149dmx1',
        'k6SaxGrHsKLvODw4vHq1NcuVk/HBuMIoZY+QKfr50bAFgaMRwia/vIKSJE6ciSMjdPxeoqCqdTPjEvwn3/3Rr3nHO54dumy9NxH2kURbMWGoycGra48OpA4t',
        'YtqUJpsmI1OtDqQWmWOJMcfVYAyTAK8mIYhLrOsCaimZqNMYbWlzbTdbiNtAAEvirdBWbfvxzOo6nrnmlnyWfCbWuiXESZhYHMZA0DjYtSuSHK24x/lvUlgf',
        'cutGuX47LfssSpPQCPTJyRuxkXs7Q42dJ0Y19aGxBYHvnqPTdYLWMaqPf6VdtxYlJxrjbfDf/ak/+jsvPvX0ctX2K9ZLkjnukNq24jm34hkfN15l+oBUl+pS',
        'CKGMJnlkOJK4PZ6lrkR91TYCX4iyRb0qVU5sP29XijgUdzcbTXhxdqHiYl48pInwTTEmt7JRDAkhI/aRPbngx3vU4WNe+muvloNbMhzRrakdqqo6RYzGfLEI',
        '2VLCXfnhabwdgc+JdrZTkN7qTHkG3gV/7c9/7KPvfM87utXlhTIcIh3Zq3pz4WK/GqTuSt2lzvGZkaswpDLkUpvB04CUWPabmpuKWIY2Wp68UROpcdBvbEl6',
        'SXVI1ZrB226YdbXpXSPFgG5TApJ6dIV26kMDM2gsY0ksi2tRPFXTIlqwAetlTGFwRm2nSzDKXr39ue7my/Ny2Kpp7WvtaCR8lRQiMufYzvsIeP0J7ADJXJKm',
        'o6N16zxlvNv5zz72Bz/63ve9fXW04wXrkIp4d+f27NLTBGeLxuh0jomYbaYIRShCCV/DjUxnEqdyo8gUm2oe5rG4UkGnyL0wED64dPcBqSLWJJlB3uxtm2ZJ',
        'lpxklqpLEYpYHVnpvfWcXYpXaYVuj1tXbe9m268bKx6nfyum8btx9fXJYfGh8foTWFBBpaBwaXd+uFyJcNH44ob//nu++y9+4ze/twy7/TIlp1/qbNYd7rmu',
        'PR+hHTqMHQG4CnGOUIE1LD0d9cnXQWZiVo/nTWGu475jZAWZGFsdT44X3/YCG/3DqJinGE2T2m9CTYJWBBMVCQkuMqttd2EMqyRIN/SvXFu+ei31wyw31CFY',
        'fYUaC5/GUdux9faQeP0JDGDkPB6Au7s7QwyvuXDJ+Z6v/Z1/5S/8hW953wfm165dgMvuu4nsg3jBKxb0iIZlPGNxamX4z8WPPHa3KnEKfFWLvBvGuBAqY2ir',
        'Eu58YGrh9vbA0gXiSNWKhovwZgPNPKKiGI9NFTyJZEdP13O/0sXCJzGb0hfbO1zevl27ddMksRobqRtJon4BzmDAHIHVqhPMvDi16uC5iHARfveFxV/5I3/o',
        'v/nD3/PVedbu3ZTl/qIwH7KWJEWnhEVxalyChKXkubGcWYAajUCiCGjypKZiLmU0cYu6Kp6ojZSmKU2qDQiqrrpliWe8bb1ppZHgl9GiLJKZa/BOwZMzM9rT',
        'NbxG6ZJpFqXm6jk3O5hw+065cT31y0XtZnXIsaIIQZ4T0uvD4A0hsCpmzBczB4uzSlR674y+gUvwbvjjX/G+//kv/gf/8R/+ro+84+ln1sunu9XTXXdhGOal',
        'NlaCT7slTNWZVd+pvmvMIEEDDaowS7qjuhBv3NUMn5Y6NNySR9NKIMLRtymridkF52LKKY7V0bE5WbmI7dSarEiNI/0mEpyu58xSBHeySsLqwLCkP2T/Zv/q',
        'Z5/qDy6XZRsrsCNORvPkzv9wSH/5L//le797ZLggGsuWJNV4rSRJx30LCZflC/DiO5759q/+yq/44Pufbjm6fbWujxrRyApiKprU+/5SM2tWRxdWB3/i937d',
        '73vvuy+BVOmP1nnW2Lx9+U7/qZc/jyRRzN0jmxqO1LCSHCswo7fCg0pcrGv65dvRj33rN3/VO56eQRbQWCBkT/Tjn/iEYvNF23VHOedwvL63nvuVkX9E40DP',
        'ASnQ5bKcHe3pnev//u/9+q+/dOHiKD2g5kkljj99OGwdXbg1NoalMa7eiXDTY67jI+eoQoEe1lPE7WdX619/6ZVf/q3Pfub6rf1utb+/33cr7coHnn322772',
        '3/qDv/t3fDHMS6UU2llV9uA34Pt+6Kf/6Y//+EplSFTCbmDIsIlVvLeJrwlxt7r84Nuf+3e++mv/3Y+8+HZozeaiQ+n6Rjraz8Lf/+lf/sGf+smXrl8nN3k2',
        'L6YeE3QLGNSMiLQVwYyq+MK9pf6h7/rOb3nxS78a2d348G+Cnrat/l68/gSOrGEJ8hTnSRoP0hxPg98w0mCHaM9oEYyfh1gxwCF1h9QBlcuJGTQ9iybygdSj',
        'YX1Eprm4gj3I0+2bhA2KB2c8b+co7MLFyq4AlDKklEjaw9ItiRa4aaDswFHhvMElYdNINipfIkTyM4WL8AzQlxD0RvZ/3hc4gdefwGPKDUihXUT7orNHiTQ8',
        'SY+nel9IuQn9VoK1u/elNE3bmzk56RgAEpH/Zp2mkDDz0lIzZWfa9IY6SJxD24gfJ4/ZDuqiOaIpemOmJIa+z7M2dlOy40IPxUlGk0Ly3/4RmibHchcGgSk6',
        'ZgDFslU8IbrZ4nkE+r4BBGZSKmJ7MUJH7+bam+7YPLoZ/yVWawVSGjOP9pU2AZTeRSRnzKZwn3CfMErBoWmn+ka5J3LHZBj386ZnPQARzN6X9aU0x8CdnHB1',
        's8g44n1XxK1tK5h3rTTH0UTbwRCZDm4dxIHspuHvY5a1wbWI+yiYPQqHfoMIbCCEAXH0lw1DQaSTBbCNqQYAtVrdPeWMGOhQzMzaNhP9Eb8SEKqN87i4JYn4',
        'pagj8rEpLgiu1QUjBa+Wra0FVSj4wHCBJMXJDai7Yy7hAiwF9Q4MYgNEwnq9HVzG8x8juiO4QkLx4GqC50nXFo0Bdp/sNdvgDSDwhBP1xky+axIdz+wNY40b',
        'BDMLu+PQ0zTgUHpUwAaRnNqxN2UAbO3atujgZS25BcUjJVpxRgPJudQMg87ISgt1KKnJ5qzKsNM0YlAGspnK4JKlSQbFiAx7W6NQEqKewlITbD8mAOGUN0Vd',
        'CqPKd28VW+P1J/CGH4cyh4xHaDpjhstNjx+z7s3Gr8eGMjCx4uC3sciJx16teoJqUhXHE+7EwbMwpdkLp6KHIfC4hDhhiqsFMg5mtUUJ3QUMVVcJYown6m6L',
        '45Vr2sQSA8Fi23P8M86AuYwuced9iRGvP4E3c/fkK9/zjOM/nf7paYy/2cz/zavew3U363z8wGBMcPHa1Z/GPY3aNH7iHGPNcvqn22GUNx+M0698brwhBH6C',
        'Lxw8/NB4grcEnhD4MccTAj/meELgxxxPCPyY4wmBH3M8IfBjjicEfszxhMCPOZ4Q+DHHEwI/5nhC4MccTwj8mOMJgR9zPCHwY44nBH7M8YTAjzmeEPgxx/8P',
        'war5WABhfBcAAAAASUVORK5CYII='
    ].join('');


    const createPlanId = (date = new Date()) => {
        const pad = value => String(value).padStart(2, '0');
        return `PS-${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}-${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}${String(date.getMilliseconds()).padStart(3, '0')}`;
    };

    // Anti-counterfeit verification code printed on the exported PDF. It is a
    // deterministic hash (FNV-1a, run twice over the forward and reversed
    // payload to spread bits across 64 bits) of the recommendation result +
    // the inputs that produced it + the export timestamp, so:
    //  - the same plan re-exported at the same instant reproduces the same
    //    code (useful to confirm a document was generated by this tool and
    //    matches the numbers it claims), and
    //  - changing any product/qty/energy/peak-power figure on the page, or
    //    the export time, changes the code.
    // This is NOT cryptographic proof (there is no server-side secret to sign
    // with from a static HTML file) -- it is a lightweight tamper-evidence
    // marker, not a substitute for a real signature if that's ever needed.
    const fnv1a32 = (str, seed) => {
        let hash = seed >>> 0;
        for (let i = 0; i < str.length; i++) {
            hash ^= str.charCodeAt(i);
            hash = Math.imul(hash, 0x01000193) >>> 0;
        }
        return hash >>> 0;
    };

    const computeVerificationCode = (snapshot) => {
        const canonical = JSON.stringify({
            scenario: snapshot.scenario.id,
            subType: snapshot.scenario.subTypeId,
            dailyWh: Math.round(snapshot.loads.dailyWh),
            peakPowerW: Math.round(snapshot.loads.peakPowerW),
            systemVoltage: snapshot.recommendation.systemVoltage,
            items: snapshot.recommendation.items.map(item => `${item.sku}x${item.qty}`).sort(),
            exportedAt: snapshot.document.exportedAt
        });
        const forwardHash = fnv1a32(canonical, 0x811c9dc5).toString(16).padStart(8, '0');
        const reverseHash = fnv1a32([...canonical].reverse().join(''), 0x9e3779b9).toString(16).padStart(8, '0');
        const hex = (forwardHash + reverseHash).toUpperCase();
        return hex.match(/.{1,4}/g).join('-');
    };

    const PLAN_SCENARIO_LABELS = Object.freeze({
        rv: 'RV',
        marine: 'Marine',
        tiny_house: 'Tiny House'
    });

    // Product prices in productDB are display strings ("$2,099.99", or "$TBD"
    // for anything not yet priced) -- this pulls the numeric value back out
    // for cart-total math, defaulting to 0 when there isn't a real price yet.
    const parsePriceToNumber = (priceStr) => {
        const numeric = Number.parseFloat(String(priceStr ?? '').replace(/[^0-9.]/g, ''));
        return Number.isFinite(numeric) ? numeric : 0;
    };

    const createPlanItem = (component, category) => {
        if (!component || !component.id || component.id === '-' || component.id === 'null') return null;

        const product = getDBInfo(component.id);
        return {
            category,
            name: product.title || component.id,
            sku: product.id || component.id,
            qty: Math.max(1, Number.parseInt(component.qty, 10) || 1),
            price: parsePriceToNumber(product.price),
            wiring: translateWiring(component.wiring || '')
        };
    };

    // Mirrors the PDF's kit-vs-custom logic: a kit is bought as the one line
    // item, so its included components (already present in `items` purely so
    // the UI/PDF can show what's inside) must not be added again, or "Add to
    // Cart" would report a total several times the kit's real price. A
    // custom plan has no kit line, so every item is priced individually.
    const computePlanTotalValue = (recommendation) => {
        if (!recommendation || !Array.isArray(recommendation.items)) return 0;
        const isKitPlan = recommendation.type === 'kit';
        const items = isKitPlan
            ? recommendation.items.filter(item => item.category === 'Recommended kit')
            : recommendation.items;
        return items.reduce((sum, item) => sum + (item.price || 0) * (item.qty || 1), 0);
    };

    function createPlanSnapshot(rec, scenario, subType) {
        const subtypeData = configData[scenario]?.subtypes.find(item => item.id === subType);
        const appliances = [...document.querySelectorAll('.standard-app-card.active, .custom-app-card')]
            .map(card => {
                const watts = Number.parseFloat(card.querySelector('.live-watts')?.value) || 0;
                const hours = Number.parseFloat(card.querySelector('.apple-slider')?.value) || 0;
                const name = card.classList.contains('custom-app-card')
                    ? card.querySelector('.custom-name-text')?.innerText
                    : card.dataset.name;
                return {
                    name: (name || 'Unnamed device').trim(),
                    watts,
                    hours,
                    dailyWh: watts * hours
                };
            })
            .filter(item => item.watts > 0 && item.hours > 0);

        const peakAppliances = [...document.querySelectorAll('.peak-checkbox:checked')]
            .map(checkbox => checkbox.closest('.peak-item')?.querySelector('.app-title')?.innerText?.trim())
            .filter(Boolean);

        const items = [];
        const addItem = (component, category) => {
            const item = createPlanItem(component, category);
            if (item) items.push(item);
        };

        if (rec.type === 'kit') {
            (rec.titles || []).forEach(id => addItem({ id, qty: 1 }, 'Recommended kit'));
        }

        const pvOptions = Array.isArray(rec.pv?.options) ? rec.pv.options : [];
        if (pvOptions.length) {
            const selectedIndex = Math.max(0, Math.min(
                Number.isInteger(currentPvOptionIndex) ? currentPvOptionIndex : 0,
                pvOptions.length - 1
            ));
            addItem(pvOptions[selectedIndex], 'Solar panels (PV)');
        }
        addItem(rec.controller, 'Charge controller');
        addItem(rec.battery, 'Battery');
        addItem(rec.inverter, 'Inverter');
        addItem(rec.other, 'Other components');

        return {
            scenario: {
                id: scenario,
                label: PLAN_SCENARIO_LABELS[scenario] || scenario,
                subTypeId: subType,
                subTypeLabel: subtypeData?.title || subType
            },
            loads: {
                dailyWh: totalWh,
                dailyKwh: totalWh / 1000,
                peakPowerW,
                appliances,
                peakAppliances
            },
            recommendation: {
                type: rec.type,
                systemVoltage: rec.sysVoltage,
                items,
                warning: rec.inverter?.warning || ''
            }
        };
    }

    // 【Talk to an Expert -> 谷歌问卷预填】
    // 按最终确认的方案：客户最近一次推荐结果的全部信息（含产品名称、SKU、价格）
    // 都作为可见字段直接预填进谷歌问卷，不做"隐藏字段"处理（Google 表单本身也没有
    // 预填后隐藏某一题的机制——凡是 entry.XXXXX 预填的内容都会以正常题目形式完整
    // 显示给填表人）。客户端只需要额外手动填邮箱和一个开放性问题即可提交。
    //
    // entry ID 已于 2026-09-24 从表单编辑页(Contact Form, 表单 ID
    // 1cc5zeB27DfU1DCCLry4rTpl9SMzErLVfgZHe4r8BAN4)的"获取预填链接"页面直接读取
    // 并核对填入，对应新增的 7 道题（系统类型/具体场景/用电器清单/峰值并发电器/
    // 每日耗电量/峰值功率/推荐产品明细）。若表单题目改动导致 entry ID 变化，
    // 需要重新走一遍"⋮ -> 获取预填链接"流程取值更新。
    const EXPERT_FORM_PREFILL_CONFIG = Object.freeze({
        baseUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfq5MMy-8nfH_ztEoJJAVn7a-KflvVfQ5Tw9fatFVGDC-6eAw/viewform',
        entryIds: {
            type: '1509385144',           // System Type
            subtype: '2080004773',        // System Sub-Type
            appliances: '1289235345',     // Appliance List
            peakAppliances: '126549946',  // Peak Concurrent Appliances
            dailyEnergy: '813121522',     // Daily Energy Consumption (kWh)
            peakPower: '757613671',       // Peak Power Draw (W)
            products: '5314423'           // Recommended Products
        }
    });

    function buildExpertFormUrl() {
        const cfg = EXPERT_FORM_PREFILL_CONFIG;
        const params = new URLSearchParams();
        params.set('embedded', 'true');

        if (!latestPlanSnapshot) return `${cfg.baseUrl}?${params.toString()}`;

        const { scenario, loads, recommendation } = latestPlanSnapshot;

        // 【方案推荐需要包含里面的具体单品】：kit 方案下 recommendation.items 既有套件
        // 本身（category === 'Recommended kit'），也有组成套件的具体单品（太阳能板/控制器/
        // 电池/逆变器等）——这里全部列出，和推荐结果页面上客户实际看到的卡片列表一致，
        // 不再像 computePlanTotalValue() 那样为了避免"加购总价"重复计算而只取套件本身。
        // 【去掉价格，换行分隔】：客户/销售在问卷里只需要看到产品名称 + SKU，价格不再
        // 预填进这个字段；每个单品单独一行（标准换行格式），方便阅读。
        const productLines = (() => {
            if (!recommendation || !Array.isArray(recommendation.items) || !recommendation.items.length) return '';
            return recommendation.items.map(item => {
                const qtyPart = item.qty > 1 ? ` x${item.qty}` : '';
                return `${item.name}${qtyPart} - SKU: ${item.sku}`;
            }).join('\n');
        })();

        const fieldValues = {
            type: scenario?.label || '',
            subtype: scenario?.subTypeLabel || '',
            appliances: (loads?.appliances || []).map(a => `${a.name}: ${a.watts}W, ${a.hours}h`).join('\n'),
            peakAppliances: (loads?.peakAppliances || []).join(', '),
            dailyEnergy: typeof loads?.dailyKwh === 'number' ? `${loads.dailyKwh.toFixed(2)} kWh` : '',
            peakPower: typeof loads?.peakPowerW === 'number' ? `${Math.round(loads.peakPowerW)} W` : '',
            products: productLines
        };

        Object.keys(fieldValues).forEach(key => {
            const entryId = cfg.entryIds[key];
            const value = fieldValues[key];
            if (entryId && value) params.set(`entry.${entryId}`, value);
        });

        return `${cfg.baseUrl}?${params.toString()}`;
    }

    const normalizePdfText = (value, maxLength = 0) => {
        const source = String(value ?? '').trim();
        const normalized = source
            .replace(/[\u2013\u2014]/g, '-')
            .replace(/\u2122/g, 'TM')
            .replace(/\u00ae/g, '(R)')
            .replace(/[^\x20-\x7E]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
        const bounded = maxLength > 0 && normalized.length > maxLength
            ? `${normalized.slice(0, Math.max(0, maxLength - 3))}...`
            : normalized;
        return bounded || (source ? '[Non-Latin text]' : '');
    };

    const hasUnsupportedPdfCharacters = (value) => /[^\x20-\x7E\u2013\u2014\u2122\u00ae]/.test(String(value ?? ''));

    const getUnsupportedPlanApplianceNames = (snapshot) => snapshot.loads.appliances
        .map(item => item.name)
        .filter(hasUnsupportedPdfCharacters)
        .slice(0, 3);

    const formatPdfDate = (isoDate) => new Intl.DateTimeFormat('en-US', {
        year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit'
    }).format(new Date(isoDate));

    function buildFixedPlanPdf(snapshot) {
        if (!window.jspdf || !window.jspdf.jsPDF) {
            throw new Error(window.__powerConfiguratorPdfLibraryError || 'The PDF generator is still loading. Please check the connection and try again.');
        }

        const { jsPDF } = window.jspdf;
        const spec = PROPOSAL_PDF_FORMAT;
        const { margin, colors } = spec;
        const doc = new jsPDF({ ...spec.page, putOnlyUsedFonts: true });
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const contentWidth = pageWidth - margin.left - margin.right;
        let y = 0;

        const HEADER_HEIGHT = 24;

        const drawPageHeader = () => {
            doc.setFillColor(...colors.brand);
            doc.rect(0, 0, pageWidth, HEADER_HEIGHT, 'F');
            // Darker accent strip under the brand bar so the page reads in clear
            // bands (brand bar -> accent line -> content) instead of the header
            // just stopping abruptly into white space.
            doc.setFillColor(0, 35, 110);
            doc.rect(0, HEADER_HEIGHT, pageWidth, 1.1, 'F');

            try {
                doc.addImage(
                    RENOGY_LOGO_PNG_DATA_URL,
                    'PNG',
                    margin.left,
                    5,
                    14,
                    14,
                    undefined,
                    'FAST'
                );
            } catch (error) {
                console.warn('Renogy logo could not be embedded in the plan PDF.', error);
            }

            doc.setTextColor(255, 255, 255);
            doc.setFont('helvetica', 'bolditalic');
            doc.setFontSize(10.5);
            doc.text('RENOGY', margin.left + 18, 10);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(9);
            doc.text('POWER SYSTEM RECOMMENDATION', margin.left + 39, 10);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(7.3);
            doc.text(normalizePdfText(snapshot.document.planId), pageWidth - margin.right, 8.5, { align: 'right' });
            doc.setFontSize(6.3);
            doc.setTextColor(195, 213, 250);
            doc.text(`VERIFY ${normalizePdfText(snapshot.document.verificationCode || '')}`, pageWidth - margin.right, 13, { align: 'right' });
            doc.setTextColor(...colors.ink);
            y = HEADER_HEIGHT + 9;
        };

        const drawWatermark = () => {
            // Faint logo tiled evenly across the whole page. The Renogy mark
            // is itself a coarse grid icon -- stretched into one giant copy
            // (the earlier approach) blows its own grid up into large,
            // visibly blocky patches of shading. Repeating many small copies
            // instead spans the full page just as evenly without that
            // artifact. The verification code itself is never printed here
            // -- it only appears once, top-right in the header -- this is
            // purely a branding + light tamper-evidence cue (a copy/paste of
            // the text content onto a blank page loses this mark).
            try {
                doc.saveGraphicsState();
                doc.setGState(new doc.GState({ opacity: 0.03 }));
                const tile = 24;
                const gapX = 64;
                const gapY = 64;
                const top = HEADER_HEIGHT + 8;
                const bottom = pageHeight - 8;
                let rowIndex = 0;
                for (let ty = top; ty < bottom; ty += gapY, rowIndex++) {
                    const stagger = (rowIndex % 2) ? gapX / 2 : 0;
                    for (let tx = -tile + stagger; tx < pageWidth; tx += gapX) {
                        doc.addImage(RENOGY_LOGO_PNG_DATA_URL, 'PNG', tx, ty, tile, tile, undefined, 'FAST');
                    }
                }
                doc.restoreGraphicsState();
            } catch (error) {
                // Decorative only -- never block the export over a watermark failure.
            }
        };

        const addPage = () => {
            doc.addPage();
            drawPageHeader();
            drawWatermark();
        };

        const ensureSpace = (height) => {
            if (y + height > pageHeight - margin.bottom) addPage();
        };

        const drawSection = (title) => {
            ensureSpace(11);
            // Small brand-colored tab to the left of every section title -- a
            // repeated visual anchor that makes the document's section
            // structure scannable at a glance, not just a font-size change.
            doc.setFillColor(...colors.brand);
            doc.rect(margin.left, y - 3.4, 3, 3.8, 'F');
            doc.setDrawColor(...colors.line);
            doc.setLineWidth(0.35);
            doc.line(margin.left, y + 5.2, pageWidth - margin.right, y + 5.2);
            doc.setTextColor(...colors.ink);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(10.5);
            doc.text(normalizePdfText(title), margin.left + 6, y);
            y += 10;
        };

        const drawKeyValueGrid = (entries) => {
            const columns = 2;
            const rowHeight = 15;
            const rowCount = Math.ceil(entries.length / columns);
            const gridHeight = rowCount * rowHeight + 4;
            const columnWidth = contentWidth / columns;
            ensureSpace(gridHeight);
            doc.setFillColor(...colors.pale);
            doc.roundedRect(margin.left, y, contentWidth, gridHeight, 2, 2, 'F');

            entries.forEach((entry, index) => {
                const column = index % columns;
                const row = Math.floor(index / columns);
                const x = margin.left + column * columnWidth + 4;
                const itemY = y + 5 + row * rowHeight;
                doc.setTextColor(...colors.muted);
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(7.2);
                doc.text(normalizePdfText(entry.label).toUpperCase(), x, itemY);
                doc.setTextColor(...colors.ink);
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(9);
                const lines = doc.splitTextToSize(normalizePdfText(entry.value), columnWidth - 8);
                doc.text(lines.slice(0, 2), x, itemY + 4.5);
            });
            y += gridHeight + 4;
        };

        // Renders the parts list. When the plan is a pre-built kit, the kit
        // itself is one purchasable line and everything it already contains
        // is listed underneath it, indented and visually de-emphasized, with
        // an explanatory note -- the customer buys the kit once, not each
        // part inside it separately. A custom (non-kit) plan has no such
        // bundling, so its parts stay a flat, equally-weighted list. No SKU
        // column: it's an internal identifier the customer doesn't need.
        const drawComponentsSection = (items) => {
            const title = 'Recommended components';
            ensureSpace(18);
            drawSection(title);
            if (!items.length) {
                doc.setTextColor(...colors.muted);
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(8.5);
                doc.text('No items were recorded for this section.', margin.left, y);
                y += 8;
                return;
            }

            const kitItems = items.filter(item => item.category === 'Recommended kit');
            const otherItems = items.filter(item => item.category !== 'Recommended kit');
            const isKitPlan = kitItems.length > 0;

            const catWidth = 40;
            const qtyWidth = 20;
            const productWidth = contentWidth - catWidth - qtyWidth;
            const headerHeight = 7;
            const indentStep = 5;

            const drawHeaderRow = () => {
                ensureSpace(headerHeight);
                doc.setFillColor(...colors.brand);
                doc.rect(margin.left, y, contentWidth, headerHeight, 'F');
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(7.2);
                doc.setTextColor(255, 255, 255);
                doc.text('CATEGORY', margin.left + 2, y + 4.5);
                doc.text('PRODUCT', margin.left + catWidth + 2, y + 4.5);
                doc.text('QTY', margin.left + catWidth + productWidth + 2, y + 4.5);
                y += headerHeight;
            };

            const drawNoteRow = (text) => {
                const lines = doc.splitTextToSize(normalizePdfText(text), contentWidth - 4 - indentStep);
                const rowHeight = Math.max(6.5, lines.length * 3.4 + 2.5);
                if (y + rowHeight > pageHeight - margin.bottom) {
                    addPage();
                    drawSection(`${title} (continued)`);
                    drawHeaderRow();
                }
                doc.setFillColor(...colors.pale);
                doc.rect(margin.left, y, contentWidth, rowHeight, 'F');
                doc.setTextColor(...colors.muted);
                doc.setFont('helvetica', 'italic');
                doc.setFontSize(7.4);
                doc.text(lines, margin.left + indentStep, y + 4);
                y += rowHeight;
            };

            const drawItemRow = (item, { indent = false, emphasize = false, rowIndex = 0 } = {}) => {
                const productIndent = indent ? indentStep : 0;
                const categoryText = indent ? '' : item.category;
                const productLines = doc.splitTextToSize(normalizePdfText(item.name, 160), productWidth - 4 - productIndent);
                const categoryLines = doc.splitTextToSize(normalizePdfText(categoryText), catWidth - 4);
                const lineCount = Math.max(productLines.length, categoryLines.length, 1);
                const rowHeight = Math.max(8, lineCount * 3.45 + 3);

                if (y + rowHeight > pageHeight - margin.bottom) {
                    addPage();
                    drawSection(`${title} (continued)`);
                    drawHeaderRow();
                }

                if (emphasize) {
                    doc.setFillColor(...colors.pale);
                    doc.rect(margin.left, y, contentWidth, rowHeight, 'F');
                } else if (!indent && rowIndex % 2 === 0) {
                    doc.setFillColor(250, 251, 253);
                    doc.rect(margin.left, y, contentWidth, rowHeight, 'F');
                }
                doc.setDrawColor(...colors.line);
                doc.setLineWidth(0.15);
                doc.line(margin.left, y + rowHeight, pageWidth - margin.right, y + rowHeight);

                doc.setFont('helvetica', emphasize ? 'bold' : 'normal');
                doc.setFontSize(7.6);
                doc.setTextColor(...colors.ink);
                doc.text(categoryLines, margin.left + 2, y + 4.2);
                doc.setTextColor(...(indent ? colors.muted : colors.ink));
                doc.text(productLines, margin.left + catWidth + 2 + productIndent, y + 4.2);
                doc.setTextColor(...colors.ink);
                doc.text(String(item.qty), margin.left + catWidth + productWidth + 2, y + 4.2);
                y += rowHeight;
            };

            drawHeaderRow();
            if (isKitPlan) {
                kitItems.forEach((item, index) => drawItemRow(item, { emphasize: true, rowIndex: index }));
                if (otherItems.length) {
                    drawNoteRow('Included in the kit above -- already bundled, no separate purchase needed:');
                    otherItems.forEach((item, index) => drawItemRow(item, { indent: true, rowIndex: index }));
                }
            } else {
                items.forEach((item, index) => drawItemRow(item, { rowIndex: index }));
            }
            y += 4;
        };

        const drawParagraphs = (paragraphs, color = colors.ink) => {
            paragraphs.forEach(paragraph => {
                const lines = doc.splitTextToSize(normalizePdfText(paragraph), contentWidth - 4);
                let lineIndex = 0;
                while (lineIndex < lines.length) {
                    const availableHeight = pageHeight - margin.bottom - y;
                    if (availableHeight < 6) {
                        addPage();
                        continue;
                    }
                    const maximumLines = Math.max(1, Math.floor((availableHeight - 2) / 3.7));
                    const chunk = lines.slice(lineIndex, lineIndex + maximumLines);
                    doc.setTextColor(...color);
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(8.6);
                    doc.text(lineIndex === 0 ? '-' : ' ', margin.left, y);
                    doc.text(chunk, margin.left + 4, y);
                    y += Math.max(5, chunk.length * 3.7 + 2);
                    lineIndex += chunk.length;
                }
            });
        };

        drawPageHeader();
        drawWatermark();
        doc.setTextColor(...colors.brand);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8.5);
        doc.text('OFF-GRID POWER PLAN', margin.left, y);
        y += 6.5;
        doc.setTextColor(...colors.ink);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(20);
        doc.text(normalizePdfText(spec.title), margin.left, y);
        y += 7.5;
        doc.setTextColor(...colors.muted);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9.4);
        const intro = doc.splitTextToSize('A Renogy power system recommendation generated from your current appliance and peak-use selections.', contentWidth);
        doc.text(intro, margin.left, y);
        y += intro.length * 4.1 + 6;

        drawSection('Plan overview');
        drawKeyValueGrid([
            { label: 'Generated', value: formatPdfDate(snapshot.document.exportedAt) },
            { label: 'Scenario', value: snapshot.scenario.label },
            { label: 'Vehicle / property', value: snapshot.scenario.subTypeLabel },
            { label: 'Daily energy', value: `${snapshot.loads.dailyKwh.toFixed(2)} kWh` },
            { label: 'Peak power', value: `${Math.round(snapshot.loads.peakPowerW).toLocaleString()} W` },
            { label: 'System voltage', value: `${snapshot.recommendation.systemVoltage} V` }
        ]);

        // Totals only -- the per-appliance breakdown lives in the app itself,
        // not in this customer-facing plan.
        drawSection('Appliance load summary');
        drawKeyValueGrid([
            { label: 'Total daily energy', value: `${snapshot.loads.dailyKwh.toFixed(2)} kWh` },
            { label: 'Peak power', value: `${Math.round(snapshot.loads.peakPowerW).toLocaleString()} W` }
        ]);

        drawComponentsSection(snapshot.recommendation.items);

        const wiringNotes = snapshot.recommendation.items
            .filter(item => item.wiring)
            .map(item => `${item.category}: ${item.wiring}`);
        if (wiringNotes.length) {
            drawSection('Connection notes');
            drawParagraphs(wiringNotes);
            y += 2;
        }

        if (snapshot.recommendation.warning) {
            drawSection('Important system note');
            const warningLines = doc.splitTextToSize(normalizePdfText(snapshot.recommendation.warning), contentWidth - 8);
            const warningHeight = Math.max(12, warningLines.length * 4 + 7);
            ensureSpace(warningHeight);
            doc.setFillColor(255, 243, 224);
            doc.roundedRect(margin.left, y, contentWidth, warningHeight, 2, 2, 'F');
            doc.setTextColor(...colors.warning);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8.8);
            doc.text('Review before ordering', margin.left + 4, y + 5);
            doc.setFont('helvetica', 'normal');
            doc.text(warningLines, margin.left + 4, y + 9.5);
            y += warningHeight + 4;
        }

        const pageCount = doc.getNumberOfPages();
        for (let page = 1; page <= pageCount; page++) {
            doc.setPage(page);
            doc.setDrawColor(...colors.line);
            doc.setLineWidth(0.2);
            doc.line(margin.left, pageHeight - 11, pageWidth - margin.right, pageHeight - 11);
            doc.setTextColor(...colors.muted);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(7);
            doc.text('Generated by Renogy Power Configurator', margin.left, pageHeight - 7);
            doc.text(`Page ${page} of ${pageCount}`, pageWidth - margin.right, pageHeight - 7, { align: 'right' });
        }

        const filename = `${spec.filenamePrefix}-${snapshot.document.planId.toLowerCase()}.pdf`;
        return { doc, blob: doc.output('blob'), filename, snapshot };
    }

    function resolveVariantId(sku) {
        const product = getDBInfo(sku);
        return String(product.variant_id || '').trim();
    }

    function recommendationCartLines() {
        const recommendation = latestPlanSnapshot && latestPlanSnapshot.recommendation;
        if (!recommendation || !Array.isArray(recommendation.items)) return [];
        const lines = recommendation.type === 'kit'
            ? recommendation.items.filter((item) => item.category === 'Recommended kit')
            : recommendation.items;
        return lines.filter((item) => item && item.sku && item.sku !== '-');
    }

    async function addRecommendedSolutionToCart(button) {
        if (!button || button.dataset.busy === '1') return;

        const cartValue = latestPlanSnapshot ? computePlanTotalValue(latestPlanSnapshot.recommendation) : 0;
        const lines = recommendationCartLines();
        if (!lines.length) {
            showRecommendationActionStatus('There is no product to add.', 'error');
            AnalyticsTracker.recordAddToCartClick('error', cartValue);
            return;
        }

        button.dataset.busy = '1';
        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');

        try {
            const resolved = [];
            const missing = [];
            for (const line of lines) {
                const variantId = await resolveVariantId(line.sku);
                if (!variantId) missing.push(line.sku);
                else resolved.push({ id: variantId, quantity: line.qty || 1 });
            }

            if (missing.length) {
                showRecommendationActionStatus(`Missing a store variant, so nothing was added: ${missing.join(', ')}.`, 'error');
                AnalyticsTracker.recordAddToCartClick('missing_variant', cartValue);
                return;
            }

            const form = document.createElement('form');
            form.method = 'post';
            form.action = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add';
            resolved.forEach((line, index) => {
                const idInput = document.createElement('input');
                idInput.type = 'hidden';
                idInput.name = `items[${index}][id]`;
                idInput.value = line.id;
                const qtyInput = document.createElement('input');
                qtyInput.type = 'hidden';
                qtyInput.name = `items[${index}][quantity]`;
                qtyInput.value = String(line.quantity);
                form.append(idInput, qtyInput);
            });

            const formData = new FormData(form);
            const cartDrawer = document.querySelector('cart-drawer');
            let sections = 'cart-icon-bubble';
            const drawerSection = cartDrawer && cartDrawer.closest('.shopify-section');
            if (drawerSection) {
                sections += `,${drawerSection.id.replace('shopify-section-', '')}`;
            }
            formData.append('sections_url', window.location.pathname);
            formData.append('sections', sections);

            const response = await fetch(form.action, {
                method: 'POST',
                headers: {
                    Accept: 'application/javascript',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            });
            const data = await response.json().catch(() => ({}));
            let error = typeof data.description === 'string' ? data.description : data.message;
            if (data.errors && typeof data.errors === 'object') {
                error = Object.entries(data.errors).map((item) => item[1].join(', ')).join(', ');
            }
            if (!response.ok || data.status) {
                showRecommendationActionStatus(error || 'Add to cart failed.', 'error');
                AnalyticsTracker.recordAddToCartClick('error', cartValue);
                return;
            }

            if (window.theme && theme.settings && theme.settings.afterAtc === 'page') {
                window.location.href = theme.routes.cart;
                return;
            }

            const cartIconBubble = document.getElementById('cart-icon-bubble');
            if (cartIconBubble && data.sections && data.sections['cart-icon-bubble']) {
                cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
            }
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                const openDrawer = !window.theme || !theme.settings || theme.settings.afterAtc === 'drawer';
                cartDrawer.renderContents(data, openDrawer);
            }

            showRecommendationActionStatus('Added to cart.', 'success');
            AnalyticsTracker.recordAddToCartClick('success', cartValue);
        } catch (e) {
            showRecommendationActionStatus('Add to cart failed. Please try again.', 'error');
            AnalyticsTracker.recordAddToCartClick('error', cartValue);
        } finally {
            delete button.dataset.busy;
            button.disabled = false;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
        }
    }

    function showRecommendationActionStatus(message, type = '') {
        const status = document.getElementById('recommendation-action-status');
        if (!status) return;
        clearTimeout(recommendationActionStatusTimer);
        status.textContent = message;
        status.className = `recommendation-action-status${type ? ` is-${type}` : ''}`;
        recommendationActionStatusTimer = setTimeout(() => {
            status.textContent = '';
            status.className = 'recommendation-action-status';
        }, 6000);
    }

    function exportPlanPdf() {
        if (!latestPlanSnapshot) {
            showRecommendationActionStatus('Generate a recommendation before exporting a plan.', 'error');
            return;
        }

        try {
            const exportedAt = new Date().toISOString();
            const snapshot = {
                ...latestPlanSnapshot,
                document: {
                    planId: createPlanId(),
                    exportedAt,
                    formatVersion: PROPOSAL_PDF_FORMAT.version
                }
            };
            snapshot.document.verificationCode = computeVerificationCode(snapshot);
            const unsupportedNames = getUnsupportedPlanApplianceNames(snapshot);
            if (unsupportedNames.length) {
                showRecommendationActionStatus('This PDF template uses a Latin font. Rename custom devices with Latin characters before exporting.', 'error');
                return;
            }
            const artifact = buildFixedPlanPdf(snapshot);
            artifact.doc.save(artifact.filename);
            showRecommendationActionStatus('Your Renogy plan PDF has been downloaded.', 'success');
            AnalyticsTracker.recordExport(snapshot.document.planId, snapshot.document.verificationCode);

            // Future delivery is initiated by an authorised email form after the
            // secure backend endpoint and server-side email token are configured.
        } catch (error) {
            console.error('Plan PDF export failed:', error);
            showRecommendationActionStatus(error.message || 'The plan PDF could not be generated. Please try again.', 'error');
        }
    }

    // Placeholder config for the not-yet-built email-delivery backend. Kept
    // disabled until a secure server endpoint (holding its own send token)
    // exists -- sendPlanPdfByEmail() below is unused until then, but this
    // definition is required so referencing it doesn't throw a ReferenceError.
    const PROPOSAL_EMAIL_DELIVERY_CONFIG = Object.freeze({
        enabled: false,
        endpoint: '',
        serverTokenEnvironmentKey: 'RENOGY_PROPOSAL_EMAIL_TOKEN'
    });

    async function sendPlanPdfByEmail({ recipientEmail, pdfBlob, snapshot }) {
        const config = PROPOSAL_EMAIL_DELIVERY_CONFIG;
        if (!config.enabled) return { sent: false, reason: 'Email delivery is disabled.' };
        if (!recipientEmail) throw new Error('A customer email address is required.');
        if (!config.endpoint) throw new Error(`Configure a secure backend endpoint that owns ${config.serverTokenEnvironmentKey} before enabling email delivery.`);

        const formData = new FormData();
        formData.append('recipientEmail', recipientEmail);
        formData.append('proposal', JSON.stringify(snapshot));
        formData.append('proposalPdf', pdfBlob, `${snapshot.document.planId}.pdf`);
        const response = await fetch(config.endpoint, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error('The plan email could not be sent.');
        return { sent: true, response };
    }

    const renderComponentCard = (comp, categoryName, isSubItem = false, hideCategory = false, sysVoltage = 12) => {
        if (!comp || comp.id === 'null' || comp.id === '-') return '';
        
        const dbInfo = getDBInfo(comp.id);
        let specsHtml = ''; 
        let isSolarPanel = categoryName.includes('Solar Panels (PV)'); 
        let isBattery = categoryName.includes('Battery'); 
        let showBatteryInfo = isBattery && comp && comp.qty > 1; 
        
        let specsContent = '';
        const modelMatch = comp.id.match(/(RSP[A-Z0-9-x]+)/i); 
        
        if (modelMatch && pvSpecsDB[modelMatch[1].toUpperCase()]) {
            const spec = pvSpecsDB[modelMatch[1].toUpperCase()];
            specsContent = `
                <div style="margin-bottom:2px; color: #1d1d1f;">${spec.name}</div>
                <div style="margin-bottom:2px;">${spec.dim} ${isSolarPanel ? '(per panel)' : ''}</div>
                <div>${spec.weight} ${isSolarPanel ? '(per panel)' : ''}</div>
            `;
        }

        if (specsContent || isSolarPanel || showBatteryInfo) {
            let infoBtnHtml = '';
            if (isSolarPanel || showBatteryInfo) {
                let modalTriggerAttr = isSolarPanel ? 
                    `data-action="open-pv-modal" data-qty="${comp.qty || 1}" data-id="${comp.id}" data-sysvoltage="${sysVoltage}" data-wiring="${comp.wiring || ''}"` : 
                    `data-action="open-batt-modal" data-qty="${comp.qty}" data-id="${comp.id}" data-sysvoltage="${sysVoltage}" data-wiring="${comp.wiring || ''}"`;
                
                let tooltipHtml = isSolarPanel ? 
                    `<div class="pv-rich-tooltip">${buildPvDetailHtml(comp.qty || 1, comp.id, false, sysVoltage, comp.wiring)}</div>` : 
                    `<div class="pv-rich-tooltip">${buildBatteryDetailHtml(comp.qty, comp.id, false, sysVoltage, comp.wiring)}</div>`;
                
                infoBtnHtml = `
                    <button type="button" class="btn-action info-trigger-btn" ${modalTriggerAttr} style="background:none; border:none; padding:4px; cursor:pointer; color:#a1a1a6; transition: 0.2s; margin-left: auto; flex-shrink: 0;">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>
                        ${tooltipHtml}
                    </button>
                `;
            }
            specsHtml = `
                <div style="display: flex; align-items: flex-end; justify-content: space-between; margin-top: 10px; padding-top: 10px; border-top: 1px dashed #e5e5e5; width: 100%;">
                    <div style="font-size: 13px; color: #86868b; line-height: 1.3; font-weight: normal;">
                        ${specsContent}
                    </div>
                    ${infoBtnHtml}
                </div>
            `;
        }
        
        const qtyStr = (comp.qty && comp.qty > 1) ? `<span class="rec-qty">Qty: ${comp.qty}</span>` : '';
        const cardClass = isSubItem ? 'rec-card sub-item-card' : 'rec-card';
        const catClass = isSubItem ? 'rec-category sub-item-category' : 'rec-category';
        
        const titleHtml = `<h4 class="rec-title" style="margin: 0 0 4px 0;">${dbInfo.title}</h4>`;
        
        let catDescHtml = '';
        if(categoryName === 'Battery') {
            catDescHtml = `<p style="font-size: 14px; color: #86868b; font-weight: 400; margin: 8px 0 0 0; line-height: 1.4;">Battery is recommended based on your total appliance load.</p>`;
        } else if (categoryName === 'Inverter') {
            catDescHtml = `<p style="font-size: 14px; color: #86868b; font-weight: 400; margin: 8px 0 0 0; line-height: 1.4;">Inverter is recommended based on the peak power of appliances running together.</p>`;
        }
        
        const categoryHtml = hideCategory ? '' : `
            <div class="${catClass}" style="display:flex; flex-direction:column; border-bottom:none; margin-bottom:12px;">
                <div style="display:flex; justify-content:space-between; align-items:baseline;">
                    <span>${categoryName}</span>
                </div>
                ${catDescHtml}
            </div>
        `;

        return `
            ${categoryHtml}
            <div class="${cardClass}" onclick="if(event.target.closest('.btn-action')) return; window.open('${dbInfo.url}', '_blank')" style="position:relative; cursor:pointer;">
                <img src="${dbInfo.pic}" class="rec-img">
                <div class="rec-info" style="width:100%; min-width:0;">
                    <span class="rec-bestseller" style="display: none;">Best Seller</span>
                    ${titleHtml}
                    <div class="rec-price-row">
                        <span class="rec-price">${dbInfo.price}</span>
                        ${qtyStr}
                    </div>
                    ${specsHtml}
                </div>
                <span class="rec-arrow">›</span>
            </div>
        `;
    };

    const generatePvHtml = (pvData, isSubItem, sysVoltage = 12) => {
        if (!pvData || !pvData.options || pvData.options.length === 0) return '';
        const catClass = isSubItem ? 'rec-category sub-item-category' : 'rec-category';

        if (pvData.options.length > 1) {
            currentPvOptions = pvData.options;
            if (currentPvOptionIndex >= currentPvOptions.length) currentPvOptionIndex = 0;
            const selectedOpt = currentPvOptions[currentPvOptionIndex];
            
            let totalPvWatts = 0;
            const dbModelMatch = selectedOpt.id.match(/(RSP[A-Z0-9-x]+)/i);
            
            if (dbModelMatch && pvSpecsDB[dbModelMatch[1].toUpperCase()]) {
                const specName = pvSpecsDB[dbModelMatch[1].toUpperCase()].name;
                const wattMatch = specName.match(/(\d+)W/i);
                if (wattMatch) { 
                    totalPvWatts = parseInt(wattMatch[1]) * selectedOpt.qty; 
                }
            }
            
            let wattText = totalPvWatts > 0 ? totalPvWatts + 'W' : 'the recommended wattage';

            let optionsHtml = '';
            currentPvOptions.forEach((opt, index) => {
                const dbInfo = getDBInfo(opt.id); 
                const isSelected = index === currentPvOptionIndex;
                const tagHtml = isSelected ? `<span class="current-tag">Current</span>` : '';
                const qtyHtml = opt.qty > 1 ? `<span style="color:#86868b; font-size:12px; margin-left:4px;">x${opt.qty}</span>` : '';

                let specsHtmlInline = '';
                const modelMatch = opt.id.match(/(RSP[A-Z0-9-x]+)/i); 
                
                if (modelMatch && pvSpecsDB[modelMatch[1].toUpperCase()]) {
                    const spec = pvSpecsDB[modelMatch[1].toUpperCase()];
                    let modalTriggerAttr = `data-action="open-pv-modal" data-qty="${opt.qty || 1}" data-id="${opt.id}" data-sysvoltage="${sysVoltage}" data-wiring="${opt.wiring || ''}"`;
                    let tooltipHtml = `<div class="pv-rich-tooltip">${buildPvDetailHtml(opt.qty || 1, opt.id, false, sysVoltage, opt.wiring)}</div>`;
                    
                    specsHtmlInline = `
                        <div style="display: flex; align-items: flex-end; justify-content: space-between; margin-top: 8px; padding-top: 8px; border-top: 1px dashed #e5e5e5; width: 100%;">
                            <div style="font-size: 12px; color: #86868b; line-height: 1.3; font-weight: normal;">
                                <div style="margin-bottom:2px; color: #1d1d1f;">${spec.name}</div>
                                <div style="margin-bottom:2px;">${spec.dim} (per panel)</div>
                                <div>${spec.weight} (per panel)</div>
                            </div>
                            <button type="button" class="btn-action info-trigger-btn" ${modalTriggerAttr} style="background:none; border:none; padding:4px; cursor:pointer; color:#a1a1a6; flex-shrink: 0; transition: 0.2s;">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>
                                ${tooltipHtml}
                            </button>
                        </div>
                    `;
                }

                optionsHtml += `
                    <div class="inline-option-item btn-action ${isSelected ? 'selected' : ''}" data-action="select-pv-inline" data-index="${index}">
                        <img src="${dbInfo.pic}" class="inline-item-img">
                        <div class="inline-item-info" style="min-width:0; width:100%;">
                            <div class="inline-item-title">${dbInfo.title} ${tagHtml}</div>
                            <div style="display:flex; align-items:center; justify-content:space-between; margin-top: 4px;">
                                <div class="inline-item-price">${dbInfo.price} ${qtyHtml}</div>
                            </div>
                            ${specsHtmlInline}
                        </div>
                    </div>
                `;
            });

            const containerClass = isPvOptionsOpen ? "pv-options-container open" : "pv-options-container";
            const btnText = isPvOptionsOpen ? 
                `Show Less Options <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg>` : 
                `Show More Options <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>`;

            return `
                <div class="${catClass}" style="display: flex; flex-direction: column; border-bottom: none; margin-bottom: 12px;">
                    <div style="display: flex; justify-content: space-between; align-items: baseline;">
                        <span>Solar Panels (PV) <span style="font-size: 16px; color: #86868b; font-weight: 500; margin-left: 4px;">(${currentPvOptions.length} Options)</span></span>
                    </div>
                    <p style="font-size: 14px; color: #86868b; font-weight: 400; margin: 8px 0 0 0; line-height: 1.4;">Based on your selection, we recommend about <strong style="color: #1d1d1f;">${wattText}</strong> of solar power. Choose the right option and panel quantity based on your space and actual conditions.</p>
                </div>
                <div id="dynamic-pv-container" style="animation: ac-fadeIn 0.4s ease;">
                    ${renderComponentCard(selectedOpt, 'Solar Panels (PV)', isSubItem, true, sysVoltage)}
                    <div style="text-align: center; margin-top: 8px; margin-bottom: 16px;">
                        <button type="button" id="pv-toggle-btn" class="toggle-text-btn btn-action" data-action="toggle-pv-options">${btnText}</button>
                    </div>
                    <div id="pv-inline-options" class="${containerClass}" style="margin-top: 8px; margin-left: 0; padding-left: 0; border-left: none;">
                        ${optionsHtml}
                    </div>
                </div>
            `;
        } else {
            currentPvOptions = []; 
            currentPvOptionIndex = 0; 
            isPvOptionsOpen = false; 
            return renderComponentCard(pvData.options[0], 'Solar Panels (PV)', isSubItem, false, sysVoltage);
        }
    };

    function renderInstallSurvey() {
        const el = document.getElementById('rec-survey');
        if (!el) return;

        if (installSurveyState.step === 'done') {
            el.innerHTML = `
                <div class="install-survey-card install-survey-done">
                    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>
                    <p>Thanks for the feedback</p>
                </div>
            `;
        } else {
            el.innerHTML = `
                <div class="install-survey-card">
                    <div class="install-survey-copy">
                        <span class="install-survey-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m14.7 6.3 3 3L19 8a2.1 2.1 0 0 0-3-3l-1.3 1.3Z"></path><path d="M9.6 11.4 4 17v3h3l5.6-5.6"></path><path d="m12.4 8.6 3 3"></path></svg>
                        </span>
                        <div>
                            <p class="install-survey-question">Would you be interested in professional installation?</p>
                            <p class="install-survey-sub">We're exploring an install service and your answer helps us plan it — booking isn't available yet.</p>
                        </div>
                    </div>
                    <div class="install-survey-options">
                        <button type="button" class="install-survey-btn is-yes btn-action" data-action="install-interest" data-value="yes">Yes, for a fee</button>
                        <button type="button" class="install-survey-btn is-no btn-action" data-action="install-interest" data-value="no">No, I'll do it myself</button>
                    </div>
                </div>
            `;
        }
    }

    function generateRecommendation(keepIndex = false) {
        document.getElementById('mobile-sheet-backdrop').classList.remove('show');
        
        const scenario = document.querySelector('input[name="main_scenario"]:checked').value; 
        const subType = document.querySelector('input[name="sub_type"]:checked').value; 
        
        const wrapper = document.getElementById('rec-wrapper'); 
        const actionRow = document.getElementById('rec-action-row');
        const backTarget = window.innerWidth <= 768 ? 'usage1' : 'usage2';

        if (!keepIndex) {
            currentPvOptionIndex = 0;
            isPvOptionsOpen = false;
            installSurveyState = { step: 'ask', choice: null };
        }

        const rec = calculateRecommendation(totalWh, peakPowerW, scenario, subType);

        if (rec.error) {
            latestPlanSnapshot = null;
            const surveyEl = document.getElementById('rec-survey');
            if (surveyEl) surveyEl.innerHTML = '';
            wrapper.innerHTML = `
                <div class="rec-header empty-state">
                    <h2>Your energy needs are unique, so a standard system won't do.</h2>
                    <p>Contact our experts for a personalized plan. </p>
                </div>
                <img src="${IMG_EMPTY_STATE}" style="width:100%; height:auto; border-radius: 16px; object-fit: contain; background: #fff; box-shadow: 0 4px 30px rgba(0,0,0,0.03); margin-bottom: 24px;" alt="No Solutions Found">
            `;
            actionRow.innerHTML = `
                <div class="recommendation-plan-actions">
                    <button type="button" class="recommendation-back-btn btn-nav" data-target="${backTarget}">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></svg> Back
                    </button>
                    <button type="button" class="btn-primary btn-action" data-action="open-modal">Talk to an Expert</button>
                </div>
            `;
            return;
        }

        latestPlanSnapshot = createPlanSnapshot(rec, scenario, subType);

        let warningBanner = '';
        if (rec.inverter && rec.inverter.warning) {
            warningBanner = `
                <div class="warning-banner">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                    <p>${rec.inverter.warning}</p>
                </div>
            `;
        }

        let productsHtml = warningBanner;

        if (rec.type === 'kit') {
            let titles = rec.titles || [];
            titles.forEach(t => {
                const dbInfo = getDBInfo(t);
                productsHtml += `
                    <div class="rec-category">Recommended Kit</div>
                    <div class="rec-card" onclick="window.open('${dbInfo.url}', '_blank')" style="border: 2px solid #003399; cursor: pointer; position: relative;">
                        <img src="${dbInfo.pic}" class="rec-img">
                        <div class="rec-info" style="width:100%;">
                            <span class="rec-bestseller" style="display: none;">Best Seller</span>
                            <h4 class="rec-title" style="margin: 0 0 4px 0;">${dbInfo.title}</h4>
                            <div class="rec-price-row">
                                <span class="rec-price">${dbInfo.price}</span>
                            </div>
                        </div>
                        <span class="rec-arrow">›</span>
                    </div>
                `;
            });
            productsHtml += `
                <div style="margin-top: 32px; padding: 24px; background: #fbfbfd; border-radius: 16px;">
                    <h3 style="font-size: 20px; margin: 0 0 16px 0; color: #1d1d1f; font-weight: 600;">What's included in the kit</h3>
            `;
            productsHtml += generatePvHtml(rec.pv, true, rec.sysVoltage);
            productsHtml += renderComponentCard(rec.controller, 'Charge Controller', true, false, rec.sysVoltage);
            productsHtml += renderComponentCard(rec.battery, 'Battery', true, false, rec.sysVoltage);
            // 新代码：使用了可选链 (?.) 和默认值 (|| '-')
            productsHtml += renderComponentCard({id: rec.inverter?.id || '-', qty: 1}, 'Inverter', true, false, rec.sysVoltage);
            productsHtml += renderComponentCard(rec.other, 'Other Components', true, false, rec.sysVoltage);
            productsHtml += `</div>`;
        } else {
            productsHtml += generatePvHtml(rec.pv, false, rec.sysVoltage);
            productsHtml += renderComponentCard(rec.controller, 'Charge Controller', false, false, rec.sysVoltage);
            productsHtml += renderComponentCard(rec.battery, 'Battery', false, false, rec.sysVoltage);
            productsHtml += renderComponentCard({id: rec.inverter.id, qty: 1}, 'Inverter', false, false, rec.sysVoltage);
            productsHtml += renderComponentCard(rec.other, 'Other Components', false, false, rec.sysVoltage);
        }

        wrapper.innerHTML = `
            <div class="rec-header">
                <h2>Best Recommended Solutions</h2>
                <p>Add the best recommended solutions to the cart.</p>
            </div>
            ${productsHtml}
        `;
        
        actionRow.innerHTML = `
            <button type="button" class="btn-primary recommendation-cart-btn btn-action" data-action="add-all-to-cart" aria-describedby="recommendation-action-status">
                <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h2l2.4 12.1a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 2-1.6L21 7H6"></path><circle cx="10" cy="20" r="1"></circle><circle cx="18" cy="20" r="1"></circle></svg>
                Add Solution to Cart
            </button>
            <div class="recommendation-plan-actions">
                <button type="button" class="recommendation-back-btn btn-nav" data-target="${backTarget}">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></svg> Back
                </button>
                <button type="button" class="btn-secondary recommendation-export-btn btn-action" data-action="export-plan" aria-describedby="recommendation-action-status">
                    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"></path><path d="m7 10 5 5 5-5"></path><path d="M5 21h14"></path></svg>
                    Export Plan
                </button>
                <button type="button" class="btn-secondary btn-action" data-action="open-modal">Talk to an Expert</button>
            </div>
            <p id="recommendation-action-status" class="recommendation-action-status" role="status" aria-live="polite"></p>
        `;
        renderInstallSurvey();
    }
})();
